// Lesson 1 - Microbiology
// 11 topics covering bacteriology, virology, immunology, and oral microbiology

export const questions = {
  "1. Basic Bacteriology": [
    {
      id: 70001,
      question: "Which of the following is NOT one of the five major groups of microorganisms?",
      options: [
        "Algae",
        "Viruses",
        "Archaea",
        "Fungi",
      ],
      correct: "C"
    },
    {
      id: 70002,
      question: "Algae and protozoa are included in which kingdom?",
      options: [
        "Protists",
        "Animalia",
        "Plantae",
        "Monera",
      ],
      correct: "A"
    },
    {
      id: 70003,
      question: "What distinguishes protists from plants and animals?",
      options: [
        "Cell wall composition",
        "Multicellularity",
        "Presence of nucleus",
        "Metabolic pathways",
      ],
      correct: "B"
    },
    {
      id: 70004,
      question: "Which organisms are not typically considered as microorganisms to some extent?",
      options: [
        "Bacteria",
        "Fungi",
        "Protozoa",
        "Viruses",
      ],
      correct: "D"
    },
    {
      id: 70005,
      question: "How many main differences are listed between prokaryotes and eukaryotes?",
      options: [
        "Six",
        "Seven",
        "Eight",
        "Nine",
      ],
      correct: "C"
    },
    {
      id: 70006,
      question: "Which of the following is NOT a difference between prokaryotes and eukaryotes?",
      options: [
        "Flagella composition",
        "Genetic material",
        "Introns",
        "Ribosomes",
      ],
      correct: "A"
    },
    {
      id: 70007,
      question: "What type of chromosome do prokaryotes possess?",
      options: [
        "Multiple linear chromosomes",
        "Single, supercoiled circular chromosome",
        "Multiple circular chromosomes",
        "Single linear chromosome",
      ],
      correct: "B"
    },
    {
      id: 70008,
      question: "Where does cellular respiration occur in prokaryotes?",
      options: [
        "Mitochondria",
        "Nucleus",
        "Golgi apparatus",
        "Cell membrane",
      ],
      correct: "D"
    },
    {
      id: 70009,
      question: "Where does cellular respiration occur in eukaryotes?",
      options: [
        "Cell membrane",
        "Ribosomes",
        "Mitochondrion",
        "Endoplasmic reticulum",
      ],
      correct: "C"
    },
    {
      id: 70010,
      question: "What are extrachromosomal genetic elements in bacteria called?",
      options: [
        "Plasmids",
        "Introns",
        "Lysosomes",
        "Mesosomes",
      ],
      correct: "A"
    },
    {
      id: 70011,
      question: "Which organelle is found in eukaryotes but NOT in prokaryotes?",
      options: [
        "Ribosomes",
        "Lysosome",
        "Cell membrane",
        "Cytoplasm",
      ],
      correct: "B"
    },
    {
      id: 70012,
      question: "What is the main component of the prokaryotic cell wall?",
      options: [
        "Cellulose",
        "Chitin",
        "Phospholipid",
        "Peptidoglycan",
      ],
      correct: "D"
    },
    {
      id: 70013,
      question: "How many different groups are bacteria categorized into based on their shapes?",
      options: [
        "Two",
        "Three",
        "Four",
        "Five",
      ],
      correct: "B"
    },
    {
      id: 70014,
      question: "Which of the following is a bacterial shape category?",
      options: [
        "Cocci",
        "Filamentous",
        "Cuboid",
        "Triangular",
      ],
      correct: "A"
    },
    {
      id: 70015,
      question: "What term describes rod-shaped bacteria?",
      options: [
        "Cocci",
        "Spirochetes",
        "Bacilli",
        "Pleomorphic",
      ],
      correct: "C"
    },
    {
      id: 70016,
      question: "What term describes bacteria that can vary in shape?",
      options: [
        "Cocci",
        "Bacilli",
        "Spirochetes",
        "Pleomorphic",
      ],
      correct: "D"
    },
    {
      id: 70017,
      question: "In what arrangements can bacteria be found?",
      options: [
        "Only in chains",
        "Only as singles",
        "Clusters, chains, pairs, and singles",
        "Only in pairs",
      ],
      correct: "C"
    },
    {
      id: 70018,
      question: "Which type of bacteria is more resistant to penicillin?",
      options: [
        "Gram-negative bacteria",
        "Gram-positive bacteria",
        "Both are equally resistant",
        "Neither is resistant",
      ],
      correct: "A"
    },
    {
      id: 70019,
      question: "What are bacterial flagella composed of?",
      options: [
        "Pilin",
        "Flagellin",
        "Peptidoglycan",
        "Polysaccharide",
      ],
      correct: "B"
    },
    {
      id: 70020,
      question: "What is the primary function of flagella in bacteria?",
      options: [
        "Adhesion to host cells",
        "Gene transfer",
        "Vaccine production",
        "Mediating bacterial movements",
      ],
      correct: "D"
    },
    {
      id: 70021,
      question: "What term describes bacteria with flagella distributed around the entire cell?",
      options: [
        "Peritrichous",
        "Monotrichous",
        "Lophotrichous",
        "Atrichous",
      ],
      correct: "A"
    },
    {
      id: 70022,
      question: "What do spirochetes have instead of typical flagella?",
      options: [
        "Pili",
        "Axial filaments",
        "Fimbriae",
        "Capsules",
      ],
      correct: "B"
    },
    {
      id: 70023,
      question: "What are pili (fimbriae) composed of?",
      options: [
        "Flagellin",
        "Polysaccharide",
        "Pilin",
        "Peptidoglycan",
      ],
      correct: "C"
    },
    {
      id: 70024,
      question: "What is the function of pili in bacteria?",
      options: [
        "Movement only",
        "Protection from phagocytosis only",
        "Energy production",
        "Adhesion to host cells and gene transfer",
      ],
      correct: "D"
    },
    {
      id: 70025,
      question: "What is the glycocalyx composed of?",
      options: [
        "Polysaccharide",
        "Protein",
        "Lipid",
        "Nucleic acid",
      ],
      correct: "A"
    },
    {
      id: 70026,
      question: "Which bacterium uses glycocalyx for attachment?",
      options: [
        "Escherichia coli",
        "Streptococcus mutans",
        "Staphylococcus aureus",
        "Bacillus anthracis",
      ],
      correct: "B"
    },
    {
      id: 70027,
      question: "Which structure is more complex than glycocalyx?",
      options: [
        "Pili",
        "Flagella",
        "Capsule",
        "Fimbriae",
      ],
      correct: "C"
    },
    {
      id: 70028,
      question: "Which of the following is NOT a function of the bacterial capsule?",
      options: [
        "Adhesion",
        "Phagocytosis resistance",
        "Vaccine production",
        "Energy production",
      ],
      correct: "D"
    },
    {
      id: 70029,
      question: "What is the main component of the gram-positive bacterial cell wall?",
      options: [
        "Lipopolysaccharide",
        "Thick peptidoglycan",
        "Lipoprotein",
        "Phospholipid",
      ],
      correct: "B"
    },
    {
      id: 70030,
      question: "Which component is found in gram-negative but NOT gram-positive cell walls?",
      options: [
        "Peptidoglycan",
        "Cytoplasmic membrane",
        "Lipopolysaccharide",
        "Ribosomes",
      ],
      correct: "C"
    },
    {
      id: 70031,
      question: "What does LPS stand for?",
      options: [
        "Lipoprotein structure",
        "Lysophospholipid substrate",
        "Linear polysaccharide",
        "Lipopolysaccharide",
      ],
      correct: "D"
    },
    {
      id: 70032,
      question: "LPS has which two properties?",
      options: [
        "Toxic and antigenic",
        "Nutritive and structural",
        "Protective and metabolic",
        "Genetic and enzymatic",
      ],
      correct: "A"
    },
    {
      id: 70033,
      question: "Which type of bacteria have defective cell walls and cause pneumonia?",
      options: [
        "Spheroplasts",
        "Protoplasts",
        "L-forms",
        "Mycoplasmas",
      ],
      correct: "D"
    },
    {
      id: 70034,
      question: "How many types of bacteria have defective cell walls?",
      options: [
        "Four",
        "Two",
        "Three",
        "Five",
      ],
      correct: "A"
    },
    {
      id: 70035,
      question: "L-forms are produced in which conditions?",
      options: [
        "Only in natural environments",
        "In the lab or in penicillin-treated patients",
        "Only in gram-positive bacteria",
        "Only in anaerobic conditions",
      ],
      correct: "B"
    },
    {
      id: 70036,
      question: "Spheroplasts are derived from which type of bacteria?",
      options: [
        "Gram-positive bacteria",
        "Both types equally",
        "Gram-negative bacteria",
        "Mycoplasmas",
      ],
      correct: "C"
    },
    {
      id: 70037,
      question: "Protoplasts are derived from which type of bacteria?",
      options: [
        "Gram-negative bacteria",
        "Gram-positive bacteria",
        "Mycoplasmas",
        "L-forms",
      ],
      correct: "B"
    },
    {
      id: 70038,
      question: "Which bacteria with defective cell walls are more sensitive and unstable?",
      options: [
        "Mycoplasmas only",
        "L-forms only",
        "All four types equally",
        "Spheroplasts and protoplasts",
      ],
      correct: "D"
    },
    {
      id: 70039,
      question: "Which characteristic is true of spheroplasts and protoplasts?",
      options: [
        "They are unable to replicate",
        "They can replicate normally",
        "They are more resistant than normal cells",
        "They have enhanced cell walls",
      ],
      correct: "A"
    },
    {
      id: 70040,
      question: "What component is absent in bacterial cell membranes but present in eukaryotic membranes?",
      options: [
        "Phospholipids",
        "Proteins",
        "Sterols",
        "Fatty acids",
      ],
      correct: "C"
    },
    {
      id: 70041,
      question: "Which bacteria are exceptions and DO contain sterols in their membrane?",
      options: [
        "Bacillus",
        "Clostridium",
        "Streptococcus",
        "Mycoplasmas",
      ],
      correct: "D"
    },
    {
      id: 70042,
      question: "What is NOT a function of the bacterial cell membrane?",
      options: [
        "Selective diffusion of molecules",
        "DNA replication",
        "Aerobic respiration",
        "Synthesis of cell wall precursors",
      ],
      correct: "B"
    },
    {
      id: 70043,
      question: "Which function does the cell membrane perform?",
      options: [
        "Secretion of enzymes and toxins",
        "Protein synthesis",
        "Chromosome replication",
        "Spore formation",
      ],
      correct: "A"
    },
    {
      id: 70044,
      question: "What are the invaginations of the inner membrane called?",
      options: [
        "Lysosomes",
        "Mesosomes",
        "Ribosomes",
        "Peroxisomes",
      ],
      correct: "B"
    },
    {
      id: 70045,
      question: "What is the main function of mesosomes?",
      options: [
        "Protein synthesis",
        "Energy storage",
        "Cell division",
        "Waste removal",
      ],
      correct: "C"
    },
    {
      id: 70046,
      question: "What structures are found in bacterial cytoplasm?",
      options: [
        "Mitochondria and nucleus",
        "Golgi apparatus and lysosomes",
        "Endoplasmic reticulum and vacuoles",
        "Ribosomes, genetic material, and inclusions",
      ],
      correct: "D"
    },
    {
      id: 70047,
      question: "What type of genetic material is found in bacterial cytoplasm?",
      options: [
        "Single, circular chromosome",
        "Multiple linear chromosomes",
        "Paired chromosomes",
        "No genetic material",
      ],
      correct: "A"
    },
    {
      id: 70048,
      question: "When are bacterial spores formed?",
      options: [
        "During rapid growth",
        "In response to unfavorable conditions",
        "During conjugation",
        "After binary fission",
      ],
      correct: "B"
    },
    {
      id: 70049,
      question: "Which of the following is NOT a component of bacterial spores?",
      options: [
        "DNA",
        "Cytoplasm",
        "Mitochondria",
        "Thick coat",
      ],
      correct: "C"
    },
    {
      id: 70050,
      question: "Which two genera are known for spore formation?",
      options: [
        "Bacillus and Clostridium",
        "Streptococcus and Staphylococcus",
        "Escherichia and Salmonella",
        "Mycobacterium and Mycoplasma",
      ],
      correct: "A"
    },
    {
      id: 70051,
      question: "What are the possible locations of spores within bacteria?",
      options: [
        "External only",
        "Central, terminal, or subterminal",
        "Nuclear only",
        "Cytoplasmic only",
      ],
      correct: "B"
    },
    {
      id: 70052,
      question: "Which term describes a spore located near but not at the end of the cell?",
      options: [
        "Central",
        "Terminal",
        "Peripheral",
        "Subterminal",
      ],
      correct: "D"
    },
    {
      id: 70053,
      question: "What is the term for organisms that obtain energy from organic compounds?",
      options: [
        "Heterotroph",
        "Autotroph",
        "Lithotroph",
        "Phototroph",
      ],
      correct: "A"
    },
    {
      id: 70054,
      question: "What is binary fission?",
      options: [
        "Sexual reproduction in bacteria",
        "Asexual reproduction where one cell divides into two",
        "Spore formation",
        "Gene transfer between bacteria",
      ],
      correct: "B"
    },
    {
      id: 70055,
      question: "What is a facultative anaerobe?",
      options: [
        "An organism that can only grow with oxygen",
        "An organism that can only grow without oxygen",
        "An organism that can grow with or without oxygen",
        "An organism that requires carbon dioxide",
      ],
      correct: "C"
    },
    {
      id: 70056,
      question: "What is conjugation in bacteria?",
      options: [
        "Spore formation",
        "Cell division",
        "Capsule formation",
        "Transfer of genetic material between bacteria",
      ],
      correct: "D"
    },
    {
      id: 70057,
      question: "What is a mutation?",
      options: [
        "A change in the genetic material",
        "Transfer of plasmids",
        "Binary fission",
        "Spore germination",
      ],
      correct: "A"
    },
    {
      id: 70058,
      question: "Which structure facilitates gene transfer between bacteria?",
      options: [
        "Flagella",
        "Pili",
        "Capsule",
        "Glycocalyx",
      ],
      correct: "B"
    },
    {
      id: 70059,
      question: "What structure contains bacterial receptors?",
      options: [
        "Capsule",
        "Cell wall",
        "Cytoplasm",
        "Cell membrane",
      ],
      correct: "D"
    },
    {
      id: 70060,
      question: "The periplasmic space is found in which type of bacteria?",
      options: [
        "Gram-negative only",
        "Gram-positive only",
        "Both types",
        "Neither type",
      ],
      correct: "A"
    },
    {
      id: 70061,
      question: "What is the outer membrane a characteristic of?",
      options: [
        "Gram-positive bacteria",
        "Gram-negative bacteria",
        "All bacteria",
        "Eukaryotic cells only",
      ],
      correct: "B"
    },
    {
      id: 70062,
      question: "Which structure is thicker in gram-positive bacteria compared to gram-negative?",
      options: [
        "Outer membrane",
        "Periplasmic space",
        "Peptidoglycan layer",
        "Lipoprotein layer",
      ],
      correct: "C"
    },
    {
      id: 70063,
      question: "What is the nucleoid?",
      options: [
        "A membrane-bound nucleus",
        "A type of ribosome",
        "An inclusion body",
        "The region containing bacterial DNA",
      ],
      correct: "D"
    },
    {
      id: 70064,
      question: "Which component connects the outer membrane to peptidoglycan in gram-negative bacteria?",
      options: [
        "Lipoprotein",
        "Phospholipid",
        "LPS",
        "Capsule",
      ],
      correct: "A"
    },
    {
      id: 70065,
      question: "Which of the following is a key term related to bacterial genetics?",
      options: [
        "Photosynthesis",
        "Autotroph",
        "Mutation",
        "Chemolithotroph",
      ],
      correct: "C"
    },
    {
      id: 70066,
      question: "What is the ribosome size in prokaryotes?",
      options: [
        "80S",
        "60S",
        "40S",
        "70S",
      ],
      correct: "D"
    },
    {
      id: 70067,
      question: "What is the ribosome size in eukaryotes?",
      options: [
        "80S",
        "70S",
        "60S",
        "50S",
      ],
      correct: "A"
    },
    {
      id: 70068,
      question: "Which kingdom includes algae?",
      options: [
        "Fungi",
        "Protists",
        "Bacteria",
        "Archaea",
      ],
      correct: "B"
    },
    {
      id: 70069,
      question: "What mediates the attachment of Streptococcus mutans?",
      options: [
        "Capsule",
        "Pili",
        "Flagella",
        "Glycocalyx",
      ],
      correct: "D"
    },
    {
      id: 70070,
      question: "Which statement about bacterial cell membranes is correct?",
      options: [
        "They contain sterols like eukaryotes",
        "They contain a phospholipid bilayer with proteins",
        "They lack phospholipids",
        "They are identical to eukaryotic membranes",
      ],
      correct: "B"
    },
    {
      id: 70071,
      question: "What is produced during aerobic respiration in the cell membrane?",
      options: [
        "Proteins",
        "DNA",
        "Peptidoglycan",
        "ATP/Energy",
      ],
      correct: "D"
    },
    {
      id: 70072,
      question: "Which of the following can cross the cell membrane through selective diffusion?",
      options: [
        "Various molecules selectively",
        "Only large proteins",
        "Nothing can cross",
        "Only water",
      ],
      correct: "A"
    },
    {
      id: 70073,
      question: "Which structure is NOT found in a typical bacterial cell?",
      options: [
        "Ribosomes",
        "Cell membrane",
        "Nucleus with nuclear membrane",
        "Cytoplasm",
      ],
      correct: "C"
    },
    {
      id: 70074,
      question: "What is the function of bacterial ribosomes?",
      options: [
        "Energy production",
        "DNA replication",
        "Cell wall synthesis",
        "Protein synthesis",
      ],
      correct: "D"
    },
    {
      id: 70075,
      question: "Inclusions in bacterial cytoplasm serve what purpose?",
      options: [
        "Storage of nutrients or waste",
        "Protein synthesis",
        "DNA replication",
        "Cell division",
      ],
      correct: "A"
    },
    {
      id: 70076,
      question: "Which bacterium from the genus Bacillus is known for causing anthrax?",
      options: [
        "Bacillus subtilis",
        "Bacillus cereus",
        "Bacillus anthracis",
        "Bacillus thuringiensis",
      ],
      correct: "C"
    },
    {
      id: 70077,
      question: "What allows gram-negative bacteria to be more resistant to certain antibiotics?",
      options: [
        "Outer membrane with LPS",
        "Thick peptidoglycan",
        "Absence of cell wall",
        "Presence of sterols",
      ],
      correct: "A"
    },
    {
      id: 70078,
      question: "Which of the following is an example of a spirochete-caused disease?",
      options: [
        "Strep throat",
        "Tuberculosis",
        "Lyme disease",
        "Pneumonia",
      ],
      correct: "C"
    },
    {
      id: 70079,
      question: "Why are gram-positive bacteria more susceptible to penicillin?",
      options: [
        "They have a thick, exposed peptidoglycan layer",
        "They lack a cell membrane",
        "They have no peptidoglycan",
        "They have an outer membrane",
      ],
      correct: "A"
    },
    {
      id: 70080,
      question: "Which structure is responsible for incorporating bacterial receptors?",
      options: [
        "Capsule",
        "Cell membrane",
        "Cell wall",
        "Flagella",
      ],
      correct: "B"
    },
    {
      id: 70081,
      question: "What is the primary difference between glycocalyx and capsule?",
      options: [
        "Glycocalyx is made of protein",
        "Capsule is simpler than glycocalyx",
        "Capsule is more complex than glycocalyx",
        "They are identical structures",
      ],
      correct: "C"
    },
    {
      id: 70082,
      question: "Which of the following is NOT a function attributed to pili?",
      options: [
        "Adhesion to host cells",
        "Gene transfer",
        "Bacterial movement",
        "Conjugation",
      ],
      correct: "C"
    },
    {
      id: 70083,
      question: "Bacteria are classified using how many main approaches to taxonomy?",
      options: [
        "One",
        "Two",
        "Three",
        "Four",
      ],
      correct: "B"
    },
    {
      id: 70084,
      question: "Which of the following is NOT a criterion used in phenotypic taxonomy?",
      options: [
        "Morphology",
        "Antigenic characteristics",
        "DNA homology",
        "Biochemical reactions",
      ],
      correct: "C"
    },
    {
      id: 70085,
      question: "Which criterion is used in phenotypic taxonomy?",
      options: [
        "Staining features",
        "DNA sequencing",
        "Gene comparison",
        "DNA homology",
      ],
      correct: "A"
    },
    {
      id: 70086,
      question: "What is highly necessary for bacterial growth?",
      options: [
        "Salt",
        "Water",
        "Alcohol",
        "Oil",
      ],
      correct: "B"
    },
    {
      id: 70087,
      question: "Oxygen is essential for which type of bacteria?",
      options: [
        "Anaerobic bacteria",
        "All bacteria equally",
        "Aerobic bacteria",
        "No bacteria",
      ],
      correct: "C"
    },
    {
      id: 70088,
      question: "Based on carbon consumption, bacteria fall into how many categories?",
      options: [
        "Two",
        "Three",
        "Four",
        "Five",
      ],
      correct: "A"
    },
    {
      id: 70089,
      question: "Which of the following is essential for most bacterial species?",
      options: [
        "Alcohol",
        "Ethanol",
        "Acetone",
        "Inorganic ions",
      ],
      correct: "D"
    },
    {
      id: 70090,
      question: "How do bacteria reproduce?",
      options: [
        "Binary fission",
        "Sexual reproduction",
        "Budding",
        "Fragmentation",
      ],
      correct: "A"
    },
    {
      id: 70091,
      question: "What is the formula for bacterial population growth?",
      options: [
        "BT = BO + 2n",
        "BT = BO x 2n",
        "BT = BO / 2n",
        "BT = BO - 2n",
      ],
      correct: "B"
    },
    {
      id: 70092,
      question: "How many main phases are in the bacterial growth cycle?",
      options: [
        "Two",
        "Three",
        "Four",
        "Five",
      ],
      correct: "C"
    },
    {
      id: 70093,
      question: "Which phase comes first in the bacterial growth cycle?",
      options: [
        "Lag",
        "Log",
        "Stationary",
        "Decline",
      ],
      correct: "A"
    },
    {
      id: 70094,
      question: "During which phase do bacteria multiply most rapidly?",
      options: [
        "Lag",
        "Log",
        "Stationary",
        "Decline",
      ],
      correct: "B"
    },
    {
      id: 70095,
      question: "What is the correct order of the bacterial growth cycle phases?",
      options: [
        "Log, Lag, Stationary, Decline",
        "Stationary, Lag, Log, Decline",
        "Decline, Stationary, Log, Lag",
        "Lag, Log, Stationary, Decline",
      ],
      correct: "D"
    },
    {
      id: 70096,
      question: "In the stationary phase, what happens to bacterial population?",
      options: [
        "Remains relatively constant",
        "Rapid increase",
        "Rapid decrease",
        "Complete death",
      ],
      correct: "A"
    },
    {
      id: 70097,
      question: "Which graph axis shows \"Log count\" in a bacterial growth curve?",
      options: [
        "X-axis",
        "Y-axis",
        "Z-axis",
        "Neither axis",
      ],
      correct: "B"
    },
    {
      id: 70098,
      question: "Temperature is classified as what type of factor for bacterial growth?",
      options: [
        "Internal factor",
        "Genetic factor",
        "External factor",
        "Nutritional factor",
      ],
      correct: "C"
    },
    {
      id: 70099,
      question: "Which bacteria absolutely require oxygen for growth?",
      options: [
        "Obligate aerobes",
        "Strict anaerobes",
        "Facultative anaerobes",
        "Microaerophiles",
      ],
      correct: "A"
    },
    {
      id: 70100,
      question: "Which bacteria cannot survive in the presence of oxygen?",
      options: [
        "Obligate aerobes",
        "Strict anaerobes",
        "Facultative anaerobes",
        "Capnophiles",
      ],
      correct: "B"
    },
    {
      id: 70101,
      question: "Which bacteria can grow with or without oxygen?",
      options: [
        "Obligate aerobes",
        "Strict anaerobes",
        "Facultative anaerobes",
        "Microaerophiles",
      ],
      correct: "C"
    },
    {
      id: 70102,
      question: "Which bacteria require low levels of oxygen?",
      options: [
        "Obligate aerobes",
        "Strict anaerobes",
        "Capnophiles",
        "Microaerophiles",
      ],
      correct: "D"
    },
    {
      id: 70103,
      question: "Bacteria have what type of DNA structure?",
      options: [
        "Multiple linear chromosomes",
        "Single, circular DNA",
        "Multiple circular chromosomes",
        "Single linear DNA",
      ],
      correct: "B"
    },
    {
      id: 70104,
      question: "What does cccDNA stand for in relation to bacterial DNA?",
      options: [
        "Completely coded circular DNA",
        "Chemically combined circular DNA",
        "Covalently closed circular DNA",
        "Centrally condensed circular DNA",
      ],
      correct: "C"
    },
    {
      id: 70105,
      question: "The bacterial chromosome is partially attached to which structure?",
      options: [
        "Cell wall",
        "Ribosome",
        "Capsule",
        "Cell membrane",
      ],
      correct: "D"
    },
    {
      id: 70106,
      question: "What is the specific site on the chromosome where replication begins called?",
      options: [
        "oriC",
        "Terminus",
        "Codon",
        "Gene",
      ],
      correct: "A"
    },
    {
      id: 70107,
      question: "What happens at oriC during replication?",
      options: [
        "The chromosome condenses",
        "The DNA is denatured to form a replication fork",
        "Translation begins",
        "The cell divides",
      ],
      correct: "B"
    },
    {
      id: 70108,
      question: "During replication, the replication forks move in which directions?",
      options: [
        "Same direction",
        "Random directions",
        "Opposite directions",
        "Only clockwise",
      ],
      correct: "C"
    },
    {
      id: 70109,
      question: "What type of replication occurs in bacteria?",
      options: [
        "Conservative replication",
        "Dispersive replication",
        "Distributive replication",
        "Semiconservative replication",
      ],
      correct: "D"
    },
    {
      id: 70110,
      question: "What is the most important enzyme for DNA replication?",
      options: [
        "DNA polymerase",
        "RNA polymerase",
        "Ligase",
        "Helicase",
      ],
      correct: "A"
    },
    {
      id: 70111,
      question: "What are the structural units of genes?",
      options: [
        "Amino acids",
        "Proteins",
        "Codons",
        "Nucleotides",
      ],
      correct: "D"
    },
    {
      id: 70112,
      question: "Bacteria are described as what type of organisms regarding their chromosome number?",
      options: [
        "Haploid",
        "Diploid",
        "Polyploid",
        "Triploid",
      ],
      correct: "A"
    },
    {
      id: 70113,
      question: "A codon consists of how many nucleotides?",
      options: [
        "One",
        "Two",
        "Three",
        "Four",
      ],
      correct: "C"
    },
    {
      id: 70114,
      question: "What does a codon code for?",
      options: [
        "A gene",
        "A specific amino acid",
        "A chromosome",
        "A protein",
      ],
      correct: "B"
    },
    {
      id: 70115,
      question: "How many main types of mutations are described?",
      options: [
        "Two",
        "Three",
        "Four",
        "Five",
      ],
      correct: "A"
    },
    {
      id: 70116,
      question: "Which of the following is a type of mutation?",
      options: [
        "Conjugation",
        "Substitution",
        "Transduction",
        "Transformation",
      ],
      correct: "B"
    },
    {
      id: 70117,
      question: "Which type of mutation involves replacing one nucleotide with another?",
      options: [
        "Insertion",
        "Deletion",
        "Frame shift",
        "Substitution",
      ],
      correct: "D"
    },
    {
      id: 70118,
      question: "How many methods of gene transfer are described in bacteria?",
      options: [
        "Two",
        "Three",
        "Four",
        "Five",
      ],
      correct: "C"
    },
    {
      id: 70119,
      question: "Transformation involves what type of gene transfer?",
      options: [
        "Direct gene transfer",
        "Via bacteriophage",
        "Via F plasmid",
        "Via transposons",
      ],
      correct: "A"
    },
    {
      id: 70120,
      question: "What structure connects two bacteria during conjugation?",
      options: [
        "Flagellum",
        "Capsule",
        "Glycocalyx",
        "Pilus",
      ],
      correct: "D"
    },
    {
      id: 70121,
      question: "What happens to the bacterial cell during transduction?",
      options: [
        "Binary fission",
        "Cell lysis releases DNA fragments",
        "Direct DNA uptake",
        "Spore formation",
      ],
      correct: "B"
    },
    {
      id: 70122,
      question: "F plasmids are involved in which process?",
      options: [
        "Transduction",
        "Conjugation",
        "Transformation",
        "Transposition",
      ],
      correct: "B"
    },
    {
      id: 70123,
      question: "Plasmids can produce which of the following?",
      options: [
        "Colicin and other toxins",
        "Flagella",
        "Cell walls",
        "Ribosomes",
      ],
      correct: "A"
    },
    {
      id: 70124,
      question: "Can transposons replicate independently?",
      options: [
        "Yes, always",
        "Only in eukaryotes",
        "Only during conjugation",
        "No, they cannot",
      ],
      correct: "D"
    },
    {
      id: 70125,
      question: "Transposons can mediate which of the following?",
      options: [
        "Binary fission",
        "Drug resistance",
        "Cell membrane synthesis",
        "Ribosome production",
      ],
      correct: "B"
    },
    {
      id: 70126,
      question: "What can transposons carry genes for?",
      options: [
        "Antibiotic resistance",
        "Flagella synthesis",
        "Capsule formation",
        "Ribosome assembly",
      ],
      correct: "A"
    },
    {
      id: 70127,
      question: "During transcription, what is produced from DNA?",
      options: [
        "Protein",
        "RNA",
        "Lipid",
        "Carbohydrate",
      ],
      correct: "B"
    },
    {
      id: 70128,
      question: "During translation, what is produced from RNA?",
      options: [
        "DNA",
        "Lipid",
        "Amino acid sequence of protein",
        "Carbohydrate",
      ],
      correct: "C"
    },
    {
      id: 70129,
      question: "In a deletion mutation, what happens to amino acid sequence downstream?",
      options: [
        "Changes due to shifted reading frame",
        "Remains unchanged",
        "Is completely deleted",
        "Becomes duplicated",
      ],
      correct: "A"
    },
    {
      id: 70130,
      question: "What type of inheritance pattern do bacteria follow?",
      options: [
        "Diploid inheritance",
        "Haploid inheritance",
        "Mendelian inheritance",
        "Polyploid inheritance",
      ],
      correct: "B"
    },
    {
      id: 70131,
      question: "Which phase of the growth curve shows adaptation to the environment?",
      options: [
        "Log phase",
        "Stationary phase",
        "Decline phase",
        "Lag phase",
      ],
      correct: "D"
    },
    {
      id: 70132,
      question: "During the decline phase, what happens to viable cells?",
      options: [
        "They decrease",
        "They increase rapidly",
        "They remain constant",
        "They multiply exponentially",
      ],
      correct: "A"
    },
    {
      id: 70133,
      question: "Total cells and viable cells diverge during which phase?",
      options: [
        "Lag phase",
        "Stationary/Decline phase",
        "Log phase",
        "Only during lag phase",
      ],
      correct: "B"
    },
    {
      id: 70134,
      question: "Which factor is NOT listed as an external factor for bacterial growth?",
      options: [
        "Temperature",
        "pH",
        "Oxygen",
        "Plasmid content",
      ],
      correct: "D"
    },
    {
      id: 70135,
      question: "Bacteriophages are involved in which gene transfer mechanism?",
      options: [
        "Conjugation",
        "Transduction",
        "Transformation",
        "Transposition",
      ],
      correct: "B"
    },
    {
      id: 70136,
      question: "Daughter phages are produced in which process?",
      options: [
        "Conjugation",
        "Transformation",
        "Binary fission",
        "Transduction",
      ],
      correct: "D"
    },
    {
      id: 70137,
      question: "Phage DNA enters the bacterial cell during which process?",
      options: [
        "Conjugation",
        "Transformation",
        "Transposition",
        "Transduction",
      ],
      correct: "D"
    },
  ],
  "2. Basic Virology": [
    {
      id: 70100,
      question: "Viruses are approximately what size compared to bacteria?",
      options: [
        "1:10 of bacteria",
        "1:2 of bacteria",
        "Same size",
        "2x larger",
      ],
      correct: "A"
    },
    {
      id: 70101,
      question: "Which of the following can viruses infect?",
      options: [
        "Only animals",
        "Bacteria, plants, and animals",
        "Only plants",
        "Only bacteria",
      ],
      correct: "B"
    },
    {
      id: 70102,
      question: "Viral genomes can be which of the following?",
      options: [
        "DNA or RNA",
        "Only DNA",
        "Only RNA",
        "Both DNA and RNA simultaneously",
      ],
      correct: "A"
    },
    {
      id: 70103,
      question: "How many different polypeptide chains typically comprise the capsid?",
      options: [
        "1-3",
        "5-10",
        "10-20",
        "More than 20",
      ],
      correct: "A"
    },
    {
      id: 70104,
      question: "Which of the following is NOT a function of the capsid?",
      options: [
        "Protects genome",
        "Has tendency for cell receptors",
        "Produces ATP",
        "Could be antigenic determinants",
      ],
      correct: "C"
    },
    {
      id: 70105,
      question: "What percentage of envelope lipid is phospholipid?",
      options: [
        "10-20%",
        "50-60%",
        "30-40%",
        "70-80%",
      ],
      correct: "B"
    },
    {
      id: 70106,
      question: "Which viruses have icosahedral symmetry?",
      options: [
        "Orthomyxoviruses",
        "Paramyxoviruses",
        "Retroviruses",
        "Herpesviruses",
      ],
      correct: "D"
    },
    {
      id: 70107,
      question: "Which viruses have complex symmetry?",
      options: [
        "Poxviruses and retroviruses",
        "Herpesviruses and adenoviruses",
        "Papovaviruses and parvoviruses",
        "Picornaviruses and togaviruses",
      ],
      correct: "A"
    },
    {
      id: 70108,
      question: "Papovavirus is an acronym derived from how many different viruses?",
      options: [
        "2",
        "Three",
        "4",
        "5",
      ],
      correct: "B"
    },
    {
      id: 70109,
      question: "Which viruses make up the name \"Papovavirus\"?",
      options: [
        "Parvovirus, Poliovirus, and Varicella",
        "Paramyxovirus, Poxvirus, and VZV",
        "Papillomavirus, Polyomavirus, and Vacuolating agent SV40",
        "Papillomavirus, Poxvirus, and Variola",
      ],
      correct: "C"
    },
    {
      id: 70110,
      question: "Which are the largest animal viruses?",
      options: [
        "Picornaviruses",
        "Poxviruses",
        "Parvoviruses",
        "Papovaviruses",
      ],
      correct: "B"
    },
    {
      id: 70111,
      question: "Which disease caused by poxvirus has been eradicated?",
      options: [
        "Monkeypox",
        "Cowpox",
        "Smallpox",
        "Molluscum contagiosum",
      ],
      correct: "C"
    },
    {
      id: 70112,
      question: "How many serotypes do parvoviruses have?",
      options: [
        "Two",
        "Four",
        "Three",
        "Five",
      ],
      correct: "C"
    },
    {
      id: 70113,
      question: "Which of the following is NOT a herpesvirus?",
      options: [
        "Herpes simplex virus",
        "Varicella-zoster virus",
        "Rhinovirus",
        "Cytomegalovirus",
      ],
      correct: "C"
    },
    {
      id: 70114,
      question: "Which are the smallest RNA viruses?",
      options: [
        "Picornaviruses",
        "Orthomyxoviruses",
        "Paramyxoviruses",
        "Coronaviruses",
      ],
      correct: "A"
    },
    {
      id: 70115,
      question: "What does ECHO in echovirus stand for?",
      options: [
        "External, cellular, host, origin",
        "Encephalitic, chronic, human, oral",
        "Epithelial, cutaneous, host, oral",
        "Enteric, cytopathogenic, human, orphan",
      ],
      correct: "D"
    },
    {
      id: 70116,
      question: "SARS was transmitted from which animal to humans?",
      options: [
        "Dogs",
        "Pigs",
        "Birds",
        "Cats",
      ],
      correct: "D"
    },
    {
      id: 70117,
      question: "How many subfamilies of retroviruses are there?",
      options: [
        "Two",
        "Four",
        "Three",
        "Five",
      ],
      correct: "C"
    },
    {
      id: 70118,
      question: "HIV belongs to which subfamily of retroviruses?",
      options: [
        "Lentiviruses",
        "Spumaviruses",
        "Oncoviruses",
        "Paramyxoviruses",
      ],
      correct: "A"
    },
    {
      id: 70119,
      question: "HTLV-I and HTLV-II belong to which subfamily?",
      options: [
        "Lentiviruses",
        "Oncoviruses",
        "Spumaviruses",
        "Picornaviruses",
      ],
      correct: "B"
    },
    {
      id: 70120,
      question: "How many steps are in viral replication?",
      options: [
        "Five",
        "Six",
        "Eight",
        "Seven",
      ],
      correct: "D"
    },
    {
      id: 70121,
      question: "How many mechanisms exist for viral penetration?",
      options: [
        "Two",
        "Three",
        "Four",
        "Five",
      ],
      correct: "B"
    },
    {
      id: 70122,
      question: "During transcription, what is produced?",
      options: [
        "DNA",
        "Viral mRNA",
        "Proteins",
        "Lipids",
      ],
      correct: "B"
    },
    {
      id: 70123,
      question: "Prions initially replicate in which tissue before infecting the CNS?",
      options: [
        "Muscle tissue",
        "Epithelial tissue",
        "Bone tissue",
        "Lymphoid tissue",
      ],
      correct: "D"
    },
    {
      id: 70124,
      question: "PrPSc causes CNS cells to develop what appearance?",
      options: [
        "Crystalline",
        "Fibrous",
        "Spongiform",
        "Granular",
      ],
      correct: "C"
    },
    {
      id: 70125,
      question: "Creutzfeldt-Jakob disease (CJD) mostly occurs at what age?",
      options: [
        "10-20 years",
        "40-60 years",
        "20-30 years",
        "Over 70 years",
      ],
      correct: "B"
    },
    {
      id: 70126,
      question: "For prion diseases, which statement is true?",
      options: [
        "Vaccines are available",
        "No drug or vaccine is available",
        "Many effective drugs exist",
        "Antibiotics are effective",
      ],
      correct: "B"
    },
    {
      id: 70127,
      question: "Papovaviruses, adenoviruses, and parvoviruses all have which symmetry?",
      options: [
        "Helical",
        "Complex",
        "Icosahedral",
        "Random",
      ],
      correct: "C"
    },
    {
      id: 70128,
      question: "Which coronavirus symptom involves difficulty breathing?",
      options: [
        "Fever",
        "Shortness of breath",
        "Dry cough",
        "Runny nose",
      ],
      correct: "B"
    },
    {
      id: 70129,
      question: "Herpesviruses cause what type of infections?",
      options: [
        "Only acute infections",
        "Only one-time infections",
        "Latent and recurrent infections",
        "Only respiratory infections",
      ],
      correct: "C"
    },
    {
      id: 70130,
      question: "Fatal familial insomnia occurs at what age?",
      options: [
        "10-20 years",
        "20-30 years",
        "Over 70 years",
        "40-60 years",
      ],
      correct: "D"
    },
  ],
  "3. Microbial Pathogenesis": [
    {
      id: 70200,
      question: "Virulence depends on which two factors?",
      options: [
        "Size and shape",
        "Color and motility",
        "Toxigenicity and invasiveness",
        "Temperature and pH",
      ],
      correct: "C"
    },
    {
      id: 70201,
      question: "How many stages of infection are there?",
      options: [
        "Two",
        "Four",
        "Three",
        "Five",
      ],
      correct: "B"
    },
    {
      id: 70202,
      question: "How many routes of bacterial entry are described?",
      options: [
        "Three",
        "Five",
        "Four",
        "Six",
      ],
      correct: "B"
    },
    {
      id: 70203,
      question: "Which of the following is NOT a route of bacterial entry?",
      options: [
        "Skin",
        "Respiratory tract",
        "Lymphatic system",
        "Blood",
      ],
      correct: "C"
    },
    {
      id: 70204,
      question: "Pili are used for adherence by which bacteria?",
      options: [
        "S. mutans and S. aureus",
        "M. tuberculosis and S. pneumoniae",
        "B. cereus and V. cholerae",
        "N. gonorrhoeae and E. coli",
      ],
      correct: "D"
    },
    {
      id: 70205,
      question: "S. mutans uses which structure for adherence?",
      options: [
        "Extracellular polysaccharide",
        "Pili",
        "Flagella",
        "Capsule",
      ],
      correct: "A"
    },
    {
      id: 70206,
      question: "Which of the following is NOT a reason for sessile organism resistance?",
      options: [
        "Protection by EPM from immune system",
        "Poor availability of deeper-layer bacteria to antimicrobial agents",
        "Increased susceptibility to antibiotics",
        "Gene expression resulting in more resistance",
      ],
      correct: "C"
    },
    {
      id: 70207,
      question: "Which bacterium uses capsule as an invasiveness factor?",
      options: [
        "S. aureus",
        "S. pneumoniae",
        "E. coli",
        "N. gonorrhoeae",
      ],
      correct: "B"
    },
    {
      id: 70208,
      question: "S. aureus causes which type of inflammation?",
      options: [
        "Granulomatous",
        "Pyogenic",
        "Chronic only",
        "Allergic",
      ],
      correct: "B"
    },
    {
      id: 70209,
      question: "M. tuberculosis causes which type of inflammation?",
      options: [
        "Pyogenic",
        "Allergic",
        "Acute only",
        "Granulomatous",
      ],
      correct: "D"
    },
    {
      id: 70210,
      question: "Fever caused by endotoxins is due to which cytokine from macrophages?",
      options: [
        "IL-6",
        "TNF-alpha",
        "IL-10",
        "IL-1",
      ],
      correct: "D"
    },
    {
      id: 70211,
      question: "How many subunits do exotoxins have?",
      options: [
        "Two",
        "One",
        "Three",
        "Four",
      ],
      correct: "A"
    },
    {
      id: 70212,
      question: "Tetanus toxin prevents the release of which neurotransmitter?",
      options: [
        "Acetylcholine",
        "Glycine",
        "Dopamine",
        "Serotonin",
      ],
      correct: "B"
    },
    {
      id: 70213,
      question: "Which viruses can evade immune response by infecting macrophages and lymphocytes?",
      options: [
        "Rhinovirus and coronavirus",
        "Rotavirus and enterovirus",
        "Herpesviruses and paramyxoviruses",
        "Adenovirus and parvovirus",
      ],
      correct: "C"
    },
    {
      id: 70214,
      question: "Which type of viremia is more severe?",
      options: [
        "Primary viremia",
        "Both are equal",
        "Secondary viremia",
        "Neither is severe",
      ],
      correct: "C"
    },
    {
      id: 70215,
      question: "Which viruses demonstrate hemadsorption?",
      options: [
        "Herpesviruses",
        "Retroviruses",
        "Adenoviruses",
        "Orthomyxoviruses and paramyxoviruses",
      ],
      correct: "D"
    },
    {
      id: 70216,
      question: "Which viruses promote giant cell formation?",
      options: [
        "Rhinovirus and coronavirus",
        "HSV and HIV",
        "Adenovirus and parvovirus",
        "Rotavirus and enterovirus",
      ],
      correct: "B"
    },
    {
      id: 70217,
      question: "How many types of non-permissive infections are there?",
      options: [
        "Two",
        "Three",
        "Five",
        "Four",
      ],
      correct: "D"
    },
    {
      id: 70218,
      question: "Koch\'s postulates consist of how many principles?",
      options: [
        "Four",
        "Two",
        "Three",
        "Five",
      ],
      correct: "A"
    },
    {
      id: 70219,
      question: "V. cholerae produces which type of toxin?",
      options: [
        "Enterotoxin",
        "Neurotoxin",
        "Cytotoxin",
        "Hemotoxin",
      ],
      correct: "A"
    },
    {
      id: 70220,
      question: "B. cereus produces which type of toxin?",
      options: [
        "Neurotoxin",
        "Enterotoxin",
        "Cytotoxin",
        "Hemotoxin",
      ],
      correct: "B"
    },
    {
      id: 70221,
      question: "Anticapsular antibodies are stimulated by which invasiveness factor?",
      options: [
        "Pili",
        "Flagella",
        "Capsule",
        "Cell wall proteins",
      ],
      correct: "C"
    },
  ],
  "4. Basic Immunology": [
    {
      id: 70300,
      question: "Which type of immunity consists of pre-existing non-specific responses?",
      options: [
        "Adaptive immunity",
        "Acquired immunity",
        "Natural (innate) immunity",
        "Humoral immunity",
      ],
      correct: "C"
    },
    {
      id: 70301,
      question: "What is the ability of the immune system to discriminate between self and non-self components called?",
      options: [
        "Memory",
        "Tolerance",
        "Specificity",
        "Diversity",
      ],
      correct: "B"
    },
    {
      id: 70302,
      question: "Which characteristic describes the second immune response compared to the first?",
      options: [
        "Slower and weaker",
        "Faster and more intense",
        "Same speed but weaker",
        "Slower but more intense",
      ],
      correct: "B"
    },
    {
      id: 70303,
      question: "What is the mucociliary elevator?",
      options: [
        "Mucous secretions in the oral cavity",
        "Cilia projected from epithelial cells in the lower respiratory tract",
        "Enzymes in the stomach",
        "Lysozyme in tears",
      ],
      correct: "B"
    },
    {
      id: 70304,
      question: "Which two mammalian proteins can disrupt bacterial cell membranes?",
      options: [
        "Lysozyme and amylase",
        "Interferons and interleukins",
        "Defensins and cathelicidins",
        "Perforin and granzymes",
      ],
      correct: "C"
    },
    {
      id: 70305,
      question: "What is the chemotactic effect of defensins and cathelicidins?",
      options: [
        "They kill bacteria directly",
        "They attract phagocytic leukocytes, lymphocytes, and dendritic cells",
        "They neutralize toxins",
        "They activate complement",
      ],
      correct: "B"
    },
    {
      id: 70306,
      question: "Which cells are the major phagocytic cells?",
      options: [
        "B lymphocytes and T lymphocytes",
        "Natural killer cells and dendritic cells",
        "Polymorphonuclear leukocytes (PMN) and macrophages",
        "Mast cells and basophils",
      ],
      correct: "C"
    },
    {
      id: 70307,
      question: "What is the difference between PMNs and macrophages?",
      options: [
        "PMNs are tissue-resident while macrophages circulate",
        "PMNs are short-lived circulating cells while macrophages are tissue-resident monocytes",
        "PMNs live longer than macrophages",
        "There is no difference",
      ],
      correct: "B"
    },
    {
      id: 70308,
      question: "Which organs have plenty of macrophages?",
      options: [
        "Heart, brain, and muscles",
        "Liver, alveoli, kidney, spleen, and lymph nodes",
        "Stomach, intestines, and pancreas",
        "Bones, cartilage, and tendons",
      ],
      correct: "B"
    },
    {
      id: 70309,
      question: "What is formed when a phagosome fuses with a lysosome?",
      options: [
        "Pseudopod",
        "Phagolysosome",
        "Endosome",
        "Vacuole",
      ],
      correct: "B"
    },
    {
      id: 70310,
      question: "What do lysosomes produce to kill microbes?",
      options: [
        "Antibodies and cytokines",
        "Proteolytic enzymes, oxygen and nitrogen radicals",
        "Interferons and interleukins",
        "Complement proteins",
      ],
      correct: "B"
    },
    {
      id: 70311,
      question: "What type of cells are Natural Killer (NK) cells?",
      options: [
        "Phagocytic lymphocytes",
        "Non-phagocytic lymphocytes specialized in killing tumor and virus-infected cells",
        "Antibody-producing cells",
        "Antigen-presenting cells",
      ],
      correct: "B"
    },
    {
      id: 70312,
      question: "How many types of receptors do NK cells have?",
      options: [
        "One",
        "Two",
        "Three",
        "Four",
      ],
      correct: "B"
    },
    {
      id: 70313,
      question: "What does the antigen receptor on NK cells do?",
      options: [
        "Transmits inactivation signals",
        "Recognizes MHC I molecules",
        "Stimulates the transmission of activation signals",
        "Produces antibodies",
      ],
      correct: "C"
    },
    {
      id: 70314,
      question: "What does the MHC I receptor on NK cells transmit?",
      options: [
        "Activation signals",
        "Inactivation signals",
        "Chemotactic signals",
        "Inflammatory signals",
      ],
      correct: "B"
    },
    {
      id: 70315,
      question: "When are NK cells activated?",
      options: [
        "When there is a strong inactivation signal",
        "When there is no inactivation signal",
        "When antibodies are present",
        "When complement is activated",
      ],
      correct: "B"
    },
    {
      id: 70316,
      question: "What role do NK cells play in adaptive immunity?",
      options: [
        "They produce antibodies",
        "They act as effector cells in killing antibody-coated microbes",
        "They present antigens",
        "They produce memory cells",
      ],
      correct: "B"
    },
    {
      id: 70317,
      question: "Where are acute phase proteins produced?",
      options: [
        "Bone marrow",
        "Thymus",
        "Liver",
        "Spleen",
      ],
      correct: "C"
    },
    {
      id: 70318,
      question: "What does C-reactive protein bind to?",
      options: [
        "Viral RNA",
        "C-polysaccharide component of bacteria and fungi cell wall",
        "Antibodies",
        "T cell receptors",
      ],
      correct: "B"
    },
    {
      id: 70319,
      question: "What is the function of α1-antitrypsin?",
      options: [
        "Activates complement",
        "Neutralizes bacterial proteases",
        "Kills viruses",
        "Produces antibodies",
      ],
      correct: "B"
    },
    {
      id: 70320,
      question: "What are interferons?",
      options: [
        "Antibodies produced by B cells",
        "Cytokines synthesized by virus-infected cells and malignant cells",
        "Acute phase proteins",
        "Complement proteins",
      ],
      correct: "B"
    },
    {
      id: 70321,
      question: "How do interferons protect non-infected cells?",
      options: [
        "By producing antibodies",
        "By inhibiting mRNA translation of virus and host cell",
        "By activating complement",
        "By promoting phagocytosis",
      ],
      correct: "B"
    },
    {
      id: 70322,
      question: "What is one of the most pivotal parts of inflammatory responses that could lead to phagocytosis?",
      options: [
        "Antibody production",
        "Complement system",
        "T cell activation",
        "Cytokine release",
      ],
      correct: "B"
    },
    {
      id: 70323,
      question: "What are the two types of complement activation?",
      options: [
        "Primary and secondary",
        "Innate and adaptive",
        "Alternative and classical",
        "Humoral and cellular",
      ],
      correct: "C"
    },
    {
      id: 70324,
      question: "What are typical signs of inflammation?",
      options: [
        "Decreased blood supply and reduced leukocytes",
        "Leukocytes and acute-phase protein production as well as fever",
        "Antibody production only",
        "Memory cell formation",
      ],
      correct: "B"
    },
    {
      id: 70325,
      question: "What happens during inflammatory responses?",
      options: [
        "Blood supply decreases",
        "Capillaries become less permeable",
        "Immune system components move to the desired location and capillaries become more permeable",
        "Leukocyte migration decreases",
      ],
      correct: "C"
    },
    {
      id: 70326,
      question: "What are the four characteristics of acquired immunity?",
      options: [
        "Speed, intensity, duration, location",
        "Diversity, specificity, memory, self from non-self discrimination",
        "Phagocytosis, inflammation, complement, fever",
        "Innate, adaptive, humoral, cellular",
      ],
      correct: "B"
    },
    {
      id: 70327,
      question: "Where are all immune system cells derived from?",
      options: [
        "Thymus and spleen",
        "Hematopoietic stem cells in bone marrow and liver",
        "Lymph nodes only",
        "Peripheral blood",
      ],
      correct: "B"
    },
    {
      id: 70328,
      question: "What receptors do B cells and T cells express on their surfaces during maturation?",
      options: [
        "MHC I and MHC II",
        "BCR and TCR, respectively",
        "CD4 and CD8",
        "FcR and CR",
      ],
      correct: "B"
    },
    {
      id: 70329,
      question: "What do B lymphocytes produce?",
      options: [
        "Cytokines only",
        "Immunoglobulins (antibodies) and act as APCs for T cells",
        "Interferons",
        "Complement proteins",
      ],
      correct: "B"
    },
    {
      id: 70330,
      question: "Which marker do T-helper and T-delayed hypersensitivity cells have?",
      options: [
        "CD8",
        "CD4",
        "CD3",
        "CD19",
      ],
      correct: "B"
    },
    {
      id: 70331,
      question: "Which marker do T-cytotoxic and T-suppressor cells have?",
      options: [
        "CD4",
        "CD8",
        "CD19",
        "CD20",
      ],
      correct: "B"
    },
    {
      id: 70332,
      question: "How do T-helpers activate other immune system cells?",
      options: [
        "By producing antibodies",
        "By direct contact or secreting lymphokines",
        "By phagocytosis",
        "By complement activation",
      ],
      correct: "B"
    },
    {
      id: 70333,
      question: "What is the function of T-cytotoxic cells?",
      options: [
        "Activate other immune cells",
        "Kill target cells (tumor and virus-infected cells)",
        "Suppress immune responses",
        "Present antigens",
      ],
      correct: "B"
    },
    {
      id: 70334,
      question: "What do T-suppressor cells do?",
      options: [
        "Kill target cells",
        "Activate B cells",
        "Alleviate immune responses",
        "Produce antibodies",
      ],
      correct: "C"
    },
    {
      id: 70335,
      question: "What are the primary lymphoid organs?",
      options: [
        "Spleen and lymph nodes",
        "Bone marrow and thymus",
        "MALT and tonsils",
        "Appendix and Peyer\'s patches",
      ],
      correct: "B"
    },
    {
      id: 70336,
      question: "What ability do B and T lymphocytes acquire in primary lymphoid organs?",
      options: [
        "Antibody production",
        "Self from non-self discrimination",
        "Phagocytosis",
        "Complement activation",
      ],
      correct: "B"
    },
    {
      id: 70337,
      question: "What is the function of the spleen?",
      options: [
        "T cell maturation",
        "Blood filter and antibody producer",
        "B cell maturation",
        "Mucous membrane protection",
      ],
      correct: "B"
    },
    {
      id: 70338,
      question: "What is the function of lymph nodes?",
      options: [
        "Blood filtration",
        "Tissue filter and antigen concentrator",
        "B cell maturation",
        "T cell maturation",
      ],
      correct: "B"
    },
    {
      id: 70339,
      question: "What is MALT?",
      options: [
        "Primary lymphoid organ",
        "Mucosa-associated lymphoid tissue, the first barrier against microbial entry",
        "A type of antibody",
        "A complement protein",
      ],
      correct: "B"
    },
    {
      id: 70340,
      question: "What can TCR identify?",
      options: [
        "Non-linear peptides directly",
        "Linear peptides bound to MHC on the surface of APCs",
        "Carbohydrates",
        "Lipids",
      ],
      correct: "B"
    },
    {
      id: 70341,
      question: "What can BCR recognize?",
      options: [
        "Only linear peptides",
        "Non-linear peptides directly without MHC",
        "Only peptides bound to MHC",
        "Only carbohydrates",
      ],
      correct: "B"
    },
    {
      id: 70342,
      question: "What is MHC?",
      options: [
        "A type of antibody",
        "A complex genetic system coding for cell surface molecules that bind peptides for presentation to T cells",
        "A cytokine",
        "A complement protein",
      ],
      correct: "B"
    },
    {
      id: 70343,
      question: "How many classes of MHC are there?",
      options: [
        "One",
        "Two",
        "Three",
        "Four",
      ],
      correct: "B"
    },
    {
      id: 70344,
      question: "What chains does TCR consist of?",
      options: [
        "Heavy and light chains",
        "α and β or γ and δ chains",
        "Constant chains only",
        "Variable chains only",
      ],
      correct: "B"
    },
    {
      id: 70345,
      question: "Which region of TCR is in contact with antigen on the surface of APC?",
      options: [
        "Constant (C) region",
        "Variable (V) region",
        "Transmembrane region",
        "Cytoplasmic region",
      ],
      correct: "B"
    },
    {
      id: 70346,
      question: "What is BCR?",
      options: [
        "A cytokine receptor",
        "An Ig antibody that does not need any APC or MHC",
        "A complement receptor",
        "A chemokine receptor",
      ],
      correct: "B"
    },
    {
      id: 70347,
      question: "How many chains does BCR have?",
      options: [
        "One heavy chain",
        "Two heavy (H) chains and two light (L) chains",
        "Four heavy chains",
        "Two light chains only",
      ],
      correct: "B"
    },
    {
      id: 70348,
      question: "What happens after BCR binds to antigen?",
      options: [
        "B lymphocytes die",
        "B lymphocytes become activated and produce antibodies",
        "B lymphocytes become T cells",
        "B lymphocytes become macrophages",
      ],
      correct: "B"
    },
    {
      id: 70349,
      question: "What is responsible for antigen specificity in antibodies?",
      options: [
        "Constant region of light chain only",
        "Variable region of both heavy and light chains",
        "Constant region of heavy chain only",
        "Transmembrane region",
      ],
      correct: "B"
    },
    {
      id: 70350,
      question: "What can antigen-antibody complex lead to?",
      options: [
        "Only antigen neutralization",
        "Antigen neutralization, infected cell killing, and removal by phagocytic cells",
        "Only complement activation",
        "Only inflammation",
      ],
      correct: "B"
    },
    {
      id: 70351,
      question: "What do phagocytes and NKs bind to on antibody-coated target cells?",
      options: [
        "Variable region",
        "Fc receptors (constant region of heavy chain)",
        "Light chain",
        "Antigen-binding site",
      ],
      correct: "B"
    },
    {
      id: 70352,
      question: "Which antibody is a dimer?",
      options: [
        "IgG",
        "IgA",
        "IgM",
        "IgE",
      ],
      correct: "B"
    },
    {
      id: 70353,
      question: "How long does IgA in mother\'s milk protect newborns?",
      options: [
        "Up to 3 months",
        "Up to 9 months",
        "Up to 12 months",
        "Up to 18 months",
      ],
      correct: "B"
    },
    {
      id: 70354,
      question: "What is the function of IgD?",
      options: [
        "Crosses placenta",
        "Activates B lymphocytes",
        "Fights parasites",
        "Forms pentamers",
      ],
      correct: "B"
    },
    {
      id: 70355,
      question: "What is IgE highly effective against?",
      options: [
        "Bacteria only",
        "Parasites and allergens",
        "Viruses only",
        "Fungi only",
      ],
      correct: "B"
    },
    {
      id: 70356,
      question: "Which is the only antibody conveyed via placenta?",
      options: [
        "IgA",
        "IgM",
        "IgG",
        "IgE",
      ],
      correct: "C"
    },
    {
      id: 70357,
      question: "How many subclasses does IgG have?",
      options: [
        "Two",
        "Three",
        "Four",
        "Five",
      ],
      correct: "C"
    },
    {
      id: 70358,
      question: "Which antibody is a pentamer and is the first produced in most immune responses?",
      options: [
        "IgG",
        "IgA",
        "IgE",
        "IgM",
      ],
      correct: "D"
    },
    {
      id: 70359,
      question: "What are cytokines?",
      options: [
        "Heavy proteins produced by red blood cells",
        "Light glycoproteins produced mainly by various immune cells that act as communicative molecules",
        "Antibodies",
        "Complement proteins",
      ],
      correct: "B"
    },
    {
      id: 70360,
      question: "What are lymphokines?",
      options: [
        "Cytokines derived from macrophages",
        "Cytokines derived from lymphocytes",
        "Cytokines derived from neutrophils",
        "Cytokines derived from mast cells",
      ],
      correct: "B"
    },
    {
      id: 70361,
      question: "What produces monokines?",
      options: [
        "Lymphocytes",
        "Macrophages and monocytes",
        "Neutrophils",
        "NK cells",
      ],
      correct: "B"
    },
    {
      id: 70362,
      question: "What is the function of interleukins?",
      options: [
        "Only inflammation",
        "Initiator and regulator of all immune responses",
        "Only antibody production",
        "Only phagocytosis",
      ],
      correct: "B"
    },
    {
      id: 70363,
      question: "What are chemokines responsible for?",
      options: [
        "Antibody production",
        "Chemotaxis, leukocytes activation, cell adhesion to endothelium, and leukocyte trafficking",
        "Complement activation",
        "Antigen presentation",
      ],
      correct: "B"
    },
    {
      id: 70364,
      question: "What does pleiotropy mean for cytokines?",
      options: [
        "Same activity by different cytokines",
        "Different activities by one cytokine",
        "No activity",
        "Constant activity",
      ],
      correct: "B"
    },
    {
      id: 70365,
      question: "What does redundancy mean for cytokines?",
      options: [
        "Different activities by one cytokine",
        "Same activity by different cytokines",
        "No activity",
        "Reduced activity",
      ],
      correct: "B"
    },
    {
      id: 70366,
      question: "What happens when cytotoxic T cells (CD8+ T cells) contact antigen presented by MHC I?",
      options: [
        "They die",
        "Polarization of cytoplasmic granules and release of granule components",
        "They become memory cells",
        "They produce antibodies",
      ],
      correct: "B"
    },
    {
      id: 70367,
      question: "What are the most important components of cytotoxic granules?",
      options: [
        "Antibodies and cytokines",
        "Perforin and granzymes",
        "Complement proteins",
        "Interferons",
      ],
      correct: "B"
    },
    {
      id: 70368,
      question: "What does perforin do?",
      options: [
        "Acts as a protease",
        "Forms channels through the cell membrane",
        "Stimulates antibody production",
        "Activates complement",
      ],
      correct: "B"
    },
    {
      id: 70369,
      question: "What do granzymes do?",
      options: [
        "Form channels in membranes",
        "Act as proteases and stimulate apoptosis",
        "Produce antibodies",
        "Activate complement",
      ],
      correct: "B"
    },
    {
      id: 70370,
      question: "What do NK cells produce that enhances MHC I expression?",
      options: [
        "IL-1",
        "IFN-γ",
        "TNF-α",
        "IL-6",
      ],
      correct: "B"
    },
    {
      id: 70371,
      question: "What is ADCC?",
      options: [
        "Antigen-dependent cell-mediated cytotoxicity",
        "Antibody-dependent cell-mediated cytotoxicity",
        "Adaptive defense cellular cooperation",
        "Acquired defense complement cascade",
      ],
      correct: "B"
    },
    {
      id: 70372,
      question: "Which cells can activate ADCC?",
      options: [
        "B cells and T cells",
        "NKs, macrophages, and neutrophils",
        "Dendritic cells only",
        "Mast cells only",
      ],
      correct: "B"
    },
    {
      id: 70373,
      question: "What type of antibodies are mainly produced in primary immune response?",
      options: [
        "High-affinity IgG",
        "Low-affinity antibodies (IgM)",
        "IgE",
        "IgA",
      ],
      correct: "B"
    },
    {
      id: 70374,
      question: "What happens to some B cells that experience mutation?",
      options: [
        "They die",
        "They produce high-affinity antibodies (IgA, IgE and IgG)",
        "They become T cells",
        "They become macrophages",
      ],
      correct: "B"
    },
    {
      id: 70375,
      question: "What do memory B cells produce when they re-encounter the same antigen?",
      options: [
        "Low-affinity IgM slowly",
        "High titers of high-affinity antibodies (IgA, IgE and IgG) rapidly",
        "Only cytokines",
        "Only complement",
      ],
      correct: "B"
    },
    {
      id: 70376,
      question: "How are primary T cells and memory T cells distinguished?",
      options: [
        "By antibody production",
        "By different isoforms of CD45",
        "By size",
        "By location",
      ],
      correct: "B"
    },
    {
      id: 70377,
      question: "What do memory T cells produce compared to primary T cells?",
      options: [
        "Less stimulating molecules slowly",
        "Higher amounts of stimulating molecules rapidly for a long time",
        "Only antibodies",
        "Only complement",
      ],
      correct: "B"
    },
    {
      id: 70378,
      question: "What is required for memory T cell activation?",
      options: [
        "Primary B cells",
        "Memory B cells",
        "Macrophages",
        "Dendritic cells",
      ],
      correct: "B"
    },
    {
      id: 70379,
      question: "What do memory CD4+ T cells activate?",
      options: [
        "T-suppressor cells",
        "B cells",
        "Macrophages only",
        "NK cells only",
      ],
      correct: "B"
    },
    {
      id: 70380,
      question: "What do primary CD4+ T cells activate?",
      options: [
        "B cells",
        "T-suppressor cells",
        "NK cells",
        "Macrophages",
      ],
      correct: "B"
    },
    {
      id: 70381,
      question: "Which enzyme can break down peptidoglycan in bacterial cell walls?",
      options: [
        "Amylase",
        "Lysozyme",
        "Lipase",
        "Protease",
      ],
      correct: "B"
    },
    {
      id: 70382,
      question: "What do IL-1, IL-6, and TNF-α come from in bacterial defense?",
      options: [
        "B cells",
        "Macrophages",
        "T cells",
        "NK cells",
      ],
      correct: "B"
    },
    {
      id: 70383,
      question: "What activates alternative complement against bacteria?",
      options: [
        "Antibodies",
        "Endotoxins",
        "Cytokines",
        "Interferons",
      ],
      correct: "B"
    },
    {
      id: 70384,
      question: "Which antibody is active against bacterial toxins?",
      options: [
        "IgM",
        "IgG",
        "IgA",
        "IgE",
      ],
      correct: "B"
    },
    {
      id: 70385,
      question: "Which antibody protects mucous membranes against bacteria?",
      options: [
        "IgG",
        "IgM",
        "IgA",
        "IgE",
      ],
      correct: "C"
    },
    {
      id: 70386,
      question: "What is a bacterial evasion strategy where bacteria are not recognized by phagocytes?",
      options: [
        "Toxin production",
        "Encapsulation",
        "Spore formation",
        "Flagella movement",
      ],
      correct: "B"
    },
    {
      id: 70387,
      question: "Which bacteria can survive within inactive macrophages?",
      options: [
        "Streptococci and staphylococci",
        "Mycobacterium, Listeria, and Brucella",
        "E. coli and Salmonella",
        "Pseudomonas and Klebsiella",
      ],
      correct: "B"
    },
    {
      id: 70388,
      question: "What can long-term presence of macrophages against M. leprae and M. tuberculosis cause?",
      options: [
        "Antibody overproduction",
        "Massive production of lymphokines leading to cell fusion (syncytia or giant cells)",
        "Complement activation",
        "Increased phagocytosis",
      ],
      correct: "B"
    },
    {
      id: 70389,
      question: "What do virus-infected cells produce as a first defense?",
      options: [
        "Antibodies",
        "IFN-α and β",
        "Complement",
        "Acute phase proteins",
      ],
      correct: "B"
    },
    {
      id: 70390,
      question: "What is antigenic drift?",
      options: [
        "Major change in viral antigens",
        "Minor change in viral antigens",
        "Complete loss of antigens",
        "Gain of new antigens",
      ],
      correct: "B"
    },
    {
      id: 70391,
      question: "What is antigenic shift?",
      options: [
        "Minor change in viral antigens",
        "Major change in viral antigens",
        "Complete loss of antigens",
        "No change in antigens",
      ],
      correct: "B"
    },
    {
      id: 70392,
      question: "Which virus can integrate its genes into the host chromosome?",
      options: [
        "Influenza virus",
        "HSV (Herpes Simplex Virus)",
        "Rhinovirus",
        "Rotavirus",
      ],
      correct: "B"
    },
    {
      id: 70393,
      question: "Which viruses can infect immune cells?",
      options: [
        "Rhinovirus and rotavirus",
        "EBV, HIV, HTLV, and measles virus",
        "Influenza only",
        "Hepatitis A only",
      ],
      correct: "B"
    },
    {
      id: 70394,
      question: "What can EBV induce B cells to do?",
      options: [
        "Die immediately",
        "Secrete antibodies including anti-self antibodies",
        "Become T cells",
        "Stop dividing",
      ],
      correct: "B"
    },
    {
      id: 70395,
      question: "What can HBV cause?",
      options: [
        "Acute infections only",
        "Chronic autoimmune diseases",
        "Only liver cancer",
        "Only jaundice",
      ],
      correct: "B"
    },
    {
      id: 70396,
      question: "What are the major routes of AIDS transmission?",
      options: [
        "Airborne, food, and water",
        "Sexual intercourse, mother to fetus, and direct injection into blood",
        "Insect bites only",
        "Casual contact",
      ],
      correct: "B"
    },
    {
      id: 70397,
      question: "How does HIV attach to TH cells?",
      options: [
        "Via gp41",
        "Via gp120 to CD4",
        "Via reverse transcriptase",
        "Via integrase",
      ],
      correct: "B"
    },
    {
      id: 70398,
      question: "What is the function of gp41 in HIV infection?",
      options: [
        "Attaches to CD4",
        "Facilitates fusion and injection into the cell",
        "Produces viral RNA",
        "Integrates viral DNA",
      ],
      correct: "B"
    },
    {
      id: 70399,
      question: "What are the four key enzymes in HIV replication?",
      options: [
        "Lipase, amylase, protease, kinase",
        "RNase H, RT (reverse transcriptase), host DNA polymerase, and integrase",
        "DNA polymerase only",
        "RNA polymerase only",
      ],
      correct: "B"
    },
    {
      id: 70400,
      question: "What is the most important reservoir for HIV?",
      options: [
        "T cells",
        "Macrophages",
        "B cells",
        "NK cells",
      ],
      correct: "B"
    },
    {
      id: 70401,
      question: "What happens when lymph nodes are finally damaged in HIV infection?",
      options: [
        "Increased immunity",
        "TH destruction and HIV release",
        "Increased antibody production",
        "Enhanced phagocytosis",
      ],
      correct: "B"
    },
    {
      id: 70402,
      question: "What ratio increases in advanced HIV infection?",
      options: [
        "CD4+/CD8+ ratio",
        "CD8+/CD4+ ratio",
        "B cell/T cell ratio",
        "NK/macrophage ratio",
      ],
      correct: "B"
    },
    {
      id: 70403,
      question: "What are the three types of fungal infections based on location?",
      options: [
        "Mild, moderate, severe",
        "Superficial, subcutaneous, and systemic",
        "Acute, chronic, latent",
        "Primary, secondary, tertiary",
      ],
      correct: "B"
    },
    {
      id: 70404,
      question: "Which cells are most crucial against fungi?",
      options: [
        "B cells and macrophages",
        "Neutrophils and T cells",
        "NK cells and mast cells",
        "Dendritic cells and basophils",
      ],
      correct: "B"
    },
    {
      id: 70405,
      question: "Which antibody is related to allergic diseases in fungal infections?",
      options: [
        "IgG",
        "IgE",
        "IgM",
        "IgA",
      ],
      correct: "B"
    },
    {
      id: 70406,
      question: "What is vaccination?",
      options: [
        "Treatment of active infection",
        "Memory cells induction before exposure to pathogens",
        "Antibiotic administration",
        "Surgical removal of infected tissue",
      ],
      correct: "B"
    },
    {
      id: 70407,
      question: "What is passive transfer of maternal antibodies an example of?",
      options: [
        "Active immunization",
        "Passive immunization",
        "Natural active immunity",
        "Artificial active immunity",
      ],
      correct: "B"
    },
    {
      id: 70408,
      question: "Why is vaccination in neonatal period useful for memory T cells but not memory B cells?",
      options: [
        "Neonates cannot produce T cells",
        "Memory B cells would be neutralized by maternal antibodies",
        "Neonates cannot produce B cells",
        "T cells are absent in neonates",
      ],
      correct: "B"
    },
    {
      id: 70409,
      question: "What do live vaccines contain?",
      options: [
        "Killed microorganisms",
        "Attenuated microorganisms",
        "Toxoids",
        "Synthetic peptides only",
      ],
      correct: "B"
    },
    {
      id: 70410,
      question: "What can live vaccines induce?",
      options: [
        "Only memory B cells",
        "Both memory B and T cells",
        "Only memory T cells",
        "No memory cells",
      ],
      correct: "B"
    },
    {
      id: 70411,
      question: "Why are live vaccines not recommended for immunocompromised patients?",
      options: [
        "They are too expensive",
        "Attenuated organisms could cause disease in these patients",
        "They don\'t work in these patients",
        "They cause allergies",
      ],
      correct: "B"
    },
    {
      id: 70412,
      question: "What do inactivated vaccines contain?",
      options: [
        "Live attenuated organisms",
        "Killed microorganisms",
        "Only toxoids",
        "Only DNA",
      ],
      correct: "B"
    },
    {
      id: 70413,
      question: "What is the best adjuvant for vaccines?",
      options: [
        "Water",
        "Alum",
        "Saline",
        "Oil",
      ],
      correct: "B"
    },
    {
      id: 70414,
      question: "How does alum work as an adjuvant?",
      options: [
        "Kills pathogens",
        "Precipitates antigens to release them slowly",
        "Activates complement",
        "Produces antibodies",
      ],
      correct: "B"
    },
    {
      id: 70415,
      question: "What are toxoids?",
      options: [
        "Live bacteria",
        "Safe bacterial exotoxins that stimulate antitoxoid antibodies",
        "Killed viruses",
        "Synthetic chemicals",
      ],
      correct: "B"
    },
    {
      id: 70416,
      question: "What do synthetic peptide vaccines contain?",
      options: [
        "Whole organisms",
        "Epitopes of antigenic protein",
        "Live viruses",
        "Bacterial toxins",
      ],
      correct: "B"
    },
    {
      id: 70417,
      question: "What technology is used for recombinant vaccines like HBV vaccine?",
      options: [
        "Cell culture",
        "Recombinant DNA technology",
        "Fermentation",
        "Distillation",
      ],
      correct: "B"
    },
    {
      id: 70418,
      question: "What do mRNA vaccines encode?",
      options: [
        "Whole virus",
        "Virus spikes",
        "Bacterial toxins",
        "Fungal cell wall",
      ],
      correct: "B"
    },
    {
      id: 70419,
      question: "What is an example of an mRNA vaccine?",
      options: [
        "MMR vaccine",
        "COVID-19 vaccine",
        "Polio vaccine",
        "BCG vaccine",
      ],
      correct: "B"
    },
    {
      id: 70420,
      question: "What do subunit vaccines consist of?",
      options: [
        "Whole organisms",
        "Protection-inducing proteins",
        "Live attenuated viruses",
        "Killed bacteria",
      ],
      correct: "B"
    },
    {
      id: 70421,
      question: "What is immune hyperactivity associated with?",
      options: [
        "Infections and cancers",
        "Allergy and autoimmunity",
        "Immunodeficiency",
        "Normal immune function",
      ],
      correct: "B"
    },
    {
      id: 70422,
      question: "What is immune hypoactivity associated with?",
      options: [
        "Allergy and autoimmunity",
        "Immunodeficiency, infections, and cancers",
        "Normal immune function",
        "Hyperallergic reactions",
      ],
      correct: "B"
    },
    {
      id: 70423,
      question: "What characterizes a normal immune system?",
      options: [
        "Reactivity to self and non-self",
        "Specific non-reactivity to self and specific reactivity to non-self",
        "Non-reactivity to everything",
        "Reactivity to self only",
      ],
      correct: "B"
    },
    {
      id: 70424,
      question: "From the myeloid precursor in bone marrow, which cells are NOT derived?",
      options: [
        "Erythrocytes",
        "T lymphocytes",
        "Macrophages",
        "Neutrophils",
      ],
      correct: "B"
    },
    {
      id: 70425,
      question: "Where do thymocytes mature?",
      options: [
        "Bone marrow",
        "Thymus",
        "Spleen",
        "Lymph nodes",
      ],
      correct: "B"
    },
    {
      id: 70426,
      question: "What cells come from thymocytes?",
      options: [
        "B lymphocytes only",
        "T-helper cells, T-cytotoxic cells, and T-suppressor cells",
        "NK cells",
        "Macrophages",
      ],
      correct: "B"
    },
    {
      id: 70427,
      question: "What stimulates IL-8 production according to the document?",
      options: [
        "Antibodies",
        "Defensins and cathelicidins",
        "Complement",
        "Interferons",
      ],
      correct: "B"
    },
    {
      id: 70428,
      question: "What can defensins and cathelicidins cause mast cells to do?",
      options: [
        "Produce antibodies",
        "Degranulate",
        "Divide",
        "Migrate to bone marrow",
      ],
      correct: "B"
    },
    {
      id: 70429,
      question: "In what order does phagocytosis occur?",
      options: [
        "Phagosome formation → receptor binding → internalization → killing",
        "Receptor binding → pseudopod extension → internalization → phagosome formation → lysosome fusion → killing",
        "Killing → internalization → receptor binding",
        "Lysosome fusion → receptor binding → killing",
      ],
      correct: "B"
    },
    {
      id: 70430,
      question: "What type of response does TH1 cell activation lead to in bacterial defense?",
      options: [
        "Antibody production",
        "Macrophage activation",
        "Complement activation",
        "Mast cell degranulation",
      ],
      correct: "B"
    },
    {
      id: 70431,
      question: "What type of response does TH2 cell activation lead to?",
      options: [
        "Macrophage activation only",
        "Antibody production",
        "NK cell activation only",
        "Complement activation only",
      ],
      correct: "B"
    },
    {
      id: 70432,
      question: "What proteins in influenza A virus can undergo antigenic variation?",
      options: [
        "M and P proteins",
        "H and N proteins",
        "S and E proteins",
        "G and F proteins",
      ],
      correct: "B"
    },
    {
      id: 70433,
      question: "Which viruses can induce cytotoxic T cells that may lead to host cell destruction?",
      options: [
        "Influenza virus only",
        "Coxsackieviruses and mumps virus",
        "HIV only",
        "HBV only",
      ],
      correct: "B"
    },
    {
      id: 70434,
      question: "What happens to low-affinity B cells when the antigen is removed?",
      options: [
        "They become memory cells",
        "They die",
        "They produce more antibodies",
        "They become T cells",
      ],
      correct: "B"
    },
    {
      id: 70435,
      question: "What molecules are involved in memory B cell and memory TH cell interaction?",
      options: [
        "TCR and BCR only",
        "B7-CD28 and CD40-CD40L interactions leading to bcl-2 expression",
        "MHC only",
        "Complement only",
      ],
      correct: "B"
    },
    {
      id: 70436,
      question: "What is bcl-2 associated with in memory cell development?",
      options: [
        "Cell death",
        "Cell survival",
        "Antibody production",
        "Cytokine release",
      ],
      correct: "B"
    },
    {
      id: 70437,
      question: "What is the role of FDC (Follicular Dendritic Cells) in memory development?",
      options: [
        "Killing pathogens",
        "Holding antigen-antibody complexes for high-affinity B cell selection",
        "Producing antibodies",
        "Activating complement",
      ],
      correct: "B"
    },
    {
      id: 70438,
      question: "Which strains of bacteria have antigens similar to heart tissue?",
      options: [
        "E. coli",
        "S. pyogenes",
        "S. aureus",
        "P. aeruginosa",
      ],
      correct: "B"
    },
    {
      id: 70439,
      question: "What can some bacteria do to survive inside phagocytes?",
      options: [
        "Produce antibodies",
        "Remain active or kill the phagocytes",
        "Transform into viruses",
        "Become dormant permanently",
      ],
      correct: "B"
    },
    {
      id: 70440,
      question: "How does HIV also attach to macrophages besides CD4?",
      options: [
        "Via gp120",
        "Via Fc receptors",
        "Via complement receptors",
        "Via MHC",
      ],
      correct: "B"
    },
    {
      id: 70441,
      question: "During the latency period of HIV infection, what is the status of TH cells?",
      options: [
        "Completely destroyed",
        "Patients do not have TH deficiency",
        "TH cells are increased",
        "TH cells transform into TC cells",
      ],
      correct: "B"
    },
    {
      id: 70442,
      question: "How can HIV destroy uninfected TH cells?",
      options: [
        "Direct infection only",
        "By indirect mechanisms",
        "Through antibody production",
        "Through complement activation",
      ],
      correct: "B"
    },
    {
      id: 70443,
      question: "Which type of immunity results from infection leading to death or recovery with memory T and B cells?",
      options: [
        "Artificial passive",
        "Natural active",
        "Artificial active",
        "Natural passive",
      ],
      correct: "B"
    },
    {
      id: 70444,
      question: "Which type of immunity results from vaccination?",
      options: [
        "Natural passive",
        "Natural active",
        "Artificial active",
        "Artificial passive",
      ],
      correct: "C"
    },
    {
      id: 70445,
      question: "Which type of immunity results from placental transfer of IgG?",
      options: [
        "Artificial active",
        "Natural passive",
        "Natural active",
        "Artificial passive",
      ],
      correct: "B"
    },
    {
      id: 70446,
      question: "What is the outcome of passive immunization regarding memory cells?",
      options: [
        "Memory T and B cells are formed",
        "No memory T and B cells are formed",
        "Only memory T cells are formed",
        "Only memory B cells are formed",
      ],
      correct: "B"
    },
    {
      id: 70447,
      question: "What types of vaccines are listed as new approaches to vaccine development?",
      options: [
        "Only live vaccines",
        "Synthetic peptide, recombinant, subunit, and mRNA vaccines",
        "Only killed vaccines",
        "Only toxoid vaccines",
      ],
      correct: "B"
    },
    {
      id: 70448,
      question: "Which antibody has been detected in immune complex diseases like aspergilloma in the lungs?",
      options: [
        "IgE",
        "IgG",
        "IgM",
        "IgA",
      ],
      correct: "B"
    },
    {
      id: 70449,
      question: "What is allergic aspergillosis in the lungs related to?",
      options: [
        "IgG",
        "IgE",
        "IgM",
        "IgA",
      ],
      correct: "B"
    },
    {
      id: 70450,
      question: "What can post-exposure prophylaxis with passive immunoglobulin transfer be used for?",
      options: [
        "Influenza",
        "Rabies",
        "Common cold",
        "Tuberculosis",
      ],
      correct: "B"
    },
  ],
  "5. Medical Bacteriology (Part 1)": [
    {
      id: 70400,
      question: "What is the Gram stain characteristic of Streptococci?",
      options: [
        "Gram-negative cocci",
        "Gram-positive cocci",
        "Gram-negative bacilli",
        "Gram-positive bacilli",
      ],
      correct: "B"
    },
    {
      id: 70401,
      question: "What is the shape of Streptococci?",
      options: [
        "Rod-shaped",
        "Spiral",
        "Spherical or oval",
        "Square",
      ],
      correct: "C"
    },
    {
      id: 70402,
      question: "How do Streptococci appear in pus or liquid media?",
      options: [
        "In grape-like clusters",
        "In chains",
        "As single cells",
        "In tetrads",
      ],
      correct: "B"
    },
    {
      id: 70403,
      question: "What is the catalase test result for Streptococci?",
      options: [
        "Catalase-positive",
        "Catalase-variable",
        "Catalase-negative",
        "Catalase-dependent",
      ],
      correct: "C"
    },
    {
      id: 70404,
      question: "What type of respiration do Streptococci use?",
      options: [
        "Obligate anaerobic",
        "Obligate aerobic",
        "Facultative aerobic",
        "Microaerophilic only",
      ],
      correct: "C"
    },
    {
      id: 70405,
      question: "What is the virulence of Streptococci mostly related to?",
      options: [
        "Flagella proteins",
        "Carbohydrate antigens on their cell walls",
        "Lipopolysaccharides",
        "Capsule proteins only",
      ],
      correct: "B"
    },
    {
      id: 70406,
      question: "What is Lancefield grouping based on?",
      options: [
        "Flagellar antigens",
        "Polysaccharide antigens on the cell wall",
        "Capsular antigens",
        "Ribosomal proteins",
      ],
      correct: "B"
    },
    {
      id: 70407,
      question: "How many Lancefield groups have been identified?",
      options: [
        "10 groups",
        "15 groups",
        "20 groups",
        "25 groups",
      ],
      correct: "C"
    },
    {
      id: 70408,
      question: "What are the normal habitats of Streptococcus pyogenes?",
      options: [
        "Soil and water",
        "Human upper respiratory tract and skin",
        "Intestines only",
        "Female genital tract only",
      ],
      correct: "B"
    },
    {
      id: 70409,
      question: "How is Streptococcus pyogenes transmitted?",
      options: [
        "Fecal-oral route only",
        "Respiratory droplets and contact",
        "Vector-borne transmission",
        "Waterborne transmission",
      ],
      correct: "B"
    },
    {
      id: 70410,
      question: "Why are capsulated strains of S. pyogenes more virulent?",
      options: [
        "They produce more toxins",
        "They are resistant to phagocytosis",
        "They grow faster",
        "They are antibiotic resistant",
      ],
      correct: "B"
    },
    {
      id: 70411,
      question: "What is the function of streptokinase?",
      options: [
        "Destroys DNA",
        "Acts as a fibrinolysin",
        "Produces capsule",
        "Inhibits complement",
      ],
      correct: "B"
    },
    {
      id: 70412,
      question: "What is the alternative name for hyaluronidase?",
      options: [
        "Clotting factor",
        "Spreading factor",
        "Protective factor",
        "Growth factor",
      ],
      correct: "B"
    },
    {
      id: 70413,
      question: "Which enzyme has a pivotal role in cellulitis caused by S. pyogenes?",
      options: [
        "DNase",
        "Streptokinase",
        "Hyaluronidase",
        "Coagulase",
      ],
      correct: "C"
    },
    {
      id: 70414,
      question: "What is erythrogenic toxin responsible for?",
      options: [
        "Food poisoning",
        "Rashes of scarlet fever",
        "Meningitis",
        "Pneumonia",
      ],
      correct: "B"
    },
    {
      id: 70415,
      question: "Which toxins are phage mediated and responsible for erythematous rash in scarlet fever?",
      options: [
        "Enterotoxins",
        "Cytolysins",
        "Endotoxins",
        "Neurotoxins",
      ],
      correct: "B"
    },
    {
      id: 70416,
      question: "What are the two types of hemolysins produced by S. pyogenes?",
      options: [
        "Alpha and beta hemolysin",
        "Streptolysin S and O",
        "Hemolysin A and B",
        "Type I and II hemolysin",
      ],
      correct: "B"
    },
    {
      id: 70417,
      question: "What does ASO antibody verify?",
      options: [
        "Current infection with S. pyogenes",
        "Previous exposure to S. pyogenes",
        "Immunity to streptococci",
        "Antibiotic resistance",
      ],
      correct: "B"
    },
    {
      id: 70418,
      question: "Which of the following is NOT an infection caused by S. pyogenes?",
      options: [
        "Tonsillitis",
        "Impetigo",
        "Urinary tract infection",
        "Scarlet fever",
      ],
      correct: "C"
    },
    {
      id: 70419,
      question: "What is rheumatic fever?",
      options: [
        "Bacterial infection of the heart",
        "Immunological reaction between heart tissue and bacterial antigens",
        "Viral infection of joints",
        "Fungal infection of valves",
      ],
      correct: "B"
    },
    {
      id: 70420,
      question: "What causes acute glomerulonephritis after S. pyogenes infection?",
      options: [
        "Direct bacterial invasion",
        "Immunological reaction between glomeruli and immune complexes",
        "Toxin damage",
        "Enzyme destruction",
      ],
      correct: "B"
    },
    {
      id: 70421,
      question: "What is the drug of choice (DOC) for S. pyogenes infections?",
      options: [
        "Vancomycin",
        "Metronidazole",
        "Penicillin",
        "Ciprofloxacin",
      ],
      correct: "C"
    },
    {
      id: 70422,
      question: "What antibiotic should penicillin-allergic patients receive for S. pyogenes?",
      options: [
        "Metronidazole",
        "Erythromycin",
        "Vancomycin",
        "Clindamycin",
      ],
      correct: "B"
    },
    {
      id: 70423,
      question: "What are the normal habitats of Streptococcus agalactiae?",
      options: [
        "Skin and respiratory tract",
        "Human vagina and anorectal area",
        "Oral cavity only",
        "Intestines only",
      ],
      correct: "B"
    },
    {
      id: 70424,
      question: "Which Lancefield group does S. agalactiae belong to?",
      options: [
        "Group A",
        "Group B",
        "Group C",
        "Group D",
      ],
      correct: "B"
    },
    {
      id: 70425,
      question: "What infections does S. agalactiae cause?",
      options: [
        "Dental caries",
        "Neonatal meningitis and septicemia",
        "Scarlet fever",
        "Rheumatic fever",
      ],
      correct: "B"
    },
    {
      id: 70426,
      question: "How is S. agalactiae transmitted to neonates?",
      options: [
        "Through breast milk",
        "During delivery",
        "Through respiratory droplets",
        "Through contaminated food",
      ],
      correct: "B"
    },
    {
      id: 70427,
      question: "What is the normal habitat of oral streptococci?",
      options: [
        "Skin",
        "Human oropharynx",
        "Intestines",
        "Urogenital tract",
      ],
      correct: "B"
    },
    {
      id: 70428,
      question: "How are oral streptococci transmitted?",
      options: [
        "Fecal-oral route",
        "Mother to child",
        "Airborne droplets",
        "Vector transmission",
      ],
      correct: "B"
    },
    {
      id: 70429,
      question: "Which are the four main species groups of oral streptococci?",
      options: [
        "Alpha, beta, gamma, delta",
        "Mutans, mitis, salivarius, anginosus",
        "Viridans, pneumoniae, pyogenes, agalactiae",
        "Type I, II, III, IV",
      ],
      correct: "B"
    },
    {
      id: 70430,
      question: "What is the main agent of dental caries among oral streptococci?",
      options: [
        "S. mitis",
        "S. mutans",
        "S. salivarius",
        "S. anginosus",
      ],
      correct: "B"
    },
    {
      id: 70431,
      question: "How can oral streptococci cause infectious endocarditis?",
      options: [
        "Through skin wounds",
        "Through bacterial entry into blood stream after intraoral surgeries or tooth-brushing",
        "Through ingestion",
        "Through inhalation",
      ],
      correct: "B"
    },
    {
      id: 70432,
      question: "What do oral streptococci produce in the presence of carbohydrates that leads to dental caries?",
      options: [
        "Toxins",
        "Extracellular sticky polysaccharide",
        "Enzymes",
        "Acids only",
      ],
      correct: "B"
    },
    {
      id: 70433,
      question: "How many serotypes does S. mutans have?",
      options: [
        "4 serotypes",
        "6 serotypes",
        "8 serotypes",
        "10 serotypes",
      ],
      correct: "C"
    },
    {
      id: 70434,
      question: "Which S. mutans serotypes are isolated from humans?",
      options: [
        "a, b, and d",
        "c, e, and f",
        "g, h, and a",
        "b, d, and f",
      ],
      correct: "B"
    },
    {
      id: 70435,
      question: "What morphological change did S. mutans undergo in the past?",
      options: [
        "From bacillary to coccal",
        "From coccal to coccobacillary",
        "From spiral to coccal",
        "From filamentous to coccal",
      ],
      correct: "B"
    },
    {
      id: 70436,
      question: "What is the normal habitat of Streptococcus pneumoniae?",
      options: [
        "Skin",
        "Human upper respiratory tract",
        "Intestines",
        "Genital tract",
      ],
      correct: "B"
    },
    {
      id: 70437,
      question: "How is S. pneumoniae transmitted?",
      options: [
        "Contact transmission",
        "Airborne droplets",
        "Fecal-oral route",
        "Vector-borne",
      ],
      correct: "B"
    },
    {
      id: 70438,
      question: "What is the morphology of most S. pneumoniae strains?",
      options: [
        "Single cocci",
        "Diplococci and capsulate",
        "Chains",
        "Clusters",
      ],
      correct: "B"
    },
    {
      id: 70439,
      question: "What is the function of S. pneumoniae capsule?",
      options: [
        "Toxin production",
        "Block phagocytosis",
        "Nutrient absorption",
        "Adhesion only",
      ],
      correct: "B"
    },
    {
      id: 70440,
      question: "Which condition is associated with pneumococcal pneumonia?",
      options: [
        "Skin damage",
        "Mucociliary escalator defect",
        "Immune deficiency only",
        "Malnutrition",
      ],
      correct: "B"
    },
    {
      id: 70441,
      question: "What is used for vaccination against S. pneumoniae?",
      options: [
        "Toxoid",
        "Anticapsular antibody",
        "Killed bacteria",
        "Live attenuated bacteria",
      ],
      correct: "B"
    },
    {
      id: 70442,
      question: "Where are Gram-positive anaerobic cocci (GPAC) found?",
      options: [
        "Skin surface only",
        "Dental plaque, subgingival plaque, and female genital tract",
        "Respiratory tract only",
        "Intestines only",
      ],
      correct: "B"
    },
    {
      id: 70443,
      question: "Which is a medically important GPAC?",
      options: [
        "Streptococcus mutans",
        "Peptostreptococcus",
        "Staphylococcus aureus",
        "Lactobacillus",
      ],
      correct: "B"
    },
    {
      id: 70444,
      question: "What is the Gram stain characteristic of Staphylococci?",
      options: [
        "Gram-negative cocci",
        "Gram-positive cocci",
        "Gram-negative bacilli",
        "Gram-positive bacilli",
      ],
      correct: "B"
    },
    {
      id: 70445,
      question: "How do Staphylococci appear microscopically?",
      options: [
        "In chains",
        "In grape-like clusters",
        "In pairs",
        "As single cells",
      ],
      correct: "B"
    },
    {
      id: 70446,
      question: "What is the catalase test result for Staphylococci?",
      options: [
        "Catalase-negative",
        "Catalase-positive",
        "Variable",
        "Indeterminate",
      ],
      correct: "B"
    },
    {
      id: 70447,
      question: "What is the normal habitat of Staphylococcus aureus?",
      options: [
        "Intestines",
        "Human skin",
        "Respiratory tract",
        "Genital tract",
      ],
      correct: "B"
    },
    {
      id: 70448,
      question: "How is S. aureus transmitted?",
      options: [
        "Airborne droplets",
        "Via the hands and fingertips",
        "Fecal-oral route",
        "Sexual contact",
      ],
      correct: "B"
    },
    {
      id: 70449,
      question: "What does coagulase enzyme do?",
      options: [
        "Dissolves fibrin",
        "Clots human serum and rabbit plasma",
        "Destroys DNA",
        "Breaks down proteins",
      ],
      correct: "B"
    },
    {
      id: 70450,
      question: "What is the special affinity of Protein A?",
      options: [
        "IgM",
        "IgG",
        "IgA",
        "IgE",
      ],
      correct: "B"
    },
    {
      id: 70451,
      question: "How does Protein A contribute to virulence?",
      options: [
        "Produces toxins",
        "Makes the bacterium resistant to phagocytosis",
        "Increases growth rate",
        "Enhances toxin production",
      ],
      correct: "B"
    },
    {
      id: 70452,
      question: "What is the function of catalase in S. aureus?",
      options: [
        "Clots plasma",
        "Alleviates the bactericidal activity of PMNs",
        "Produces toxins",
        "Breaks down antibiotics",
      ],
      correct: "B"
    },
    {
      id: 70453,
      question: "What does Toxic Shock Syndrome Toxin (TSST) cause?",
      options: [
        "Diarrhea only",
        "Rash, desquamation, and shock",
        "Pneumonia",
        "Meningitis",
      ],
      correct: "B"
    },
    {
      id: 70454,
      question: "What does S. aureus enterotoxin cause?",
      options: [
        "Skin lesions",
        "Nausea, vomiting, and diarrhea",
        "Respiratory infection",
        "Urinary infection",
      ],
      correct: "B"
    },
    {
      id: 70455,
      question: "What does epidermolytic toxin cause?",
      options: [
        "Diarrhea",
        "Exfoliation",
        "Pneumonia",
        "Septicemia",
      ],
      correct: "B"
    },
    {
      id: 70456,
      question: "Which oral infection can S. aureus cause?",
      options: [
        "Dental caries",
        "Angular cheilitis",
        "Periodontitis",
        "Gingivitis",
      ],
      correct: "B"
    },
    {
      id: 70457,
      question: "What deep infection can S. aureus cause?",
      options: [
        "Dental caries",
        "Osteomyelitis",
        "Gingivitis",
        "Periodontal disease",
      ],
      correct: "B"
    },
    {
      id: 70458,
      question: "What does MRSA stand for?",
      options: [
        "Multiple Resistant Staphylococcus aureus",
        "Methicillin-Resistant Staphylococcus aureus",
        "Macrolide-Resistant Staphylococcus aureus",
        "Multi-drug Resistant Staphylococcus aureus",
      ],
      correct: "B"
    },
    {
      id: 70459,
      question: "What is the cause of vancomycin resistance in VRSA?",
      options: [
        "Enzyme production",
        "Cell wall alterations",
        "Efflux pumps",
        "Target modification",
      ],
      correct: "B"
    },
    {
      id: 70460,
      question: "What is the drug of choice for S. epidermidis infections?",
      options: [
        "Penicillin",
        "Vancomycin",
        "Erythromycin",
        "Metronidazole",
      ],
      correct: "B"
    },
    {
      id: 70461,
      question: "What type of infections does S. epidermidis cause?",
      options: [
        "Respiratory infections",
        "Urinary tract infections and catheter-related sepsis",
        "Skin infections",
        "Gastrointestinal infections",
      ],
      correct: "B"
    },
    {
      id: 70462,
      question: "What type of infection does Staphylococcus saprophyticus cause?",
      options: [
        "Respiratory infection",
        "Urinary tract infections (STD)",
        "Skin infection",
        "Gastrointestinal infection",
      ],
      correct: "B"
    },
    {
      id: 70463,
      question: "What is the Gram stain characteristic of Lactobacilli?",
      options: [
        "Gram-negative bacilli",
        "Gram-positive coccobacilli",
        "Gram-positive cocci",
        "Gram-negative cocci",
      ],
      correct: "B"
    },
    {
      id: 70464,
      question: "What are the normal habitats of Lactobacilli?",
      options: [
        "Skin only",
        "Oral cavity, female genital tract, and gastrointestinal tract",
        "Respiratory tract only",
        "Blood",
      ],
      correct: "B"
    },
    {
      id: 70465,
      question: "Why are Lactobacilli associated with dental caries and deep carious lesions?",
      options: [
        "They produce toxins",
        "Due to acidic pH tolerance",
        "They destroy enamel directly",
        "They produce enzymes",
      ],
      correct: "B"
    },
    {
      id: 70466,
      question: "What does acidogenic mean for Lactobacilli?",
      options: [
        "They survive in acid",
        "They produce acid",
        "They neutralize acid",
        "They are killed by acid",
      ],
      correct: "B"
    },
    {
      id: 70467,
      question: "What does aciduric mean for Lactobacilli?",
      options: [
        "They produce acid",
        "They tolerate/survive in acidic conditions",
        "They neutralize acid",
        "They require acid",
      ],
      correct: "B"
    },
    {
      id: 70468,
      question: "What do homofermenters produce?",
      options: [
        "Ethanol and CO2",
        "Lactic acid only",
        "Acetic acid only",
        "Butyric acid",
      ],
      correct: "B"
    },
    {
      id: 70469,
      question: "What do heterofermenters produce?",
      options: [
        "Lactic acid only",
        "Lactic acid, ethanol, acetate, and CO2",
        "Ethanol only",
        "CO2 only",
      ],
      correct: "B"
    },
    {
      id: 70470,
      question: "Which is an example of a homofermenter?",
      options: [
        "L. fermentum",
        "L. casei",
        "L. brevis",
        "L. buchneri",
      ],
      correct: "B"
    },
    {
      id: 70471,
      question: "Which Lactobacillus species is an example of a heterofermenter?",
      options: [
        "L. casei",
        "L. fermentum",
        "L. acidophilus",
        "L. rhamnosus",
      ],
      correct: "B"
    },
    {
      id: 70472,
      question: "What is the Gram stain characteristic of Corynebacteria?",
      options: [
        "Gram-negative cocci",
        "Gram-positive bacilli or coccobacilli",
        "Gram-negative bacilli",
        "Gram-positive cocci",
      ],
      correct: "B"
    },
    {
      id: 70473,
      question: "What type of morphology do Corynebacteria exhibit?",
      options: [
        "Uniform",
        "Pleomorphic",
        "Spiral",
        "Filamentous",
      ],
      correct: "B"
    },
    {
      id: 70474,
      question: "What does the cell wall of Corynebacteria contain?",
      options: [
        "Lipopolysaccharide",
        "Mycolic acid",
        "Teichoic acid only",
        "Peptidoglycan only",
      ],
      correct: "B"
    },
    {
      id: 70475,
      question: "Which other bacteria also contain mycolic acid in their cell walls?",
      options: [
        "Streptococcus and Staphylococcus",
        "Mycobacterium and Nocardia",
        "E. coli and Salmonella",
        "Bacillus and Clostridium",
      ],
      correct: "B"
    },
    {
      id: 70476,
      question: "What are the normal habitats of Corynebacterium diphtheriae?",
      options: [
        "Intestines and blood",
        "Human throat, nose, and at times skin",
        "Genital tract",
        "Urinary tract",
      ],
      correct: "B"
    },
    {
      id: 70477,
      question: "How is C. diphtheriae transmitted?",
      options: [
        "Contact transmission",
        "Respiratory droplets",
        "Fecal-oral route",
        "Sexual contact",
      ],
      correct: "B"
    },
    {
      id: 70478,
      question: "What are metachromatic granules?",
      options: [
        "Lipid stores",
        "Polymerized phosphate stores",
        "Protein stores",
        "Carbohydrate stores",
      ],
      correct: "B"
    },
    {
      id: 70479,
      question: "What enables certain strains of C. diphtheriae to produce diphtheria toxin?",
      options: [
        "Plasmid with tox gene",
        "Bacteriophage carrying the tox gene",
        "Chromosomal mutation",
        "Transposon insertion",
      ],
      correct: "B"
    },
    {
      id: 70480,
      question: "How many subunits does diphtheria toxin have?",
      options: [
        "One",
        "Two (A and B)",
        "Three",
        "Four",
      ],
      correct: "B"
    },
    {
      id: 70481,
      question: "What is the function of subunit B of diphtheria toxin?",
      options: [
        "Inhibits protein synthesis",
        "Binds toxin with the cell receptor",
        "Destroys DNA",
        "Activates enzymes",
      ],
      correct: "B"
    },
    {
      id: 70482,
      question: "What is the function of subunit A of diphtheria toxin?",
      options: [
        "Binds to receptors",
        "Inhibits protein synthesis",
        "Activates complement",
        "Destroys cell membrane",
      ],
      correct: "B"
    },
    {
      id: 70483,
      question: "What does the pseudomembrane in diphtheria contain?",
      options: [
        "Mucus only",
        "Bacteria, phagocytes, and fibrin",
        "Dead epithelial cells only",
        "Blood clots",
      ],
      correct: "B"
    },
    {
      id: 70484,
      question: "What can diphtheria toxin\'s pseudomembrane lead to?",
      options: [
        "Skin lesions",
        "Airway blockage and asphyxiation",
        "Intestinal obstruction",
        "Urinary blockage",
      ],
      correct: "B"
    },
    {
      id: 70485,
      question: "What organ\'s motor nerves can diphtheria toxin affect?",
      options: [
        "Brain",
        "Myocardium",
        "Lungs",
        "Kidneys",
      ],
      correct: "B"
    },
    {
      id: 70486,
      question: "What is a toxoid?",
      options: [
        "Active toxin",
        "Non-toxic but antigenic form of toxin",
        "Inactivated toxin with no antigenicity",
        "Synthetic toxin",
      ],
      correct: "B"
    },
    {
      id: 70487,
      question: "What vaccine is used for diphtheria prophylaxis?",
      options: [
        "BCG vaccine",
        "DPT vaccine",
        "MMR vaccine",
        "Hepatitis vaccine",
      ],
      correct: "B"
    },
    {
      id: 70488,
      question: "What is the recommended treatment for diphtheria?",
      options: [
        "Surgery only",
        "Antitoxin for neutralization and penicillin for killing bacteria",
        "Antibiotics only",
        "Supportive care only",
      ],
      correct: "B"
    },
    {
      id: 70489,
      question: "Which Corynebacterium can cause diphtheria-like lesions but is non-toxic?",
      options: [
        "C. diphtheriae",
        "C. ulcerans",
        "C. xerosis",
        "C. hofmannii",
      ],
      correct: "B"
    },
    {
      id: 70490,
      question: "Which Corynebacterium is found in the oral cavity?",
      options: [
        "C. diphtheriae",
        "C. matruchotti",
        "C. xerosis",
        "C. hofmannii",
      ],
      correct: "B"
    },
    {
      id: 70491,
      question: "What is the Gram stain characteristic of Propionibacteria?",
      options: [
        "Gram-negative aerobic bacilli",
        "Gram-positive anaerobic bacilli",
        "Gram-positive aerobic cocci",
        "Gram-negative anaerobic cocci",
      ],
      correct: "B"
    },
    {
      id: 70492,
      question: "What is the prototype species of Propionibacteria?",
      options: [
        "P. granulosum",
        "Propionibacterium acnes",
        "P. avidum",
        "P. propionicum",
      ],
      correct: "B"
    },
    {
      id: 70493,
      question: "What is the significant virulence factor of Propionibacterium acnes?",
      options: [
        "Coagulase",
        "Lipase",
        "Hemolysin",
        "Protease",
      ],
      correct: "B"
    },
    {
      id: 70494,
      question: "What do Actinomycetes resemble morphologically?",
      options: [
        "Typical bacteria",
        "Fungal hyphae",
        "Protozoa",
        "Viruses",
      ],
      correct: "B"
    },
    {
      id: 70495,
      question: "What is the Gram stain characteristic of Actinomycetes?",
      options: [
        "Gram-negative short rods",
        "Gram-positive long, branching filamentous bacteria",
        "Gram-positive cocci",
        "Gram-negative spiral bacteria",
      ],
      correct: "B"
    },
    {
      id: 70496,
      question: "What are the normal habitats of Actinomyces species?",
      options: [
        "Water and air",
        "Soil, mouth, female genital tract, and tonsillar crypts",
        "Blood and lymph",
        "Skin only",
      ],
      correct: "B"
    },
    {
      id: 70497,
      question: "Which Actinomyces species forms sulfur granules in lesions?",
      options: [
        "A. odontolyticus",
        "A. israelii",
        "A. naeslundii",
        "A. viscosus",
      ],
      correct: "B"
    },
    {
      id: 70498,
      question: "Which Actinomyces species can demineralize enamel?",
      options: [
        "A. israelii",
        "A. odontolyticus",
        "A. naeslundii",
        "A. viscosus",
      ],
      correct: "B"
    },
    {
      id: 70499,
      question: "What type of lesions do actinomycotic infections cause?",
      options: [
        "Acute superficial lesions",
        "Granulomatous and chronic lesions",
        "Vesicular lesions",
        "Ulcerative lesions",
      ],
      correct: "B"
    },
    {
      id: 70500,
      question: "Where are actinomycotic lesions typically located?",
      options: [
        "Upper jaw",
        "Orofacial region, particularly at one corner of the lower jaw",
        "Neck only",
        "Chest",
      ],
      correct: "B"
    },
    {
      id: 70501,
      question: "What antibiotics are recommended for actinomycosis treatment?",
      options: [
        "Vancomycin and metronidazole",
        "Penicillin, amoxicillin, and tetracyclines",
        "Ciprofloxacin and gentamicin",
        "Erythromycin only",
      ],
      correct: "B"
    },
    {
      id: 70502,
      question: "What is Nocardia asteroides the causative agent of?",
      options: [
        "Skin infection",
        "Nocardiosis (pulmonary infection)",
        "Intestinal infection",
        "Urinary infection",
      ],
      correct: "B"
    },
    {
      id: 70503,
      question: "What is the Gram stain characteristic of Clostridia?",
      options: [
        "Gram-negative aerobic bacilli",
        "Gram-positive anaerobic bacilli",
        "Gram-positive aerobic cocci",
        "Gram-negative anaerobic cocci",
      ],
      correct: "B"
    },
    {
      id: 70504,
      question: "Are Clostridia spore-forming?",
      options: [
        "No, they are non-sporing",
        "Yes, they are spore-forming",
        "Only some rare species",
        "Only in unfavorable conditions",
      ],
      correct: "B"
    },
    {
      id: 70505,
      question: "What are the normal habitats of Clostridia?",
      options: [
        "Human skin only",
        "Soil, water, decaying matter, and intestines",
        "Respiratory tract only",
        "Blood",
      ],
      correct: "B"
    },
    {
      id: 70506,
      question: "What are the normal habitats of Clostridium perfringens?",
      options: [
        "Respiratory tract",
        "Soil, large intestine, and vagina",
        "Skin only",
        "Oral cavity",
      ],
      correct: "B"
    },
    {
      id: 70507,
      question: "What type of toxin is α-toxin of C. perfringens?",
      options: [
        "Neurotoxin",
        "Phospholipase",
        "Hemolysin",
        "Enterotoxin",
      ],
      correct: "B"
    },
    {
      id: 70508,
      question: "How many types of C. perfringens are there?",
      options: [
        "Three (A-C)",
        "Five (A-E)",
        "Four (A-D)",
        "Six (A-F)",
      ],
      correct: "B"
    },
    {
      id: 70509,
      question: "Which type of C. perfringens is pathogenic in humans?",
      options: [
        "Type A",
        "Type B",
        "Type C",
        "Type E",
      ],
      correct: "A"
    },
    {
      id: 70510,
      question: "What is myonecrosis also known as?",
      options: [
        "Cellulitis",
        "Gas gangrene",
        "Abscess",
        "Necrotic fasciitis",
      ],
      correct: "B"
    },
    {
      id: 70511,
      question: "What causes crepitation in gas gangrene?",
      options: [
        "Fluid accumulation",
        "Gas production",
        "Tissue swelling",
        "Blood pooling",
      ],
      correct: "B"
    },
    {
      id: 70512,
      question: "What causes food poisoning from C. perfringens?",
      options: [
        "Exotoxin",
        "Enterotoxin",
        "Endotoxin",
        "Neurotoxin",
      ],
      correct: "B"
    },
    {
      id: 70513,
      question: "How is gas gangrene treated?",
      options: [
        "Antibiotics only",
        "Anti-α-toxin, antibiotics (metronidazole and penicillin), and wound debridement",
        "Surgery only",
        "Supportive care only",
      ],
      correct: "B"
    },
    {
      id: 70514,
      question: "What are the normal habitats of Clostridium tetani?",
      options: [
        "Human intestines only",
        "Soil and herbivores intestinal tract",
        "Water only",
        "Human skin",
      ],
      correct: "B"
    },
    {
      id: 70515,
      question: "What are the two toxins produced by C. tetani?",
      options: [
        "Alpha and beta toxin",
        "Tetanospasmin and tetanolysin",
        "Enterotoxin and cytotoxin",
        "Exotoxin A and B",
      ],
      correct: "B"
    },
    {
      id: 70516,
      question: "What type of toxin is tetanospasmin?",
      options: [
        "Enterotoxin",
        "Heat-labile neurotoxin",
        "Hemolysin",
        "Cytotoxin",
      ],
      correct: "B"
    },
    {
      id: 70517,
      question: "How does tetanospasmin travel in the body?",
      options: [
        "Through blood",
        "Retrograde neural movement from peripheral nerves to CNS",
        "Through lymph",
        "Through tissue spaces",
      ],
      correct: "B"
    },
    {
      id: 70518,
      question: "What does tetanospasmin block?",
      options: [
        "Excitatory neurotransmitters",
        "Inhibitory neurotransmitters",
        "Acetylcholine",
        "Dopamine",
      ],
      correct: "B"
    },
    {
      id: 70519,
      question: "What is trismus?",
      options: [
        "Body arching",
        "Jaw muscles spasm (lockjaw)",
        "Facial muscles spasm",
        "Respiratory muscle spasm",
      ],
      correct: "B"
    },
    {
      id: 70520,
      question: "What is risus sardonicus?",
      options: [
        "Body arching",
        "Facial muscles spasm",
        "Jaw muscles spasm",
        "Limb spasm",
      ],
      correct: "B"
    },
    {
      id: 70521,
      question: "What is opisthotonos?",
      options: [
        "Jaw muscles spasm",
        "Body arching",
        "Facial muscles spasm",
        "Neck stiffness",
      ],
      correct: "B"
    },
    {
      id: 70522,
      question: "How is tetanus treated?",
      options: [
        "Antibiotics only",
        "Antitoxin, penicillin, and wound debridement",
        "Surgery only",
        "Supportive care only",
      ],
      correct: "B"
    },
    {
      id: 70523,
      question: "What vaccine prevents tetanus?",
      options: [
        "BCG",
        "DPT vaccine",
        "MMR",
        "Hepatitis B",
      ],
      correct: "B"
    },
    {
      id: 70524,
      question: "What is the normal habitat of Clostridium difficile?",
      options: [
        "Soil",
        "Feces",
        "Skin",
        "Respiratory tract",
      ],
      correct: "B"
    },
    {
      id: 70525,
      question: "What disease does C. difficile cause?",
      options: [
        "Gas gangrene",
        "Antibiotic-associated colitis (pseudomembranous colitis)",
        "Tetanus",
        "Botulism",
      ],
      correct: "B"
    },
    {
      id: 70526,
      question: "Which antibiotic is associated with C. difficile infection?",
      options: [
        "Penicillin",
        "Clindamycin",
        "Erythromycin",
        "Vancomycin",
      ],
      correct: "B"
    },
    {
      id: 70527,
      question: "What are the best antibiotics for treating C. difficile infection?",
      options: [
        "Penicillin and erythromycin",
        "Vancomycin and metronidazole",
        "Ciprofloxacin and gentamicin",
        "Amoxicillin and clavulanate",
      ],
      correct: "B"
    },
    {
      id: 70528,
      question: "What disease does Clostridium botulinum cause?",
      options: [
        "Tetanus",
        "Botulism",
        "Gas gangrene",
        "Pseudomembranous colitis",
      ],
      correct: "B"
    },
    {
      id: 70529,
      question: "What is botox derived from?",
      options: [
        "C. tetani toxin",
        "C. botulinum toxin",
        "C. perfringens toxin",
        "C. difficile toxin",
      ],
      correct: "B"
    },
    {
      id: 70530,
      question: "What is the Gram stain characteristic of Bacillus species?",
      options: [
        "Gram-negative bacilli",
        "Gram-positive bacilli",
        "Gram-positive cocci",
        "Gram-negative cocci",
      ],
      correct: "B"
    },
    {
      id: 70531,
      question: "Are Bacillus species spore-forming?",
      options: [
        "No",
        "Yes",
        "Only B. anthracis",
        "Only B. cereus",
      ],
      correct: "B"
    },
    {
      id: 70532,
      question: "What is the function of the capsule in some Bacillus species?",
      options: [
        "Toxin production",
        "Antiphagocytic",
        "Adhesion",
        "Motility",
      ],
      correct: "B"
    },
    {
      id: 70533,
      question: "What is the normal habitat of Bacillus species?",
      options: [
        "Human skin",
        "Soil",
        "Water only",
        "Intestines only",
      ],
      correct: "B"
    },
    {
      id: 70534,
      question: "What disease does Bacillus anthracis cause?",
      options: [
        "Food poisoning",
        "Anthrax",
        "Botulism",
        "Tetanus",
      ],
      correct: "B"
    },
    {
      id: 70535,
      question: "How can anthrax be acquired?",
      options: [
        "Ingestion only",
        "Skin damage and respiratory tract",
        "Sexual contact",
        "Vector-borne transmission",
      ],
      correct: "B"
    },
    {
      id: 70536,
      question: "What does cutaneous anthrax result in?",
      options: [
        "Pneumonia",
        "Septicemia",
        "Meningitis",
        "Gastroenteritis",
      ],
      correct: "B"
    },
    {
      id: 70537,
      question: "What does respiratory anthrax lead to?",
      options: [
        "Septicemia",
        "Pneumonia",
        "Meningitis",
        "Skin lesions",
      ],
      correct: "B"
    },
    {
      id: 70538,
      question: "What disease does Bacillus cereus cause?",
      options: [
        "Anthrax",
        "Food-poisoning",
        "Tetanus",
        "Botulism",
      ],
      correct: "B"
    },
    {
      id: 70539,
      question: "What food is specifically associated with B. cereus food poisoning?",
      options: [
        "Meat",
        "Rice",
        "Dairy",
        "Eggs",
      ],
      correct: "B"
    },
    {
      id: 70540,
      question: "What are B. subtilis and B. stearothermophilus used as?",
      options: [
        "Probiotics",
        "Indicators of sterilization",
        "Vaccine production",
        "Antibiotic production",
      ],
      correct: "B"
    },
    {
      id: 70541,
      question: "Which of the following is a complication of S. pyogenes infection?",
      options: [
        "Urinary tract infection",
        "Erythema nodosum",
        "Pneumonia",
        "Meningitis",
      ],
      correct: "B"
    },
    {
      id: 70542,
      question: "What is the three different kinds of S. aureus typing?",
      options: [
        "Biochemical, morphological, genetic",
        "Phagetyping, serotyping, antibiotic susceptibility typing",
        "PCR, ELISA, culture",
        "Gram stain, acid-fast, spore stain",
      ],
      correct: "B"
    },
    {
      id: 70543,
      question: "Which enzyme of S. aureus breaks down penicillin?",
      options: [
        "Coagulase",
        "Penicillinase",
        "DNase",
        "Lipase",
      ],
      correct: "B"
    },
    {
      id: 70544,
      question: "What type of infections does multiresistance commonly occur in?",
      options: [
        "Community infections",
        "Nosocomial strains",
        "Pediatric infections",
        "Dental infections",
      ],
      correct: "B"
    },
    {
      id: 70545,
      question: "What can S. aureus infections lead to over time?",
      options: [
        "Complete cure always",
        "Chronic infections",
        "Immunity",
        "Self-resolution",
      ],
      correct: "B"
    },
    {
      id: 70546,
      question: "Which cytolysins are produced by S. pyogenes?",
      options: [
        "Alpha and beta toxin",
        "Hemolysins (streptolysin S and O) and leukocidins",
        "Enterotoxins",
        "Neurotoxins",
      ],
      correct: "B"
    },
    {
      id: 70547,
      question: "What infection does S. agalactiae cause in pregnant women?",
      options: [
        "Respiratory infection",
        "Gynecological sepsis and septic abortion",
        "Skin infection",
        "Urinary infection",
      ],
      correct: "B"
    },
    {
      id: 70548,
      question: "What is helpful for neonates to prevent S. agalactiae infection?",
      options: [
        "Vaccination",
        "Prophylactic antibiotics",
        "Isolation",
        "Antitoxin",
      ],
      correct: "B"
    },
    {
      id: 70549,
      question: "What is the prototype of oral streptococci?",
      options: [
        "S. mitis",
        "S. mutans",
        "S. salivarius",
        "S. anginosus",
      ],
      correct: "B"
    },
    {
      id: 70550,
      question: "What could be useful for endocarditis high-risk patients before dental procedures?",
      options: [
        "Antitoxin",
        "Prophylactic antibiotics",
        "Vaccination",
        "Isolation",
      ],
      correct: "B"
    },
    {
      id: 70551,
      question: "What infections does S. pneumoniae cause in children specifically?",
      options: [
        "Pneumonia and meningitis",
        "Otitis media and sinusitis",
        "Skin infections",
        "Gastrointestinal infections",
      ],
      correct: "B"
    },
    {
      id: 70552,
      question: "What are the three types of drug resistance among staphylococci?",
      options: [
        "Penicillin, tetracycline, aminoglycoside",
        "β-lactams, methicillin/nafcillin/oxacillin, vancomycin",
        "Macrolide, quinolone, sulfonamide",
        "Aminoglycoside, chloramphenicol, rifampin",
      ],
      correct: "B"
    },
    {
      id: 70553,
      question: "What is MRSA commonly called?",
      options: [
        "Killer bacteria",
        "Superbug",
        "Flesh-eating bacteria",
        "Hospital bacteria",
      ],
      correct: "B"
    },
    {
      id: 70554,
      question: "What is Actinomyces associated with regarding teeth?",
      options: [
        "Enamel formation",
        "Root surface caries",
        "Crown caries only",
        "Tooth development",
      ],
      correct: "B"
    },
    {
      id: 70555,
      question: "What maintains the homeostasis of the intestinal flora?",
      options: [
        "E. coli",
        "Lactobacilli",
        "Streptococci",
        "Staphylococci",
      ],
      correct: "B"
    },
    {
      id: 70556,
      question: "What typical diphtheroids are residents of conjunctiva and skin?",
      options: [
        "C. diphtheriae and C. ulcerans",
        "C. xerosis and C. hofmannii",
        "C. matruchotti and C. acnes",
        "C. jeikeium and C. urealyticum",
      ],
      correct: "B"
    },
    {
      id: 70557,
      question: "Where can rare cases of actinomycosis be seen besides the orofacial region?",
      options: [
        "Heart and brain",
        "Abdomen, lung, or skin",
        "Kidney and bladder",
        "Blood vessels",
      ],
      correct: "B"
    },
    {
      id: 70558,
      question: "What is the characteristic of actinomycotic lesions in patients?",
      options: [
        "Acute superficial lesions",
        "Chronic abscesses typically in patients with trauma",
        "Vesicular eruptions",
        "Ulcerative lesions",
      ],
      correct: "B"
    },
    {
      id: 70559,
      question: "How does Propionibacterium acnes relate to dental health?",
      options: [
        "Causes dental caries",
        "Associated with dental plaques",
        "Prevents plaque formation",
        "Treats gingivitis",
      ],
      correct: "B"
    },
  ],
  "6. Medical Bacteriology (Part 2)": [
    {
      id: 70500,
      question: "Which family includes Neisseria and Moraxella as Gram-negative, aerobic diplococci?",
      options: [
        "Enterobacteriaceae",
        "Neisseriaceae",
        "Vibrionaceae",
        "Bacteroidaceae",
      ],
      correct: "B"
    },
    {
      id: 70501,
      question: "What is the primary mode of transmission for Neisseria gonorrhoeae?",
      options: [
        "Respiratory droplets",
        "Contaminated water",
        "Sexual intercourse",
        "Fecal-oral route",
      ],
      correct: "C"
    },
    {
      id: 70502,
      question: "Which of the following is NOT a normal habitat of Neisseria gonorrhoeae?",
      options: [
        "Urogenital tract",
        "Mouth",
        "Gastrointestinal tract",
        "Nasopharynx",
      ],
      correct: "C"
    },
    {
      id: 70503,
      question: "Neisseria gonorrhoeae is the causative agent of which disease?",
      options: [
        "Meningitis",
        "Gonorrhea",
        "Cholera",
        "Plague",
      ],
      correct: "B"
    },
    {
      id: 70504,
      question: "Which complication can result from gonorrhea in women?",
      options: [
        "Adrenal hemorrhage",
        "Pelvic inflammatory disease (PID) and sterility",
        "Epiglottitis",
        "Duodenal ulcers",
      ],
      correct: "B"
    },
    {
      id: 70505,
      question: "Which virulence factor of N. gonorrhoeae damages the fallopian tubes and leads to sterility?",
      options: [
        "Pili",
        "IgA protease",
        "β-lactamase",
        "Cytotoxin",
      ],
      correct: "D"
    },
    {
      id: 70506,
      question: "What is the drug of choice for treating Neisseria gonorrhoeae infections?",
      options: [
        "Erythromycin",
        "Tetracycline",
        "Cephalosporins",
        "Metronidazole",
      ],
      correct: "C"
    },
    {
      id: 70507,
      question: "Which Neisseria species are part of the normal microflora of the oral mucosa?",
      options: [
        "N. gonorrhoeae and N. meningitidis",
        "N. sicca, N. mucosa, and N. subflava",
        "N. lactamica and N. pharyngis",
        "N. gonorrhoeae and N. sicca",
      ],
      correct: "B"
    },
    {
      id: 70508,
      question: "What is the normal habitat of Neisseria meningitidis?",
      options: [
        "Urogenital tract",
        "Gastrointestinal tract",
        "Nasopharynx",
        "Oral cavity",
      ],
      correct: "C"
    },
    {
      id: 70509,
      question: "How is Neisseria meningitidis transmitted?",
      options: [
        "Sexual intercourse",
        "Respiratory droplets",
        "Contaminated food",
        "Direct contact with wounds",
      ],
      correct: "B"
    },
    {
      id: 70510,
      question: "What is the main virulence factor of Neisseria meningitidis?",
      options: [
        "Cytotoxin",
        "Capsule",
        "Endotoxin",
        "Pili",
      ],
      correct: "C"
    },
    {
      id: 70511,
      question: "Death from N. meningitidis infection is primarily due to which conditions?",
      options: [
        "Pneumonia or bronchitis",
        "Meningitis or adrenal hemorrhage",
        "Septic arthritis or endocarditis",
        "Gastroenteritis or cholera",
      ],
      correct: "B"
    },
    {
      id: 70512,
      question: "What is Waterhouse-Friderichsen Syndrome associated with?",
      options: [
        "Neisseria gonorrhoeae infection",
        "Adrenal hemorrhage from N. meningitidis",
        "Pelvic inflammatory disease",
        "Localized aggressive periodontitis",
      ],
      correct: "B"
    },
    {
      id: 70513,
      question: "Which characteristics differentiate N. meningitidis from N. gonorrhoeae?",
      options: [
        "N. meningitidis is capsulated; N. gonorrhoeae is non-capsulated",
        "N. meningitidis is non-capsulated; N. gonorrhoeae is capsulated",
        "Both are capsulated",
        "Both are non-capsulated",
      ],
      correct: "A"
    },
    {
      id: 70514,
      question: "What are the drugs of choice for Neisseria meningitidis infection?",
      options: [
        "Tetracycline and erythromycin",
        "Penicillin and cefotaxime",
        "Metronidazole and clindamycin",
        "Aminoglycosides and polymixin",
      ],
      correct: "B"
    },
    {
      id: 70515,
      question: "What is the Gram stain characteristic and oxygen requirement of Veillonella?",
      options: [
        "Gram-positive, aerobic cocci",
        "Gram-negative, aerobic cocci",
        "Gram-positive, anaerobic cocci",
        "Gram-negative, anaerobic cocci",
      ],
      correct: "D"
    },
    {
      id: 70516,
      question: "What is the primary habitat of Veillonella species?",
      options: [
        "Gastrointestinal tract",
        "Oral cavity, especially dental plaque",
        "Urogenital tract",
        "Respiratory tract",
      ],
      correct: "B"
    },
    {
      id: 70517,
      question: "What beneficial role do Veillonella species play in the oral cavity?",
      options: [
        "They produce antimicrobial peptides",
        "They convert lactic acid to weaker acids that are less capable of degrading enamel",
        "They strengthen tooth enamel",
        "They kill cariogenic bacteria",
      ],
      correct: "B"
    },
    {
      id: 70518,
      question: "Which Veillonella species is considered the prototype?",
      options: [
        "V. dispar",
        "V. atypica",
        "V. parvula",
        "V. ratti",
      ],
      correct: "C"
    },
    {
      id: 70519,
      question: "Which group of bacteria are Gram-negative bacilli that include Haemophilus, Brucella, and Bordetella?",
      options: [
        "Enterobacteriaceae",
        "Parvobacteria",
        "Vibrionaceae",
        "Neisseriaceae",
      ],
      correct: "B"
    },
    {
      id: 70520,
      question: "What growth factors does Haemophilus influenzae require?",
      options: [
        "Vitamin K and hemin",
        "X factor (hematin) and V factor (NAD or NADP)",
        "Glucose and lactose",
        "Iron and zinc",
      ],
      correct: "B"
    },
    {
      id: 70521,
      question: "What is the morphology of Haemophilus influenzae?",
      options: [
        "Gram-positive cocci",
        "Gram-negative coccobacilli",
        "Gram-negative curved bacilli",
        "Gram-positive bacilli",
      ],
      correct: "B"
    },
    {
      id: 70522,
      question: "Which of the following is NOT an infection caused by H. influenzae?",
      options: [
        "Meningitis",
        "Epiglottitis",
        "Gonorrhea",
        "Arthritis",
      ],
      correct: "C"
    },
    {
      id: 70523,
      question: "Which virulence factor is NOT associated with Haemophilus influenzae?",
      options: [
        "IgA protease",
        "Capsule",
        "Cytotoxin",
        "Endotoxin",
      ],
      correct: "C"
    },
    {
      id: 70524,
      question: "What antibiotic is a good candidate for treating H. influenzae infections?",
      options: [
        "Metronidazole",
        "Ampicillin",
        "Clindamycin",
        "Vancomycin",
      ],
      correct: "B"
    },
    {
      id: 70525,
      question: "The Hib vaccine provides prevention against which type of H. influenzae?",
      options: [
        "Type a",
        "Type b",
        "Type c",
        "Type d",
      ],
      correct: "B"
    },
    {
      id: 70526,
      question: "Which prophylactic antibiotic is given to individuals who have had close contact with H. influenzae meningitis patients?",
      options: [
        "Penicillin",
        "Erythromycin",
        "Rifampin",
        "Tetracycline",
      ],
      correct: "C"
    },
    {
      id: 70527,
      question: "What disease is caused by Bordetella pertussis?",
      options: [
        "Typhoid fever",
        "Whooping cough (pertussis)",
        "Cholera",
        "Plague",
      ],
      correct: "B"
    },
    {
      id: 70528,
      question: "What is the characteristic cough pattern in pertussis?",
      options: [
        "Dry cough without whoop",
        "Productive cough with blood",
        "Paroxysmal cough with whoop",
        "Chronic mild cough",
      ],
      correct: "C"
    },
    {
      id: 70529,
      question: "Which virulence factor is NOT associated with Bordetella pertussis?",
      options: [
        "Fimbrial antigen",
        "Tracheal cytotoxin",
        "Leukotoxin",
        "Endotoxin",
      ],
      correct: "C"
    },
    {
      id: 70530,
      question: "What is the drug of choice for treating pertussis?",
      options: [
        "Penicillin",
        "Tetracycline",
        "Erythromycin",
        "Ampicillin",
      ],
      correct: "C"
    },
    {
      id: 70531,
      question: "Which vaccine provides prevention against Bordetella pertussis?",
      options: [
        "Hib vaccine",
        "BCG vaccine",
        "DPT vaccine",
        "MMR vaccine",
      ],
      correct: "C"
    },
    {
      id: 70532,
      question: "What is the colony morphology of Aggregatibacter actinomycetemcomitans?",
      options: [
        "Round-shaped",
        "Star-shaped",
        "Square-shaped",
        "Filamentous",
      ],
      correct: "B"
    },
    {
      id: 70533,
      question: "What is the normal habitat of Aggregatibacter actinomycetemcomitans?",
      options: [
        "Intestinal tract",
        "Respiratory tract",
        "Oral cavity (supragingival sites)",
        "Urogenital tract",
      ],
      correct: "C"
    },
    {
      id: 70534,
      question: "Aggregatibacter actinomycetemcomitans is usually isolated with which other bacterial genus?",
      options: [
        "Streptococcus",
        "Actinomyces",
        "Lactobacillus",
        "Veillonella",
      ],
      correct: "B"
    },
    {
      id: 70535,
      question: "What dental condition is caused by A. actinomycetemcomitans in adolescents?",
      options: [
        "Dental caries",
        "Localized aggressive periodontitis",
        "Gingivitis",
        "Oral candidiasis",
      ],
      correct: "B"
    },
    {
      id: 70536,
      question: "Which tooth is characteristically affected in localized aggressive periodontitis caused by A. actinomycetemcomitans?",
      options: [
        "Tooth 1",
        "Tooth 3",
        "Tooth 6",
        "Tooth 14",
      ],
      correct: "C"
    },
    {
      id: 70537,
      question: "Which virulence factor of A. actinomycetemcomitans induces bone resorption?",
      options: [
        "Leukotoxin",
        "Collagenase",
        "Epitheliotoxin-bone resorption-inducing factor",
        "Cytolethal distending toxin",
      ],
      correct: "C"
    },
    {
      id: 70538,
      question: "What is the drug of choice for treating A. actinomycetemcomitans infections?",
      options: [
        "Erythromycin",
        "Metronidazole",
        "Tetracycline",
        "Penicillin",
      ],
      correct: "C"
    },
    {
      id: 70539,
      question: "What is the Gram stain and oxygen requirement of Eikenella corrodens?",
      options: [
        "Gram-positive, aerobic",
        "Gram-negative, capnophilic",
        "Gram-positive, anaerobic",
        "Gram-negative, strictly anaerobic",
      ],
      correct: "B"
    },
    {
      id: 70540,
      question: "What are the normal habitats of Eikenella corrodens?",
      options: [
        "Respiratory tract and skin",
        "Intestine and oral cavity",
        "Urogenital tract and blood",
        "Nasopharynx and conjunctiva",
      ],
      correct: "B"
    },
    {
      id: 70541,
      question: "Which condition is NOT caused by Eikenella corrodens?",
      options: [
        "Brain abscess",
        "Meningitis",
        "Cholera",
        "Endocarditis",
      ],
      correct: "C"
    },
    {
      id: 70542,
      question: "What is the morphology of Capnocytophaga?",
      options: [
        "Gram-positive cocci",
        "Gram-negative fusiforms",
        "Gram-positive bacilli",
        "Gram-negative curved bacilli",
      ],
      correct: "B"
    },
    {
      id: 70543,
      question: "What is the normal habitat of Capnocytophaga species?",
      options: [
        "Supragingival area",
        "Subgingival area",
        "Intestinal tract",
        "Respiratory tract",
      ],
      correct: "B"
    },
    {
      id: 70544,
      question: "Which is the prototype species of Capnocytophaga?",
      options: [
        "C. gingivalis",
        "C. sputigena",
        "C. ochracea",
        "C. granulosa",
      ],
      correct: "C"
    },
    {
      id: 70545,
      question: "What is the significant virulence factor of Capnocytophaga?",
      options: [
        "Leukotoxin",
        "IgA protease",
        "Collagenase",
        "Capsule",
      ],
      correct: "B"
    },
    {
      id: 70546,
      question: "In which patient population does Capnocytophaga cause systemic infections?",
      options: [
        "Elderly patients",
        "Immunocompromised patients",
        "Pregnant women",
        "Athletes",
      ],
      correct: "B"
    },
    {
      id: 70547,
      question: "What is the Gram stain and oxygen requirement of Enterobacteriaceae?",
      options: [
        "Gram-positive, aerobic",
        "Gram-negative, strictly anaerobic",
        "Gram-negative, facultative anaerobe",
        "Gram-positive, facultative anaerobe",
      ],
      correct: "C"
    },
    {
      id: 70548,
      question: "What is the normal habitat of Enterobacteriaceae?",
      options: [
        "Respiratory tract",
        "Gastrointestinal tract",
        "Urogenital tract",
        "Skin",
      ],
      correct: "B"
    },
    {
      id: 70549,
      question: "How are Enterobacteriaceae transmitted?",
      options: [
        "Respiratory droplets",
        "Sexual contact",
        "Tainted food and fecal-oral route",
        "Insect vectors",
      ],
      correct: "C"
    },
    {
      id: 70550,
      question: "What is the most significant virulence factor of Enterobacteriaceae?",
      options: [
        "Capsule",
        "Endotoxin (LPS)",
        "Exotoxin",
        "Flagellum",
      ],
      correct: "B"
    },
    {
      id: 70551,
      question: "Which component of endotoxin is responsible for endotoxic shock?",
      options: [
        "O antigen",
        "Polysaccharide",
        "Lipid A",
        "Core oligosaccharide",
      ],
      correct: "C"
    },
    {
      id: 70552,
      question: "What are the clinical features of endotoxic shock?",
      options: [
        "Cough, rhinorrhea, and sore throat",
        "Fever, hypotension, DIC, and death",
        "Rash, joint pain, and photophobia",
        "Diarrhea, vomiting, and abdominal pain",
      ],
      correct: "B"
    },
    {
      id: 70553,
      question: "Which type of E. coli is considered the prototype for causing diarrhea?",
      options: [
        "EHEC E. coli",
        "EIEC E. coli",
        "ETEC E. coli",
        "EPEC E. coli",
      ],
      correct: "D"
    },
    {
      id: 70554,
      question: "What are the enterotoxins produced by pathogenic E. coli?",
      options: [
        "Alpha and beta toxins",
        "LT (heat-labile) and ST (heat-stable)",
        "Toxin A and Toxin B",
        "Endotoxin and exotoxin",
      ],
      correct: "B"
    },
    {
      id: 70555,
      question: "What cells are used to detect verotoxin (Vero cytotoxicity) of E. coli?",
      options: [
        "HeLa cells",
        "Vero cells",
        "CHO cells",
        "L929 cells",
      ],
      correct: "B"
    },
    {
      id: 70556,
      question: "Which E. coli infection is particularly common in elderly adults and young women?",
      options: [
        "Neonatal meningitis",
        "Urinary tract infection",
        "Diarrhea",
        "Septicemia",
      ],
      correct: "B"
    },
    {
      id: 70557,
      question: "What is enteric fever also known as?",
      options: [
        "Cholera",
        "Typhoid fever",
        "Dysentery",
        "Gastroenteritis",
      ],
      correct: "B"
    },
    {
      id: 70558,
      question: "Which Salmonella species causes enteric fever (typhoid fever)?",
      options: [
        "S. enteritidis",
        "S. choleraesuis",
        "S. typhi",
        "S. dublin",
      ],
      correct: "C"
    },
    {
      id: 70559,
      question: "Which Salmonella species causes gastroenteritis with nausea, cramps, vomiting, and diarrhea?",
      options: [
        "S. typhi",
        "S. paratyphi",
        "S. enteritidis",
        "S. choleraesuis",
      ],
      correct: "C"
    },
    {
      id: 70560,
      question: "Which Salmonella species causes septicemia?",
      options: [
        "S. typhi",
        "S. enteritidis",
        "S. choleraesuis",
        "S. paratyphi",
      ],
      correct: "C"
    },
    {
      id: 70561,
      question: "What occupation is associated with increased risk of salmonellosis from poultry products?",
      options: [
        "Healthcare workers",
        "Veterinary and slaughterhouse workers",
        "Teachers",
        "Construction workers",
      ],
      correct: "B"
    },
    {
      id: 70562,
      question: "How many medically important Shigella species are mentioned?",
      options: [
        "Two",
        "Three",
        "Four",
        "Five",
      ],
      correct: "C"
    },
    {
      id: 70563,
      question: "What type of diarrhea is caused by Shigella species?",
      options: [
        "Watery diarrhea",
        "Bloody diarrhea (bacillary dysentery)",
        "Fatty diarrhea",
        "Mucoid diarrhea",
      ],
      correct: "B"
    },
    {
      id: 70564,
      question: "Which part of the intestine do Shigella species invade?",
      options: [
        "Stomach and duodenum",
        "Ileum and colon",
        "Jejunum only",
        "Cecum only",
      ],
      correct: "B"
    },
    {
      id: 70565,
      question: "What is the significant virulence factor of Shigella?",
      options: [
        "Enterotoxin",
        "Endotoxin",
        "Neurotoxin",
        "Cytotoxin",
      ],
      correct: "C"
    },
    {
      id: 70566,
      question: "What is the best treatment for Shigella infection?",
      options: [
        "Antibiotic therapy",
        "Electrolyte therapy",
        "Antiviral therapy",
        "Surgery",
      ],
      correct: "B"
    },
    {
      id: 70567,
      question: "What is the significant virulence factor of Klebsiella pneumoniae?",
      options: [
        "Endotoxin",
        "Neurotoxin",
        "Capsule",
        "Flagellum",
      ],
      correct: "C"
    },
    {
      id: 70568,
      question: "Which infections are caused by Klebsiella pneumoniae?",
      options: [
        "Gonorrhea and syphilis",
        "Pneumonia and UTI",
        "Meningitis and encephalitis",
        "Cholera and dysentery",
      ],
      correct: "B"
    },
    {
      id: 70569,
      question: "What are the normal habitats of Klebsiella pneumoniae?",
      options: [
        "Skin and blood",
        "Intestinal tract, respiratory tract, and oral cavity",
        "Urogenital tract only",
        "Nervous system",
      ],
      correct: "B"
    },
    {
      id: 70570,
      question: "Which organisms have plants as one of their normal habitats?",
      options: [
        "Escherichia coli",
        "Enterobacter species",
        "Salmonella species",
        "Shigella species",
      ],
      correct: "B"
    },
    {
      id: 70571,
      question: "What infection is caused by Serratia marcescens?",
      options: [
        "Mild gastroenteritis",
        "Fatal diseases in neonates and immunocompromised individuals",
        "Dental caries",
        "Common cold",
      ],
      correct: "B"
    },
    {
      id: 70572,
      question: "What infection is primarily caused by Proteus species?",
      options: [
        "Pneumonia",
        "Meningitis",
        "Urinary tract infection",
        "Gastroenteritis",
      ],
      correct: "C"
    },
    {
      id: 70573,
      question: "What disease is caused by Yersinia pestis?",
      options: [
        "Cholera",
        "Typhoid fever",
        "Plague",
        "Dysentery",
      ],
      correct: "C"
    },
    {
      id: 70574,
      question: "What is the Gram stain and oxygen requirement of Pseudomonas aeruginosa?",
      options: [
        "Gram-positive, anaerobic",
        "Gram-negative, aerobic",
        "Gram-positive, aerobic",
        "Gram-negative, anaerobic",
      ],
      correct: "B"
    },
    {
      id: 70575,
      question: "Where can Pseudomonas aeruginosa be found in dental settings?",
      options: [
        "Dental instruments",
        "Dental unit water lines",
        "Dental chair upholstery",
        "Dental impression materials",
      ],
      correct: "B"
    },
    {
      id: 70576,
      question: "What type of infections is Pseudomonas aeruginosa most importantly associated with?",
      options: [
        "Sexually transmitted infections",
        "Nosocomial infections",
        "Vector-borne infections",
        "Congenital infections",
      ],
      correct: "B"
    },
    {
      id: 70577,
      question: "Which of the following is NOT a virulence factor of Pseudomonas aeruginosa?",
      options: [
        "Protease",
        "Elastase",
        "Neurotoxin",
        "Antiphagocytic extracellular slime layer",
      ],
      correct: "C"
    },
    {
      id: 70578,
      question: "What are the best drugs for treating Pseudomonas aeruginosa infections?",
      options: [
        "Penicillin and erythromycin",
        "Aminoglycosides, piperacillin, polymixin, and cephalosporins",
        "Tetracycline and metronidazole",
        "Vancomycin and clindamycin",
      ],
      correct: "B"
    },
    {
      id: 70579,
      question: "What is the morphology of Vibrio species?",
      options: [
        "Straight bacilli",
        "Curved (comma-shaped) bacilli",
        "Cocci",
        "Filamentous",
      ],
      correct: "B"
    },
    {
      id: 70580,
      question: "What is the normal habitat of Vibrio species?",
      options: [
        "Respiratory tract",
        "Oral cavity",
        "Contaminated water",
        "Skin",
      ],
      correct: "C"
    },
    {
      id: 70581,
      question: "What disease does Vibrio cholerae cause?",
      options: [
        "Typhoid fever",
        "Dysentery",
        "Cholera",
        "Plague",
      ],
      correct: "C"
    },
    {
      id: 70582,
      question: "What is the significant virulence factor of V. cholerae?",
      options: [
        "Neurotoxin",
        "Endotoxin",
        "Enterotoxin",
        "Cytotoxin",
      ],
      correct: "C"
    },
    {
      id: 70583,
      question: "What is the mechanism of action of V. cholerae enterotoxin?",
      options: [
        "Inhibits protein synthesis",
        "Activates adenylate cyclase leading to cAMP accumulation and water/electrolyte excretion",
        "Damages cell membranes directly",
        "Blocks nerve impulses",
      ],
      correct: "B"
    },
    {
      id: 70584,
      question: "What is the recommended treatment for cholera?",
      options: [
        "Antibiotics only",
        "Intravenous electrolytes and ORS",
        "Antiviral medications",
        "Surgery",
      ],
      correct: "B"
    },
    {
      id: 70585,
      question: "What causes mild diarrhea from seafood consumption?",
      options: [
        "V. cholerae",
        "V. parahaemolyticus",
        "V. vulnificus",
        "V. alginolyticus",
      ],
      correct: "B"
    },
    {
      id: 70586,
      question: "What is the normal habitat of Campylobacter species?",
      options: [
        "Contaminated water",
        "Animals (contaminated food and milk)",
        "Oral cavity",
        "Respiratory tract",
      ],
      correct: "B"
    },
    {
      id: 70587,
      question: "Which Campylobacter species causes self-limiting gastroenteritis, especially in children?",
      options: [
        "C. fetus",
        "C. rectus",
        "C. jejuni",
        "C. coli",
      ],
      correct: "C"
    },
    {
      id: 70588,
      question: "Which Campylobacter species has a strong enterotoxin?",
      options: [
        "C. jejuni",
        "C. fetus",
        "C. rectus",
        "C. coli",
      ],
      correct: "B"
    },
    {
      id: 70589,
      question: "Which Campylobacter species causes periodontal diseases?",
      options: [
        "C. jejuni",
        "C. fetus",
        "C. rectus",
        "C. coli",
      ],
      correct: "C"
    },
    {
      id: 70590,
      question: "What conditions are caused by Helicobacter pylori?",
      options: [
        "Cholera and dysentery",
        "Gastritis, duodenal ulcers, and gastric cancers",
        "Pneumonia and bronchitis",
        "Meningitis and encephalitis",
      ],
      correct: "B"
    },
    {
      id: 70591,
      question: "What is the normal habitat of Wolinella species?",
      options: [
        "Intestinal tract",
        "Respiratory tract",
        "Oral cavity, especially gingival sulcus",
        "Urogenital tract",
      ],
      correct: "C"
    },
    {
      id: 70592,
      question: "Which Wolinella species may cause periodontal diseases?",
      options: [
        "W. recta",
        "W. succinogenes",
        "W. curva",
        "W. gracilis",
      ],
      correct: "B"
    },
    {
      id: 70593,
      question: "What is the Gram stain and oxygen requirement of Bacteroides fragilis?",
      options: [
        "Gram-positive, aerobic",
        "Gram-negative, aerobic",
        "Gram-positive, anaerobic",
        "Gram-negative, anaerobic",
      ],
      correct: "D"
    },
    {
      id: 70594,
      question: "What is the normal habitat of Bacteroides fragilis?",
      options: [
        "Oral cavity",
        "Respiratory tract",
        "Intestine",
        "Skin",
      ],
      correct: "C"
    },
    {
      id: 70595,
      question: "Which virulence factors are associated with Bacteroides fragilis?",
      options: [
        "Pili, IgA protease, and cytotoxin",
        "Capsule, endotoxin, and proteases",
        "Fimbriae, leukotoxin, and collagenase",
        "Flagella, enterotoxin, and elastase",
      ],
      correct: "B"
    },
    {
      id: 70596,
      question: "What infections are caused by Bacteroides fragilis?",
      options: [
        "Urinary tract infections and pneumonia",
        "Intra-abdominal infections, liver abscesses, and peritonitis",
        "Meningitis and encephalitis",
        "Gonorrhea and syphilis",
      ],
      correct: "B"
    },
    {
      id: 70597,
      question: "What are the drugs of choice for Bacteroides fragilis infections?",
      options: [
        "Penicillin and ampicillin",
        "Metronidazole and clindamycin",
        "Tetracycline and erythromycin",
        "Cephalosporins and aminoglycosides",
      ],
      correct: "B"
    },
    {
      id: 70598,
      question: "What is the normal habitat of Tannerella forsythia?",
      options: [
        "Intestinal tract",
        "Respiratory tract",
        "Subgingival site",
        "Supragingival site",
      ],
      correct: "C"
    },
    {
      id: 70599,
      question: "Which virulence factor is unique to Tannerella forsythia among the bacteria discussed?",
      options: [
        "Endotoxin",
        "Methylglyoxal secretion",
        "Capsule",
        "Protease",
      ],
      correct: "B"
    },
    {
      id: 70600,
      question: "What is the morphology of Porphyromonas gingivalis?",
      options: [
        "Gram-positive cocci",
        "Gram-negative coccobacilli",
        "Gram-positive bacilli",
        "Gram-negative curved bacilli",
      ],
      correct: "B"
    },
    {
      id: 70601,
      question: "What is the normal habitat of Porphyromonas gingivalis?",
      options: [
        "Supragingival site",
        "Subgingival site",
        "Intestinal tract",
        "Respiratory tract",
      ],
      correct: "B"
    },
    {
      id: 70602,
      question: "What term is used to describe P. gingivalis as a periodontal pathogen?",
      options: [
        "Primary pathogen",
        "Opportunistic pathogen",
        "Consensus periodontal pathogen (periodontopathic organism)",
        "Commensal organism",
      ],
      correct: "C"
    },
    {
      id: 70603,
      question: "Which of the following is NOT a virulence factor of Porphyromonas gingivalis?",
      options: [
        "Capsule",
        "Fimbriae",
        "Leukotoxin",
        "Collagenase",
      ],
      correct: "C"
    },
    {
      id: 70604,
      question: "What enzyme produced by P. gingivalis breaks down fibrin?",
      options: [
        "Collagenase",
        "Phospholipase",
        "Fibrinolysin",
        "Hemolysin",
      ],
      correct: "C"
    },
    {
      id: 70605,
      question: "What is the normal habitat of Prevotella species?",
      options: [
        "Intestinal tract",
        "Respiratory tract",
        "Oral cavity (subgingival sites)",
        "Urogenital tract",
      ],
      correct: "C"
    },
    {
      id: 70606,
      question: "Which Prevotella species is considered the prototype?",
      options: [
        "P. intermedia",
        "P. melaninogenica",
        "P. nigrescens",
        "P. denticola",
      ],
      correct: "B"
    },
    {
      id: 70607,
      question: "Which Prevotella species causes periodontal diseases?",
      options: [
        "P. melaninogenica",
        "P. intermedia",
        "P. oralis",
        "P. buccae",
      ],
      correct: "B"
    },
    {
      id: 70608,
      question: "How do the virulence factors of Prevotella compare to P. gingivalis?",
      options: [
        "Prevotella has completely different virulence factors",
        "Prevotella has no virulence factors",
        "Prevotella virulence factors are the same as P. gingivalis",
        "Prevotella has only capsule as a virulence factor",
      ],
      correct: "C"
    },
    {
      id: 70609,
      question: "Which organism is described as non-motile, non-sporing, and non-capsulated among the periodontal pathogens?",
      options: [
        "Bacteroides fragilis",
        "Porphyromonas gingivalis",
        "Tannerella forsythia",
        "Aggregatibacter actinomycetemcomitans",
      ],
      correct: "C"
    },
    {
      id: 70610,
      question: "Which bacteria convert lactic acid produced by cariogenic bacteria to weaker acids?",
      options: [
        "Streptococcus mutans",
        "Veillonella species",
        "Lactobacillus species",
        "Actinomyces species",
      ],
      correct: "B"
    },
    {
      id: 70611,
      question: "Which organism requires capnophilic conditions for growth?",
      options: [
        "Pseudomonas aeruginosa",
        "Eikenella corrodens",
        "Bacteroides fragilis",
        "Vibrio cholerae",
      ],
      correct: "B"
    },
    {
      id: 70612,
      question: "What type of periodontitis does A. actinomycetemcomitans cause in adults?",
      options: [
        "Chronic periodontitis",
        "Localized aggressive periodontitis",
        "Rapidly destructive periodontitis (generalized)",
        "Necrotizing periodontitis",
      ],
      correct: "C"
    },
    {
      id: 70613,
      question: "Which organism produces cytolethal distending toxin (CDT)?",
      options: [
        "Porphyromonas gingivalis",
        "Aggregatibacter actinomycetemcomitans",
        "Prevotella intermedia",
        "Tannerella forsythia",
      ],
      correct: "B"
    },
    {
      id: 70614,
      question: "What is the oxygen requirement of Capnocytophaga?",
      options: [
        "Strictly aerobic",
        "Strictly anaerobic",
        "Capnophilic",
        "Facultative anaerobe",
      ],
      correct: "C"
    },
    {
      id: 70615,
      question: "Which organism has an antiphagocytic extracellular slime layer?",
      options: [
        "Escherichia coli",
        "Pseudomonas aeruginosa",
        "Klebsiella pneumoniae",
        "Salmonella typhi",
      ],
      correct: "B"
    },
    {
      id: 70616,
      question: "What structural feature do many Enterobacteriaceae possess?",
      options: [
        "Only flagellum",
        "Only capsule",
        "Flagellum, pilus, and capsule",
        "None of the above",
      ],
      correct: "C"
    },
    {
      id: 70617,
      question: "Which Shigella species is NOT mentioned in the document?",
      options: [
        "S. dysenteriae",
        "S. sonnei",
        "S. typhi",
        "S. flexneri",
      ],
      correct: "C"
    },
    {
      id: 70618,
      question: "What is a characteristic feature of Vibrio species regarding motility?",
      options: [
        "Non-motile",
        "Low motility",
        "High motility",
        "Variable motility",
      ],
      correct: "C"
    },
    {
      id: 70619,
      question: "Which statement about N. gonorrhoeae is correct?",
      options: [
        "It is motile and capsulated",
        "It is non-motile and non-capsulated",
        "It is motile and non-capsulated",
        "It is non-motile and capsulated",
      ],
      correct: "B"
    },
    {
      id: 70620,
      question: "What is the characteristic watery diarrhea caused by V. cholerae called?",
      options: [
        "Dysentery",
        "Gastroenteritis",
        "Cholera",
        "Typhoid",
      ],
      correct: "C"
    },
    {
      id: 70621,
      question: "Which enzyme produced by P. gingivalis breaks down collagen?",
      options: [
        "Phospholipase",
        "Fibrinolysin",
        "Collagenase",
        "Hemolysin",
      ],
      correct: "C"
    },
    {
      id: 70622,
      question: "What type of disease does Capnocytophaga cause in healthy individuals?",
      options: [
        "Systemic infections",
        "Gingivitis",
        "Pneumonia",
        "Meningitis",
      ],
      correct: "B"
    },
    {
      id: 70623,
      question: "Which bacteria is associated with the production of protease that cleaves IgG?",
      options: [
        "Porphyromonas gingivalis",
        "Aggregatibacter actinomycetemcomitans",
        "Prevotella intermedia",
        "Capnocytophaga ochracea",
      ],
      correct: "B"
    },
    {
      id: 70624,
      question: "What distinguishes Prevotella species isolated from healthy gingival sites?",
      options: [
        "They cause severe periodontitis",
        "They do not cause periodontal diseases like P. intermedia does",
        "They produce strong toxins",
        "They are all pathogenic",
      ],
      correct: "B"
    },
    {
      id: 70625,
      question: "Which morphology is characteristic of Haemophilus influenzae?",
      options: [
        "Diplococci",
        "Coccobacilli",
        "Curved bacilli",
        "Fusiforms",
      ],
      correct: "B"
    },
    {
      id: 70626,
      question: "What is the causative agent of neonatal meningitis among E. coli infections?",
      options: [
        "EPEC E. coli",
        "ETEC E. coli",
        "E. coli (general, after wound infection)",
        "EHEC E. coli",
      ],
      correct: "C"
    },
    {
      id: 70627,
      question: "Which bacteria has dental unit water lines as one of its normal habitats?",
      options: [
        "Streptococcus mutans",
        "Pseudomonas aeruginosa",
        "Lactobacillus species",
        "Veillonella parvula",
      ],
      correct: "B"
    },
    {
      id: 70628,
      question: "What antibiotics are included in the broad-spectrum treatment for Enterobacteriaceae?",
      options: [
        "Penicillin only",
        "Metronidazole and clindamycin",
        "Ampicillin, amoxicillin, cephalosporins, trimethoprim, chloramphenicol, aminoglycosides, and ciprofloxacin",
        "Erythromycin and tetracycline only",
      ],
      correct: "C"
    },
    {
      id: 70629,
      question: "Which Salmonella species can cause both enteric fever?",
      options: [
        "S. enteritidis and S. choleraesuis",
        "S. typhi and S. paratyphi",
        "S. dublin and S. enteritidis",
        "S. typhimurium and S. newport",
      ],
      correct: "B"
    },
    {
      id: 70630,
      question: "What is the oxygen requirement of Porphyromonas gingivalis?",
      options: [
        "Aerobic",
        "Facultative anaerobe",
        "Anaerobic",
        "Capnophilic",
      ],
      correct: "C"
    },
    {
      id: 70631,
      question: "Which organism is capsulated among Bacteroides fragilis, Tannerella forsythia, and Prevotella?",
      options: [
        "Tannerella forsythia only",
        "Prevotella only",
        "Bacteroides fragilis only",
        "All three are capsulated",
      ],
      correct: "C"
    },
    {
      id: 70632,
      question: "What is the reference textbook mentioned for this material?",
      options: [
        "Robbins Pathology",
        "Essential Microbiology for Dentistry by Samaranayake",
        "Medical Microbiology by Jawetz",
        "Murray\'s Medical Microbiology",
      ],
      correct: "B"
    },
  ],
  "7. Medical Bacteriology (Part 3)": [
    {
      id: 70600,
      question: "What is the morphology of Fusobacteria?",
      options: [
        "Gram-positive cocci",
        "Gram-negative fusiform bacilli (cigar-shaped)",
        "Gram-positive bacilli",
        "Gram-negative curved bacilli",
      ],
      correct: "B"
    },
    {
      id: 70601,
      question: "What is the oxygen requirement of Fusobacteria?",
      options: [
        "Aerobic",
        "Facultative anaerobe",
        "Anaerobic",
        "Capnophilic",
      ],
      correct: "C"
    },
    {
      id: 70602,
      question: "Which of the following is NOT a normal habitat of Fusobacteria?",
      options: [
        "Oral cavity",
        "Large intestine",
        "Female genital tract",
        "Respiratory tract",
      ],
      correct: "D"
    },
    {
      id: 70603,
      question: "Which Fusobacterium species are associated with periodontal diseases?",
      options: [
        "F. nucleatum, F. periodontium, and F. simiae",
        "F. mortiferum and F. varium",
        "F. necrophorum and F. russii",
        "F. gonidiaformans and F. ulcerans",
      ],
      correct: "A"
    },
    {
      id: 70604,
      question: "What is the normal habitat of Fusobacterium nucleatum in the oral cavity?",
      options: [
        "Tongue dorsum only",
        "Healthy gingival crevice and periodontal pockets",
        "Hard palate only",
        "Buccal mucosa only",
      ],
      correct: "B"
    },
    {
      id: 70605,
      question: "What term describes infections caused by the combination of fusobacteria and spirochetes?",
      options: [
        "Polymicrobial infections",
        "Fusospirochetal infections",
        "Synergistic infections",
        "Mixed anaerobic infections",
      ],
      correct: "B"
    },
    {
      id: 70606,
      question: "What is another name for acute ulcerative gingivitis?",
      options: [
        "Vincent\'s angina",
        "Trench mouth",
        "Cancrum oris",
        "Noma",
      ],
      correct: "B"
    },
    {
      id: 70607,
      question: "What is Vincent\'s angina?",
      options: [
        "Acute inflammation of the pharynx",
        "Ulcerative tonsillitis due to acute ulcerative gingivitis",
        "Chronic periodontal disease",
        "Fungal infection of the throat",
      ],
      correct: "B"
    },
    {
      id: 70608,
      question: "What is cancrum oris (noma)?",
      options: [
        "A mild gingival inflammation",
        "A consequence of acute necrotizing ulcerative gingivitis leading to facial tissue loss",
        "A viral infection of the oral cavity",
        "A fungal infection of the cheeks",
      ],
      correct: "B"
    },
    {
      id: 70609,
      question: "Which virulence factors are associated with Fusobacterium nucleatum?",
      options: [
        "Capsule and flagella",
        "Endotoxin and Adhesin A",
        "Exotoxin and pili",
        "Leukotoxin and collagenase",
      ],
      correct: "B"
    },
    {
      id: 70610,
      question: "What are the drugs of choice for Fusobacterium nucleatum infections?",
      options: [
        "Tetracycline and erythromycin",
        "Penicillin and metronidazole",
        "Ciprofloxacin and rifampin",
        "Vancomycin and clindamycin",
      ],
      correct: "B"
    },
    {
      id: 70611,
      question: "What is the Gram stain and oxygen requirement of Leptotrichia?",
      options: [
        "Gram-positive, aerobic",
        "Gram-negative, anaerobic",
        "Gram-positive, anaerobic",
        "Gram-negative, aerobic",
      ],
      correct: "B"
    },
    {
      id: 70612,
      question: "Where has Leptotrichia buccalis been found?",
      options: [
        "Intestinal tract",
        "Dental plaques",
        "Respiratory tract",
        "Urogenital tract",
      ],
      correct: "B"
    },
    {
      id: 70613,
      question: "What is the general morphology of spirochetes?",
      options: [
        "Straight and non-motile",
        "Motile and helical",
        "Curved and non-motile",
        "Coccoid and motile",
      ],
      correct: "B"
    },
    {
      id: 70614,
      question: "What structure in spirochetes is responsible for their spiral shape and movement?",
      options: [
        "Flagella",
        "Pili",
        "Axial filaments",
        "Capsule",
      ],
      correct: "C"
    },
    {
      id: 70615,
      question: "How many axial filaments are typically found beneath the cell wall of spirochetes?",
      options: [
        "One to two",
        "Three to five",
        "Six to eight",
        "Ten to twelve",
      ],
      correct: "B"
    },
    {
      id: 70616,
      question: "The cell wall of spirochetes is similar to which type of bacteria?",
      options: [
        "Gram-positive bacteria",
        "Gram-negative bacteria",
        "Acid-fast bacteria",
        "Cell wall-deficient bacteria",
      ],
      correct: "B"
    },
    {
      id: 70617,
      question: "How many medically important genera of spirochetes are there?",
      options: [
        "Two",
        "Three",
        "Four",
        "Five",
      ],
      correct: "B"
    },
    {
      id: 70618,
      question: "What are the normal habitats of Treponema pallidum?",
      options: [
        "Respiratory tract and skin",
        "Oral cavity and genital tract",
        "Intestinal tract and blood",
        "Water and soil",
      ],
      correct: "B"
    },
    {
      id: 70619,
      question: "How is Treponema pallidum transmitted?",
      options: [
        "Respiratory droplets only",
        "Sexual intercourse, blood, saliva, and placenta",
        "Contaminated food and water",
        "Insect vectors only",
      ],
      correct: "B"
    },
    {
      id: 70620,
      question: "What microscopy technique is used to visualize Treponema pallidum?",
      options: [
        "Light microscopy with Gram stain",
        "Dark-field or fluorescence microscopy",
        "Electron microscopy only",
        "Phase contrast microscopy only",
      ],
      correct: "B"
    },
    {
      id: 70621,
      question: "What disease is caused by Treponema pallidum?",
      options: [
        "Lyme disease",
        "Syphilis",
        "Leprosy",
        "Tuberculosis",
      ],
      correct: "B"
    },
    {
      id: 70622,
      question: "What is the drug of choice for treating syphilis?",
      options: [
        "Tetracycline",
        "Erythromycin",
        "Penicillin",
        "Metronidazole",
      ],
      correct: "C"
    },
    {
      id: 70623,
      question: "What is the best alternative antibiotic for syphilis in penicillin-allergic patients?",
      options: [
        "Erythromycin",
        "Tetracycline",
        "Metronidazole",
        "Ciprofloxacin",
      ],
      correct: "B"
    },
    {
      id: 70624,
      question: "What disease is caused by Treponema pallidum subsp. pertenue?",
      options: [
        "Syphilis",
        "Yaws",
        "Pinta",
        "Lyme disease",
      ],
      correct: "B"
    },
    {
      id: 70625,
      question: "What are the characteristics of yaws?",
      options: [
        "Acute respiratory infection",
        "Chronic, granulomatous, and ulcerative lesion of skin, mucus, and bone",
        "Watery diarrhea",
        "Meningitis",
      ],
      correct: "B"
    },
    {
      id: 70626,
      question: "How is yaws transmitted?",
      options: [
        "Sexual intercourse",
        "Direct contact",
        "Respiratory droplets",
        "Insect vectors",
      ],
      correct: "B"
    },
    {
      id: 70627,
      question: "What disease is caused by Treponema carateum?",
      options: [
        "Syphilis",
        "Yaws",
        "Pinta",
        "Lyme disease",
      ],
      correct: "C"
    },
    {
      id: 70628,
      question: "What are the characteristics of pinta?",
      options: [
        "Ulcerative lesions of the mouth",
        "Depigmented and hyperkeratotic skin",
        "Watery diarrhea",
        "Joint inflammation",
      ],
      correct: "B"
    },
    {
      id: 70629,
      question: "What is an example of an oral treponeme?",
      options: [
        "T. pallidum",
        "T. denticola",
        "T. carateum",
        "T. pertenue",
      ],
      correct: "B"
    },
    {
      id: 70630,
      question: "What is the normal habitat of oral treponemes?",
      options: [
        "Intestinal tract",
        "Oral cavity, particularly crevice and gingival margins",
        "Respiratory tract",
        "Urogenital tract",
      ],
      correct: "B"
    },
    {
      id: 70631,
      question: "How do oral treponemes compare to T. pallidum in terms of coil structure?",
      options: [
        "Oral treponemes have more coils",
        "Oral treponemes have fewer coils",
        "They have the same number of coils",
        "Oral treponemes have no coils",
      ],
      correct: "B"
    },
    {
      id: 70632,
      question: "With which bacteria do oral treponemes coaggregate to form the fusospirochetal complex?",
      options: [
        "Streptococci",
        "Fusobacteria",
        "Lactobacilli",
        "Actinomyces",
      ],
      correct: "B"
    },
    {
      id: 70633,
      question: "Which conditions are caused by the fusospirochetal complex?",
      options: [
        "Dental caries and root canal infections",
        "Acute necrotizing ulcerative gingivitis, Vincent\'s angina, and trench mouth",
        "Pneumonia and bronchitis",
        "Urinary tract infections",
      ],
      correct: "B"
    },
    {
      id: 70634,
      question: "How do oral treponemes spread within periodontal tissues?",
      options: [
        "Through the bloodstream",
        "Through gingival crevicular fluid and penetration of gingival connective tissue",
        "Through lymphatic vessels",
        "Through respiratory droplets",
      ],
      correct: "B"
    },
    {
      id: 70635,
      question: "What are the significant virulence factors of oral treponemes?",
      options: [
        "Capsule and pili",
        "Collagenase and endotoxin",
        "Leukotoxin and protease",
        "Exotoxin and flagella",
      ],
      correct: "B"
    },
    {
      id: 70636,
      question: "What are the drugs of choice for oral treponeme infections?",
      options: [
        "Tetracycline and erythromycin",
        "Penicillin and metronidazole",
        "Ciprofloxacin and rifampin",
        "Vancomycin and clindamycin",
      ],
      correct: "B"
    },
    {
      id: 70637,
      question: "What are the normal habitats of Borrelia burgdorferi?",
      options: [
        "Human skin and nerves",
        "Tick and small mammals",
        "Water and soil",
        "Cattle and poultry",
      ],
      correct: "B"
    },
    {
      id: 70638,
      question: "How is Borrelia burgdorferi transmitted?",
      options: [
        "Sexual contact",
        "Tick vector",
        "Respiratory droplets",
        "Contaminated food",
      ],
      correct: "B"
    },
    {
      id: 70639,
      question: "How do Borrelia coils compare to Treponema coils?",
      options: [
        "Borrelia coils are tighter than Treponema",
        "Borrelia coils are looser than Treponema",
        "They are identical",
        "Borrelia has no coils",
      ],
      correct: "B"
    },
    {
      id: 70640,
      question: "What disease is caused by Borrelia burgdorferi?",
      options: [
        "Syphilis",
        "Lyme disease",
        "Relapsing fever",
        "Leprosy",
      ],
      correct: "B"
    },
    {
      id: 70641,
      question: "What are the clinical features of Lyme disease?",
      options: [
        "Watery diarrhea and dehydration",
        "Arthritis associated with cardiac and neurological disorders",
        "Skin depigmentation",
        "Chronic cough and fever",
      ],
      correct: "B"
    },
    {
      id: 70642,
      question: "What neurological manifestation is associated with Lyme disease?",
      options: [
        "Bilateral facial palsy",
        "Unilateral facial palsy",
        "Trigeminal neuralgia",
        "Glossopharyngeal neuralgia",
      ],
      correct: "B"
    },
    {
      id: 70643,
      question: "What are the drugs of choice for Lyme disease?",
      options: [
        "Penicillin and metronidazole",
        "Tetracycline and amoxicillin",
        "Erythromycin and rifampin",
        "Ciprofloxacin and clindamycin",
      ],
      correct: "B"
    },
    {
      id: 70644,
      question: "How is Borrelia recurrentis transmitted?",
      options: [
        "Tick vector",
        "Louse vector",
        "Mosquito vector",
        "Flea vector",
      ],
      correct: "B"
    },
    {
      id: 70645,
      question: "What disease is caused by Borrelia recurrentis?",
      options: [
        "Lyme disease",
        "Relapsing fever",
        "Syphilis",
        "Yaws",
      ],
      correct: "B"
    },
    {
      id: 70646,
      question: "What are the normal habitats of Leptospira species?",
      options: [
        "Human skin and nerves",
        "Water, wet soils, and kidneys of some animals",
        "Oral cavity and genital tract",
        "Respiratory tract",
      ],
      correct: "B"
    },
    {
      id: 70647,
      question: "How is leptospirosis transmitted?",
      options: [
        "Respiratory droplets",
        "Animals\' urine",
        "Sexual contact",
        "Insect vectors",
      ],
      correct: "B"
    },
    {
      id: 70648,
      question: "What are the clinical features of leptospirosis?",
      options: [
        "Skin rashes and joint pain",
        "Fever, jaundice, and renal failure",
        "Chronic cough and weight loss",
        "Diarrhea and vomiting",
      ],
      correct: "B"
    },
    {
      id: 70649,
      question: "What makes mycobacteria acid-fast?",
      options: [
        "High lipid content in cell membrane",
        "Considerable amount of mycolic acid in their cell wall",
        "Presence of a capsule",
        "Thick peptidoglycan layer",
      ],
      correct: "B"
    },
    {
      id: 70650,
      question: "What is the morphology and oxygen requirement of mycobacteria?",
      options: [
        "Thick, anaerobic bacilli",
        "Slim, aerobic bacilli",
        "Curved, facultative anaerobic bacilli",
        "Coccobacilli, capnophilic",
      ],
      correct: "B"
    },
    {
      id: 70651,
      question: "What is the normal habitat of Mycobacterium tuberculosis?",
      options: [
        "Skin",
        "Human lung",
        "Intestinal tract",
        "Oral cavity",
      ],
      correct: "B"
    },
    {
      id: 70652,
      question: "How is Mycobacterium tuberculosis transmitted?",
      options: [
        "Sexual contact",
        "Respiratory droplets",
        "Contaminated food",
        "Insect vectors",
      ],
      correct: "B"
    },
    {
      id: 70653,
      question: "What type of disease is tuberculosis?",
      options: [
        "Acute and rapidly progressive",
        "Chronic, slowly progressive, and granulomatous",
        "Self-limiting and mild",
        "Recurrent and relapsing",
      ],
      correct: "B"
    },
    {
      id: 70654,
      question: "What pathological process is associated with tuberculosis?",
      options: [
        "Liquefaction necrosis",
        "Caseation",
        "Coagulative necrosis",
        "Fat necrosis",
      ],
      correct: "B"
    },
    {
      id: 70655,
      question: "In which patient population is TB more severe?",
      options: [
        "Elderly patients",
        "HIV-positive individuals",
        "Pregnant women",
        "Children",
      ],
      correct: "B"
    },
    {
      id: 70656,
      question: "Which combination of antituberculous drugs is recommended for TB treatment?",
      options: [
        "Penicillin, erythromycin, tetracycline, and metronidazole",
        "Pyrazinamide, ethambutol, rifampin, and isoniazid",
        "Ciprofloxacin, vancomycin, clindamycin, and gentamicin",
        "Ampicillin, amoxicillin, cephalosporins, and aminoglycosides",
      ],
      correct: "B"
    },
    {
      id: 70657,
      question: "What is MDR-TB?",
      options: [
        "Mild drug-resistant tuberculosis",
        "Multidrug-resistant tuberculosis",
        "Moderately drug-responsive tuberculosis",
        "Multiple drug-reactive tuberculosis",
      ],
      correct: "B"
    },
    {
      id: 70658,
      question: "What vaccine is used for prevention of tuberculosis?",
      options: [
        "DPT vaccine",
        "BCG vaccine",
        "Hib vaccine",
        "MMR vaccine",
      ],
      correct: "B"
    },
    {
      id: 70659,
      question: "What type of vaccine is BCG?",
      options: [
        "Killed whole bacteria",
        "Live attenuated bacteria",
        "Toxoid vaccine",
        "Subunit vaccine",
      ],
      correct: "B"
    },
    {
      id: 70660,
      question: "What is the normal habitat of Mycobacterium bovis?",
      options: [
        "Human lung",
        "Cattle",
        "Soil and water",
        "Tick and small mammals",
      ],
      correct: "B"
    },
    {
      id: 70661,
      question: "How is Mycobacterium bovis transmitted?",
      options: [
        "Respiratory droplets",
        "Contaminated milk",
        "Sexual contact",
        "Insect vectors",
      ],
      correct: "B"
    },
    {
      id: 70662,
      question: "What disease does Mycobacterium bovis cause in children?",
      options: [
        "Tuberculosis",
        "Scrofuloderma",
        "Leprosy",
        "Leptospirosis",
      ],
      correct: "B"
    },
    {
      id: 70663,
      question: "What characterizes scrofuloderma?",
      options: [
        "Pulmonary lesions",
        "Enlargement and caseation of cervical lymph node",
        "Skin depigmentation",
        "Joint inflammation",
      ],
      correct: "B"
    },
    {
      id: 70664,
      question: "What are the normal habitats of Mycobacterium leprae?",
      options: [
        "Human lung",
        "Human skin and nerves",
        "Cattle",
        "Water and soil",
      ],
      correct: "B"
    },
    {
      id: 70665,
      question: "How is Mycobacterium leprae transmitted?",
      options: [
        "Respiratory droplets",
        "Long-term contact",
        "Contaminated food",
        "Insect vectors",
      ],
      correct: "B"
    },
    {
      id: 70666,
      question: "What disease does Mycobacterium leprae cause?",
      options: [
        "Tuberculosis",
        "Leprosy",
        "Syphilis",
        "Lyme disease",
      ],
      correct: "B"
    },
    {
      id: 70667,
      question: "How many forms of leprosy are there?",
      options: [
        "One",
        "Two",
        "Three",
        "Four",
      ],
      correct: "B"
    },
    {
      id: 70668,
      question: "What causes lepromatous leprosy?",
      options: [
        "Strong cell-mediated immune response",
        "Weak cell-mediated immune response",
        "Strong humoral immune response",
        "Autoimmune reaction",
      ],
      correct: "B"
    },
    {
      id: 70669,
      question: "What is the main clinical feature of lepromatous leprosy?",
      options: [
        "Anesthesia",
        "Disfigurement, especially in the nose",
        "Paresthesia",
        "Joint pain",
      ],
      correct: "B"
    },
    {
      id: 70670,
      question: "What causes tuberculoid leprosy?",
      options: [
        "Weak cell-mediated immune response",
        "Strong cell-mediated immune response",
        "Weak humoral immune response",
        "Autoimmune reaction",
      ],
      correct: "B"
    },
    {
      id: 70671,
      question: "What are the clinical features of tuberculoid leprosy?",
      options: [
        "Disfigurement",
        "Anesthesia and paresthesia",
        "Skin ulceration",
        "Facial tissue loss",
      ],
      correct: "B"
    },
    {
      id: 70672,
      question: "What is the recommended treatment for leprosy?",
      options: [
        "Penicillin monotherapy",
        "Combination therapy including dapsone, rifampin, and clofazimine",
        "Tetracycline and erythromycin",
        "Metronidazole and ciprofloxacin",
      ],
      correct: "B"
    },
    {
      id: 70673,
      question: "What does MOTT stand for in mycobacteriology?",
      options: [
        "Mycobacteria of typical tuberculosis",
        "Mycobacteria other than tuberculosis",
        "Multiple opportunistic tuberculous types",
        "Mild organisms targeting tissue",
      ],
      correct: "B"
    },
    {
      id: 70674,
      question: "Which species are prototypes of MOTT?",
      options: [
        "M. tuberculosis and M. bovis",
        "M. avium and M. intracellulare",
        "M. leprae and M. ulcerans",
        "M. marinum and M. kansasii",
      ],
      correct: "B"
    },
    {
      id: 70675,
      question: "What are the normal habitats of MOTT?",
      options: [
        "Human lung only",
        "Soil, water, and animals",
        "Oral cavity only",
        "Genital tract only",
      ],
      correct: "B"
    },
    {
      id: 70676,
      question: "In which patient population are MOTT infections more common?",
      options: [
        "Healthy adults",
        "Immunocompromised patients",
        "Pregnant women",
        "Athletes",
      ],
      correct: "B"
    },
    {
      id: 70677,
      question: "What is the Gram stain and oxygen requirement of Legionella?",
      options: [
        "Gram-positive, anaerobic",
        "Gram-negative, aerobic",
        "Gram-positive, aerobic",
        "Gram-negative, anaerobic",
      ],
      correct: "B"
    },
    {
      id: 70678,
      question: "Which of the following is NOT a normal habitat of Legionella?",
      options: [
        "Soil",
        "Water supplies",
        "Human intestine",
        "Dental unit water system",
      ],
      correct: "C"
    },
    {
      id: 70679,
      question: "How is Legionella transmitted?",
      options: [
        "Sexual contact",
        "Airborne droplets",
        "Contaminated food",
        "Direct contact",
      ],
      correct: "B"
    },
    {
      id: 70680,
      question: "Which Legionella species is the prototype?",
      options: [
        "L. micdadei",
        "L. pneumophila",
        "L. longbeachae",
        "L. bozemanii",
      ],
      correct: "B"
    },
    {
      id: 70681,
      question: "What is Legionnaires\' disease?",
      options: [
        "Mild gastrointestinal infection",
        "Severe pneumonia with diarrhea, hematuria, and proteinuria",
        "Skin infection",
        "Urinary tract infection",
      ],
      correct: "B"
    },
    {
      id: 70682,
      question: "What is Pontiac fever?",
      options: [
        "Severe pneumonia",
        "Mild pneumonia",
        "Gastrointestinal infection",
        "Skin rash with fever",
      ],
      correct: "B"
    },
    {
      id: 70683,
      question: "What are the drugs of choice for Legionella infections?",
      options: [
        "Penicillin and metronidazole",
        "Erythromycin, rifampin, and ciprofloxacin",
        "Tetracycline and clindamycin",
        "Vancomycin and aminoglycosides",
      ],
      correct: "B"
    },
    {
      id: 70684,
      question: "What is the morphology of Chlamydia?",
      options: [
        "Gram-positive cocci",
        "Gram-negative coccobacilli",
        "Gram-positive bacilli",
        "Gram-negative curved bacilli",
      ],
      correct: "B"
    },
    {
      id: 70685,
      question: "What is the lifestyle of Chlamydia?",
      options: [
        "Free-living bacteria",
        "Obligate intracellular parasites",
        "Facultative intracellular parasites",
        "Extracellular parasites",
      ],
      correct: "B"
    },
    {
      id: 70686,
      question: "In what ways do Chlamydiae differ from viruses?",
      options: [
        "Size, genome, antibiotic sensitivity, and growth cycle complexity",
        "Only size and genome",
        "Only antibiotic sensitivity",
        "They do not differ from viruses",
      ],
      correct: "A"
    },
    {
      id: 70687,
      question: "Which ocular infection caused by Chlamydia trachomatis can result in blindness?",
      options: [
        "Conjunctivitis",
        "Trachoma",
        "Keratitis",
        "Uveitis",
      ],
      correct: "B"
    },
    {
      id: 70688,
      question: "Which of the following is NOT an infection caused by Chlamydia trachomatis?",
      options: [
        "Neonatal conjunctivitis",
        "Lymphogranuloma venereum",
        "Psittacosis",
        "Pneumonia in neonates",
      ],
      correct: "C"
    },
    {
      id: 70689,
      question: "What genital infection is caused by Chlamydia trachomatis?",
      options: [
        "Gonorrhea",
        "Urethritis and lymphogranuloma venereum",
        "Syphilis",
        "Herpes",
      ],
      correct: "B"
    },
    {
      id: 70690,
      question: "What are the drugs of choice for Chlamydia trachomatis infections?",
      options: [
        "Penicillin and metronidazole",
        "Tetracyclines, erythromycin, and sulfonamides",
        "Ciprofloxacin and rifampin",
        "Vancomycin and clindamycin",
      ],
      correct: "B"
    },
    {
      id: 70691,
      question: "What infections does Chlamydia pneumoniae cause?",
      options: [
        "Severe pneumonia and meningitis",
        "Mild pneumonia and sore throat",
        "Urinary tract infections",
        "Gastrointestinal infections",
      ],
      correct: "B"
    },
    {
      id: 70692,
      question: "What disease does Chlamydia psittaci cause?",
      options: [
        "Trachoma",
        "Psittacosis (ornithosis)",
        "Lymphogranuloma venereum",
        "Neonatal conjunctivitis",
      ],
      correct: "B"
    },
    {
      id: 70693,
      question: "In what occupation is psittacosis commonly seen?",
      options: [
        "Healthcare workers",
        "Taxidermists",
        "Farmers",
        "Construction workers",
      ],
      correct: "B"
    },
    {
      id: 70694,
      question: "What is the morphology of Rickettsia?",
      options: [
        "Gram-positive cocci",
        "Gram-negative coccobacilli",
        "Gram-positive bacilli",
        "Gram-negative spiral bacteria",
      ],
      correct: "B"
    },
    {
      id: 70695,
      question: "What is the lifestyle of Rickettsia?",
      options: [
        "Free-living bacteria",
        "Obligate intracellular parasites",
        "Facultative intracellular parasites",
        "Extracellular parasites",
      ],
      correct: "B"
    },
    {
      id: 70696,
      question: "What is typhus?",
      options: [
        "Gastrointestinal infection with diarrhea",
        "Febrile infection with maculopapular rashes",
        "Respiratory infection with cough",
        "Urinary tract infection",
      ],
      correct: "B"
    },
    {
      id: 70697,
      question: "How is typhus transmitted?",
      options: [
        "Tick",
        "Flea",
        "Mosquito",
        "Louse",
      ],
      correct: "B"
    },
    {
      id: 70698,
      question: "How is Rocky Mountain spotted fever transmitted?",
      options: [
        "Flea",
        "Tick",
        "Louse",
        "Mosquito",
      ],
      correct: "B"
    },
    {
      id: 70699,
      question: "What are the drugs of choice for Rickettsia infections?",
      options: [
        "Penicillin and metronidazole",
        "Tetracyclines and chloramphenicol",
        "Erythromycin and rifampin",
        "Ciprofloxacin and vancomycin",
      ],
      correct: "B"
    },
    {
      id: 70700,
      question: "What disease does Coxiella burnetii cause?",
      options: [
        "Typhus",
        "Q fever (atypical pneumonia)",
        "Rocky Mountain spotted fever",
        "Lyme disease",
      ],
      correct: "B"
    },
    {
      id: 70701,
      question: "Which organs can Q fever involve besides the lungs?",
      options: [
        "Liver and kidneys",
        "Brain and heart",
        "Spleen and pancreas",
        "Stomach and intestines",
      ],
      correct: "B"
    },
    {
      id: 70702,
      question: "What is unique about Mycoplasma regarding cell structure?",
      options: [
        "They have thick cell walls",
        "They are cell wall-deficient and have sterols in their plasma membrane",
        "They have a capsule",
        "They have flagella",
      ],
      correct: "B"
    },
    {
      id: 70703,
      question: "What is the size characteristic of Mycoplasma?",
      options: [
        "Largest prokaryotes",
        "Smallest prokaryotes",
        "Medium-sized prokaryotes",
        "Same size as typical bacteria",
      ],
      correct: "B"
    },
    {
      id: 70704,
      question: "What is the lifestyle of Mycoplasma?",
      options: [
        "Free-living bacteria",
        "Obligate intracellular parasite",
        "Facultative intracellular parasite",
        "Extracellular parasite",
      ],
      correct: "B"
    },
    {
      id: 70705,
      question: "Which Mycoplasma species is the prototype?",
      options: [
        "M. hominis",
        "M. pneumoniae",
        "M. genitalium",
        "M. fermentans",
      ],
      correct: "B"
    },
    {
      id: 70706,
      question: "What is another name for pneumonia caused by Mycoplasma pneumoniae?",
      options: [
        "Typical pneumonia",
        "Atypical pneumonia",
        "Lobar pneumonia",
        "Bronchopneumonia",
      ],
      correct: "B"
    },
    {
      id: 70707,
      question: "What are mucocutaneous eruptions caused by M. pneumoniae characterized by?",
      options: [
        "Fever and chills only",
        "Skin rashes and ulcerations of oral and vaginal mucosa",
        "Joint pain and swelling",
        "Gastrointestinal symptoms",
      ],
      correct: "B"
    },
    {
      id: 70708,
      question: "What is Stevens-Johnson syndrome?",
      options: [
        "Pneumonia with pleural effusion",
        "Oral ulceration associated with skin rash and conjunctivitis",
        "Arthritis with cardiac involvement",
        "Meningitis with neurological symptoms",
      ],
      correct: "B"
    },
    {
      id: 70709,
      question: "What blood disorder can M. pneumoniae cause?",
      options: [
        "Thrombocytopenia",
        "Hemolytic anemia",
        "Leukemia",
        "Polycythemia",
      ],
      correct: "B"
    },
    {
      id: 70710,
      question: "What are the drugs of choice for Mycoplasma pneumoniae infections?",
      options: [
        "Penicillin and metronidazole",
        "Tetracyclines and erythromycin",
        "Ciprofloxacin and rifampin",
        "Vancomycin and clindamycin",
      ],
      correct: "B"
    },
    {
      id: 70711,
      question: "Which structure encircles the central protoplasmic cylinder in spirochetes?",
      options: [
        "Capsule",
        "Cytoplasmic membrane",
        "Outer membrane only",
        "Peptidoglycan layer only",
      ],
      correct: "B"
    },
    {
      id: 70712,
      question: "Where are axial filaments located in spirochetes?",
      options: [
        "Outside the cell wall",
        "Beneath the cell wall",
        "In the cytoplasm",
        "In the nucleus",
      ],
      correct: "B"
    },
    {
      id: 70713,
      question: "To which structures are axial filaments attached in spirochetes?",
      options: [
        "The center of the cell",
        "Both ends of the cell",
        "One end of the cell only",
        "The cell membrane only",
      ],
      correct: "B"
    },
    {
      id: 70714,
      question: "What describes the coils of Treponema pallidum?",
      options: [
        "Loose and widely spaced",
        "Thin and helical with spaced coils",
        "Tight and closely spaced",
        "No coils present",
      ],
      correct: "B"
    },
    {
      id: 70715,
      question: "Which bacteria can be found in dental unit water systems?",
      options: [
        "Treponema pallidum",
        "Legionella",
        "Mycobacterium tuberculosis",
        "Chlamydia trachomatis",
      ],
      correct: "B"
    },
    {
      id: 70716,
      question: "What is the characteristic of tuberculosis infection progression?",
      options: [
        "Acute and rapidly progressive",
        "Chronic and slowly progressive",
        "Self-limiting",
        "Intermittent and relapsing",
      ],
      correct: "B"
    },
    {
      id: 70717,
      question: "Which mycobacterial infection commonly coexists with MOTT infections?",
      options: [
        "Leprosy",
        "Tuberculosis",
        "Scrofuloderma",
        "Leptospirosis",
      ],
      correct: "B"
    },
    {
      id: 70718,
      question: "What is the reference textbook for this material?",
      options: [
        "Robbins Pathology",
        "Essential Microbiology for Dentistry by Samaranayake",
        "Medical Microbiology by Jawetz",
        "Murray\'s Medical Microbiology",
      ],
      correct: "B"
    },
    {
      id: 70719,
      question: "Which three genera are the medically important spirochetes?",
      options: [
        "Neisseria, Moraxella, and Veillonella",
        "Treponema, Borrelia, and Leptospira",
        "Mycobacterium, Legionella, and Chlamydia",
        "Rickettsia, Mycoplasma, and Coxiella",
      ],
      correct: "B"
    },
    {
      id: 70720,
      question: "What condition results when acute necrotizing ulcerative gingivitis progresses to cause facial tissue loss?",
      options: [
        "Vincent\'s angina",
        "Cancrum oris (noma)",
        "Trench mouth",
        "Periodontitis",
      ],
      correct: "B"
    },
    {
      id: 70721,
      question: "Which antibiotic is NOT part of the combination therapy for leprosy?",
      options: [
        "Dapsone",
        "Rifampin",
        "Clofazimine",
        "Isoniazid",
      ],
      correct: "D"
    },
    {
      id: 70722,
      question: "What clinical features differentiate Legionnaires\' disease from Pontiac fever?",
      options: [
        "Legionnaires\' disease is milder",
        "Legionnaires\' disease is severe with diarrhea, hematuria, and proteinuria; Pontiac fever is mild",
        "They are identical in severity",
        "Pontiac fever involves the kidneys",
      ],
      correct: "B"
    },
    {
      id: 70723,
      question: "Which antituberculous drug is NOT mentioned in the standard TB treatment regimen?",
      options: [
        "Pyrazinamide",
        "Ethambutol",
        "Streptomycin",
        "Isoniazid",
      ],
      correct: "C"
    },
    {
      id: 70724,
      question: "What is the main difference between Fusobacteria and spirochetes?",
      options: [
        "Fusobacteria are Gram-positive; spirochetes are Gram-negative",
        "Fusobacteria are non-motile; spirochetes are motile",
        "Fusobacteria are aerobic; spirochetes are anaerobic",
        "Fusobacteria have capsules; spirochetes do not",
      ],
      correct: "B"
    },
    {
      id: 70725,
      question: "Which disease is characterized by chronic, granulomatous, and ulcerative lesions affecting skin, mucus, and bone?",
      options: [
        "Syphilis",
        "Yaws",
        "Pinta",
        "Lyme disease",
      ],
      correct: "B"
    },
    {
      id: 70726,
      question: "What percentage of the tuberculous disease characteristics involve the formation of granulomas?",
      options: [
        "Granulomatous inflammation is not typical of TB",
        "TB is characterized as granulomatous",
        "Only in immunocompromised patients",
        "Only in children",
      ],
      correct: "B"
    },
    {
      id: 70727,
      question: "Which organism requires visualization by dark-field or fluorescence microscopy due to its thin structure?",
      options: [
        "Mycobacterium tuberculosis",
        "Treponema pallidum",
        "Legionella pneumophila",
        "Chlamydia trachomatis",
      ],
      correct: "B"
    },
    {
      id: 70728,
      question: "Where in the dental setting can Legionella be found as a potential source of infection?",
      options: [
        "Dental instruments",
        "Dental unit water system and air conditioners",
        "Dental impression materials",
        "Dental chairs",
      ],
      correct: "B"
    },
  ],
  "8. Medical Virology & Mycology": [
    {
      id: 70700,
      question: "What conditions are caused by HPV (Human Papillomavirus)?",
      options: [
        "Chickenpox and shingles",
        "Skin warts, oral squamous papillomas, oral warts, and verrucous carcinoma",
        "Infectious mononucleosis and Burkitt\'s lymphoma",
        "Influenza and pneumonia",
      ],
      correct: "B"
    },
    {
      id: 70701,
      question: "What is a skin wart (verruca)?",
      options: [
        "A malignant epithelial tumor",
        "A benign epithelial tumor",
        "A viral infection of the dermis",
        "A bacterial skin infection",
      ],
      correct: "B"
    },
    {
      id: 70702,
      question: "How are skin warts transmitted?",
      options: [
        "Respiratory droplets",
        "Direct contact",
        "Contaminated water",
        "Sexual intercourse only",
      ],
      correct: "B"
    },
    {
      id: 70703,
      question: "In which age group are skin warts less common?",
      options: [
        "Children",
        "Teenagers",
        "Adults",
        "Infants",
      ],
      correct: "C"
    },
    {
      id: 70704,
      question: "At what age do oral squamous papillomas and warts typically occur?",
      options: [
        "10 to 20 years",
        "30 to 50 years",
        "60 to 80 years",
        "Under 10 years",
      ],
      correct: "B"
    },
    {
      id: 70705,
      question: "What is the morphology of oral squamous papillomas?",
      options: [
        "Flat and sessile lesions",
        "Small exophytic and pedunculated lesions",
        "Large ulcerated lesions",
        "Deep nodular lesions",
      ],
      correct: "B"
    },
    {
      id: 70706,
      question: "Which HPV serotypes are responsible for cervical cancer?",
      options: [
        "HPV-1, 2, and 3",
        "HPV-16, 18, and 33",
        "HPV-6, 11, and 42",
        "HPV-31, 35, and 39",
      ],
      correct: "B"
    },
    {
      id: 70707,
      question: "What is epidermodysplasia verruciformis?",
      options: [
        "A benign wart",
        "A malignant wart",
        "A bacterial skin infection",
        "A fungal infection",
      ],
      correct: "B"
    },
    {
      id: 70708,
      question: "Where do adenoviruses cause latent infections?",
      options: [
        "Respiratory epithelium",
        "Lymphoid tissues such as tonsils",
        "Gastrointestinal mucosa",
        "Skin epidermis",
      ],
      correct: "B"
    },
    {
      id: 70709,
      question: "Which of the following is NOT an adenovirus infection?",
      options: [
        "Acute respiratory disease",
        "Keratoconjunctivitis",
        "Genital herpes",
        "Gastroenteritis",
      ],
      correct: "C"
    },
    {
      id: 70710,
      question: "How are adenoviruses transmitted?",
      options: [
        "Sexual contact only",
        "Respiratory and ocular secretions",
        "Blood transfusion",
        "Insect vectors",
      ],
      correct: "B"
    },
    {
      id: 70711,
      question: "Where can adenovirus transmission commonly occur through ocular secretions?",
      options: [
        "Hospitals",
        "Swimming pools",
        "Schools",
        "Restaurants",
      ],
      correct: "B"
    },
    {
      id: 70712,
      question: "How many different types of human herpesviruses exist?",
      options: [
        "4",
        "6",
        "8",
        "10",
      ],
      correct: "C"
    },
    {
      id: 70713,
      question: "What is the characteristic feature of herpesviruses?",
      options: [
        "They cause acute infections only",
        "They are latency-inducing viruses",
        "They only infect children",
        "They cannot be treated",
      ],
      correct: "B"
    },
    {
      id: 70714,
      question: "What is the incubation period for primary HSV infections?",
      options: [
        "1-5 days",
        "2-20 days",
        "30-60 days",
        "3-6 months",
      ],
      correct: "B"
    },
    {
      id: 70715,
      question: "Where does gingivostomatitis caused by HSV occur?",
      options: [
        "On the genital area",
        "On the lips and mouth",
        "On the fingers",
        "In the eyes",
      ],
      correct: "B"
    },
    {
      id: 70716,
      question: "Which HSV type mostly causes genital herpes?",
      options: [
        "HSV-1",
        "HSV-2",
        "HSV-3",
        "HSV-4",
      ],
      correct: "B"
    },
    {
      id: 70717,
      question: "What is herpetic whitlow?",
      options: [
        "Oral infection",
        "Finger infection from contamination with secretions",
        "Eye infection",
        "Genital infection",
      ],
      correct: "B"
    },
    {
      id: 70718,
      question: "Which secretion is most commonly associated with herpetic whitlow?",
      options: [
        "Blood",
        "Saliva",
        "Urine",
        "Tears",
      ],
      correct: "B"
    },
    {
      id: 70719,
      question: "Where does the HSV virus remain latent during recurrent infections?",
      options: [
        "Cervical ganglia",
        "Trigeminal ganglia",
        "Dorsal root ganglia",
        "Lumbar ganglia",
      ],
      correct: "B"
    },
    {
      id: 70720,
      question: "Which of the following is NOT a factor for HSV reactivation?",
      options: [
        "Stress",
        "Sunlight (UV)",
        "Good nutrition",
        "Menstruation",
      ],
      correct: "C"
    },
    {
      id: 70721,
      question: "How is HSV-1 primarily transmitted?",
      options: [
        "Sexual intercourse",
        "Direct contact",
        "Blood transfusion",
        "Respiratory droplets",
      ],
      correct: "B"
    },
    {
      id: 70722,
      question: "How is HSV-2 primarily transmitted?",
      options: [
        "Direct contact",
        "Sexual intercourse",
        "Respiratory droplets",
        "Contaminated food",
      ],
      correct: "B"
    },
    {
      id: 70723,
      question: "Which antiviral drugs are useful in the prodromal phase of HSV infections?",
      options: [
        "Amantadine and rimantadine",
        "Aciclovir, penciclovir, and vidarabine",
        "Tamiflu and ribavirin",
        "Interferon and immunoglobulin",
      ],
      correct: "B"
    },
    {
      id: 70724,
      question: "What is the HHV designation for Varicella-zoster virus?",
      options: [
        "HHV-1",
        "HHV-2",
        "HHV-3",
        "HHV-4",
      ],
      correct: "C"
    },
    {
      id: 70725,
      question: "What is the incubation period for chickenpox?",
      options: [
        "One week",
        "Two weeks",
        "Four weeks",
        "Six weeks",
      ],
      correct: "B"
    },
    {
      id: 70726,
      question: "What are the predominant symptoms of chickenpox?",
      options: [
        "Cough and sore throat",
        "Fever and papular rashes that become vesicular",
        "Diarrhea and vomiting",
        "Joint pain and swelling",
      ],
      correct: "B"
    },
    {
      id: 70727,
      question: "What is shingles (herpes zoster)?",
      options: [
        "Primary VZV infection",
        "Reactivation of VZV in trigeminal ganglia",
        "A new VZV infection in adults",
        "A bacterial skin infection",
      ],
      correct: "B"
    },
    {
      id: 70728,
      question: "Where do lesions typically appear in shingles?",
      options: [
        "Face only",
        "Chest wall",
        "Legs only",
        "Arms only",
      ],
      correct: "B"
    },
    {
      id: 70729,
      question: "How are vesicular rashes characterized in chickenpox?",
      options: [
        "Painful but not itchy",
        "Itchy but painless",
        "Neither itchy nor painful",
        "Both itchy and painful",
      ],
      correct: "B"
    },
    {
      id: 70730,
      question: "How are vesicular rashes characterized in shingles?",
      options: [
        "Bilateral and itchy",
        "Unilateral and painful but not itchy",
        "Bilateral and painless",
        "Unilateral and itchy",
      ],
      correct: "B"
    },
    {
      id: 70731,
      question: "How long do shingles lesions typically last?",
      options: [
        "1 week",
        "2-4 weeks",
        "6-8 weeks",
        "3 months",
      ],
      correct: "B"
    },
    {
      id: 70732,
      question: "What is postherpetic neuralgia?",
      options: [
        "Pain during the acute phase of shingles",
        "Longer-period pain after shingles lesions heal",
        "Pain before shingles appears",
        "Pain in chickenpox",
      ],
      correct: "B"
    },
    {
      id: 70733,
      question: "What is Ramsay Hunt syndrome?",
      options: [
        "Common manifestation of chickenpox",
        "Rare manifestation of shingles affecting external auditory canal, tympanic membrane, and causing unilateral facial palsy",
        "Common cold complication",
        "Measles complication",
      ],
      correct: "B"
    },
    {
      id: 70734,
      question: "Which factors stimulate herpes zoster reactivation?",
      options: [
        "Good health and exercise",
        "Immunosuppression, trauma, some drugs, and neoplastic disease",
        "Vaccination",
        "Antibiotic use",
      ],
      correct: "B"
    },
    {
      id: 70735,
      question: "How is shingles transmitted?",
      options: [
        "Respiratory droplets",
        "Direct contact",
        "Blood transfusion",
        "Sexual contact",
      ],
      correct: "B"
    },
    {
      id: 70736,
      question: "What is used for prevention of shingles?",
      options: [
        "MMR vaccine",
        "VZIG (Varicella-Zoster Immune Globulin)",
        "DPT vaccine",
        "BCG vaccine",
      ],
      correct: "B"
    },
    {
      id: 70737,
      question: "What is the HHV designation for Epstein-Barr virus?",
      options: [
        "HHV-3",
        "HHV-4",
        "HHV-5",
        "HHV-6",
      ],
      correct: "B"
    },
    {
      id: 70738,
      question: "In which cells does EBV tend to be latent?",
      options: [
        "T cells",
        "B cells",
        "Epithelial cells",
        "Nerve cells",
      ],
      correct: "B"
    },
    {
      id: 70739,
      question: "What is another name for infectious mononucleosis?",
      options: [
        "Kissing disease or glandular fever",
        "Chickenpox",
        "Measles",
        "Mumps",
      ],
      correct: "A"
    },
    {
      id: 70740,
      question: "What is the incubation period for infectious mononucleosis?",
      options: [
        "1-2 weeks",
        "4-7 weeks",
        "8-12 weeks",
        "3-6 months",
      ],
      correct: "B"
    },
    {
      id: 70741,
      question: "Which age group is most commonly affected by infectious mononucleosis?",
      options: [
        "Infants",
        "Teenagers",
        "Elderly",
        "Middle-aged adults",
      ],
      correct: "B"
    },
    {
      id: 70742,
      question: "How is infectious mononucleosis transmitted?",
      options: [
        "Contaminated food",
        "Saliva (kissing disease)",
        "Blood transfusion",
        "Insect vectors",
      ],
      correct: "B"
    },
    {
      id: 70743,
      question: "Which of the following is NOT a common symptom of infectious mononucleosis?",
      options: [
        "Fever",
        "Lymphadenopathy",
        "Diarrhea",
        "Splenomegaly",
      ],
      correct: "C"
    },
    {
      id: 70744,
      question: "What is Burkitt\'s lymphoma?",
      options: [
        "Mild skin infection",
        "Severe malignant tumor of lymphoid tissue",
        "Benign tumor",
        "Viral rash",
      ],
      correct: "B"
    },
    {
      id: 70745,
      question: "Where is Burkitt\'s lymphoma particularly common?",
      options: [
        "North America",
        "African children and areas with endemic malaria",
        "Europe",
        "Australia",
      ],
      correct: "B"
    },
    {
      id: 70746,
      question: "What is nasopharyngeal carcinoma?",
      options: [
        "Benign nasal polyp",
        "Highly malignant tumor of epithelial cells",
        "Viral infection of the nose",
        "Bacterial infection",
      ],
      correct: "B"
    },
    {
      id: 70747,
      question: "Where is nasopharyngeal carcinoma especially common?",
      options: [
        "North America",
        "Southern China",
        "Western Europe",
        "Australia",
      ],
      correct: "B"
    },
    {
      id: 70748,
      question: "What are the characteristics of hairy leukoplakia?",
      options: [
        "Red ulcerated lesions on the palate",
        "White and thick lesions on the lateral border of the tongue",
        "Black spots on the gingiva",
        "Yellow plaques on the tonsils",
      ],
      correct: "B"
    },
    {
      id: 70749,
      question: "What is the HHV designation for Cytomegalovirus?",
      options: [
        "HHV-3",
        "HHV-4",
        "HHV-5",
        "HHV-6",
      ],
      correct: "C"
    },
    {
      id: 70750,
      question: "What complications can develop in neonates with congenital CMV infection?",
      options: [
        "Skin rashes",
        "Deafness and mental retardation",
        "Joint problems",
        "Respiratory issues only",
      ],
      correct: "B"
    },
    {
      id: 70751,
      question: "In which patient populations are CMV infections common?",
      options: [
        "Healthy adults",
        "Patients with AIDS, transplants, and neoplasia",
        "Athletes",
        "Pregnant women only",
      ],
      correct: "B"
    },
    {
      id: 70752,
      question: "Which cells does HHV-6 have tendency to infect?",
      options: [
        "Epithelial cells only",
        "B and T cells",
        "Red blood cells",
        "Nerve cells only",
      ],
      correct: "B"
    },
    {
      id: 70753,
      question: "What is exanthem subitum (roseola infantum)?",
      options: [
        "Febrile disease with facial rash in children",
        "Adult skin condition",
        "Bacterial infection",
        "Fungal infection",
      ],
      correct: "A"
    },
    {
      id: 70754,
      question: "What are Nagayama\'s spots?",
      options: [
        "Spots on the skin",
        "Erythematous papules in the oral cavity caused by HHV-6",
        "Eye lesions",
        "Genital lesions",
      ],
      correct: "B"
    },
    {
      id: 70755,
      question: "What condition is HHV-8 associated with in HIV patients?",
      options: [
        "Pneumonia",
        "Kaposi\'s sarcoma",
        "Meningitis",
        "Hepatitis",
      ],
      correct: "B"
    },
    {
      id: 70756,
      question: "What is HHV-7 responsible for?",
      options: [
        "Kaposi\'s sarcoma",
        "Rashes",
        "Meningitis",
        "Hepatitis",
      ],
      correct: "B"
    },
    {
      id: 70757,
      question: "What proteins are used to classify orthomyxoviruses into antigenic types A, B, and C?",
      options: [
        "Hemagglutinin and neuraminidase",
        "Nucleocapsid protein (NP) and envelope matrix protein (M protein)",
        "Capsid protein and envelope glycoprotein",
        "DNA polymerase and reverse transcriptase",
      ],
      correct: "B"
    },
    {
      id: 70758,
      question: "Which antigens are used to name orthomyxoviruses?",
      options: [
        "NP and M antigens",
        "H and N antigens",
        "A, B, and C antigens",
        "IgG and IgM antigens",
      ],
      correct: "B"
    },
    {
      id: 70759,
      question: "Which type of influenza virus has been reported to have antigenic shift?",
      options: [
        "Type A only",
        "Type B only",
        "Type C only",
        "All types equally",
      ],
      correct: "A"
    },
    {
      id: 70760,
      question: "What is the incubation period for influenza?",
      options: [
        "1-2 days",
        "5-7 days",
        "10-14 days",
        "3-4 weeks",
      ],
      correct: "A"
    },
    {
      id: 70761,
      question: "What is the most serious complication of influenza?",
      options: [
        "Skin rash",
        "Pneumonia associated with secondary bacterial infection",
        "Joint pain",
        "Diarrhea",
      ],
      correct: "B"
    },
    {
      id: 70762,
      question: "What are the drugs of choice for influenza?",
      options: [
        "Aciclovir and penciclovir",
        "Amantadine and rimantadine",
        "Penicillin and metronidazole",
        "Tetracycline and erythromycin",
      ],
      correct: "B"
    },
    {
      id: 70763,
      question: "Why doesn\'t the flu vaccine induce long-time immunity?",
      options: [
        "Because the virus mutates frequently (antigenic drift and shift)",
        "Because the vaccine is ineffective",
        "Because immunity is not possible",
        "Because of poor vaccine quality",
      ],
      correct: "A"
    },
    {
      id: 70764,
      question: "What is the normal habitat of avian influenza virus?",
      options: [
        "Humans",
        "Waterfowl, especially in Asia",
        "Cattle",
        "Dogs and cats",
      ],
      correct: "B"
    },
    {
      id: 70765,
      question: "What is the incubation period for avian influenza?",
      options: [
        "1-2 days",
        "7-12 days",
        "3-4 weeks",
        "2-3 months",
      ],
      correct: "B"
    },
    {
      id: 70766,
      question: "What complications can result from avian influenza?",
      options: [
        "Skin rashes only",
        "Pneumonia and encephalitis",
        "Joint pain only",
        "Diarrhea only",
      ],
      correct: "B"
    },
    {
      id: 70767,
      question: "What is the drug of choice for avian influenza if taken immediately?",
      options: [
        "Amantadine",
        "Tamiflu",
        "Aciclovir",
        "Penicillin",
      ],
      correct: "B"
    },
    {
      id: 70768,
      question: "What conditions does parainfluenza virus cause in infants and children?",
      options: [
        "Skin rashes",
        "Laryngotracheobronchitis (croup), bronchiolitis, and pneumonia",
        "Diarrhea and vomiting",
        "Joint pain",
      ],
      correct: "B"
    },
    {
      id: 70769,
      question: "What does parainfluenza virus cause in adults?",
      options: [
        "Pneumonia",
        "Common cold",
        "Meningitis",
        "Hepatitis",
      ],
      correct: "B"
    },
    {
      id: 70770,
      question: "What is mumps virus the causative agent of?",
      options: [
        "Measles",
        "Parotitis (mumps)",
        "Chickenpox",
        "Influenza",
      ],
      correct: "B"
    },
    {
      id: 70771,
      question: "Which vaccine prevents mumps?",
      options: [
        "DPT vaccine",
        "MMR vaccine",
        "BCG vaccine",
        "Hib vaccine",
      ],
      correct: "B"
    },
    {
      id: 70772,
      question: "What is the incubation period for measles?",
      options: [
        "5 days",
        "12 days",
        "21 days",
        "30 days",
      ],
      correct: "B"
    },
    {
      id: 70773,
      question: "What are Koplik\'s spots?",
      options: [
        "Red spots on the skin",
        "Bluish-white spots with dark-red areolae on the buccal mucosa",
        "Black spots on the tongue",
        "Yellow spots on the tonsils",
      ],
      correct: "B"
    },
    {
      id: 70774,
      question: "Where are Koplik\'s spots located?",
      options: [
        "On the skin",
        "On the buccal mucosa or close to orifice of the parotid duct",
        "On the palate",
        "On the tongue dorsum",
      ],
      correct: "B"
    },
    {
      id: 70775,
      question: "What happens to Koplik\'s spots as more rashes develop?",
      options: [
        "They increase in number",
        "They disappear",
        "They become larger",
        "They change color to red",
      ],
      correct: "B"
    },
    {
      id: 70776,
      question: "Which of the following is NOT a symptom of measles?",
      options: [
        "Fever",
        "Conjunctivitis",
        "Diarrhea",
        "Exanthematous rash",
      ],
      correct: "C"
    },
    {
      id: 70777,
      question: "What is a cofactor for gangrenous stomatitis and noma in measles?",
      options: [
        "Poor nutrition",
        "Acute necrotizing ulcerative gingivitis",
        "Bacterial infection",
        "Fungal infection",
      ],
      correct: "B"
    },
    {
      id: 70778,
      question: "What does SSPE stand for in measles complications?",
      options: [
        "Subacute sclerosing panencephalitis",
        "Severe systemic pulmonary edema",
        "Secondary systemic pneumonia episode",
        "Subacute systemic peripheral encephalitis",
      ],
      correct: "A"
    },
    {
      id: 70779,
      question: "What population does SSPE affect?",
      options: [
        "Elderly",
        "Children and adolescents",
        "Adults only",
        "Infants only",
      ],
      correct: "B"
    },
    {
      id: 70780,
      question: "What vaccine prevents measles?",
      options: [
        "BCG vaccine",
        "MMR vaccine (live attenuated)",
        "DPT vaccine",
        "Hib vaccine",
      ],
      correct: "B"
    },
    {
      id: 70781,
      question: "What conditions does respiratory syncytial virus cause?",
      options: [
        "Skin rashes",
        "Pneumonia and bronchiolitis in infants and children",
        "Meningitis",
        "Hepatitis",
      ],
      correct: "B"
    },
    {
      id: 70782,
      question: "Which HSV type is mostly found above the belt?",
      options: [
        "HSV-1",
        "HSV-2",
        "HSV-3",
        "HSV-4",
      ],
      correct: "A"
    },
    {
      id: 70783,
      question: "Which HSV type is mainly found below the belt?",
      options: [
        "HSV-1",
        "HSV-2",
        "HSV-3",
        "HSV-4",
      ],
      correct: "B"
    },
    {
      id: 70784,
      question: "What eye condition can result from HSV infection?",
      options: [
        "Cataracts",
        "Conjunctivitis and keratitis that may result in blindness",
        "Glaucoma",
        "Retinal detachment",
      ],
      correct: "B"
    },
    {
      id: 70785,
      question: "In which gender are oral squamous papillomas more common?",
      options: [
        "Women",
        "Men",
        "Equal in both",
        "Children only",
      ],
      correct: "B"
    },
    {
      id: 70786,
      question: "What type of cancer can certain HPV serotypes cause along with lymphoma?",
      options: [
        "Lung cancer",
        "Vulvar cancer",
        "Liver cancer",
        "Brain cancer",
      ],
      correct: "B"
    },
    {
      id: 70787,
      question: "What antiviral drugs are helpful for treating shingles?",
      options: [
        "Amantadine and rimantadine",
        "Systemic vidarabine and aciclovir",
        "Tamiflu and ribavirin",
        "Interferon and immunoglobulin",
      ],
      correct: "B"
    },
    {
      id: 70788,
      question: "What can ophthalmic nerve involvement in shingles lead to?",
      options: [
        "Hearing loss",
        "Eye lesion and blindness",
        "Facial paralysis only",
        "Skin lesions only",
      ],
      correct: "B"
    },
    {
      id: 70789,
      question: "What severe oral condition can shingles pain be confused with?",
      options: [
        "Gingivitis",
        "Toothache",
        "Oral cancer",
        "Thrush",
      ],
      correct: "B"
    },
    {
      id: 70790,
      question: "What causes postnatal CMV infection?",
      options: [
        "Direct contact only",
        "Pregnancy, immunosuppression, and blood transfusion",
        "Respiratory droplets",
        "Contaminated food",
      ],
      correct: "B"
    },
    {
      id: 70791,
      question: "How is HHV-6 transmitted?",
      options: [
        "Blood transfusion only",
        "Saliva",
        "Sexual contact",
        "Insect vectors",
      ],
      correct: "B"
    },
    {
      id: 70792,
      question: "What is febrile pharyngoconjunctivitis caused by?",
      options: [
        "Herpes simplex virus",
        "Adenovirus",
        "Measles virus",
        "Mumps virus",
      ],
      correct: "B"
    },
    {
      id: 70793,
      question: "What type of infection does adenovirus cause that resembles influenza?",
      options: [
        "Gastroenteritis",
        "Acute respiratory disease",
        "Skin infection",
        "Urinary tract infection",
      ],
      correct: "B"
    },
    {
      id: 70794,
      question: "Is chickenpox mild or severe in adults compared to children?",
      options: [
        "Milder in adults",
        "More severe in adults",
        "Same severity",
        "Only affects children",
      ],
      correct: "B"
    },
    {
      id: 70795,
      question: "What is the relationship between Koplik\'s spots and skin rashes in measles?",
      options: [
        "They appear together",
        "As more rashes develop, more Koplik\'s spots disappear",
        "Koplik\'s spots appear after rashes",
        "They are unrelated",
      ],
      correct: "B"
    },
    {
      id: 70796,
      question: "What does gangrenous stomatitis and noma lead to in measles?",
      options: [
        "Lung damage",
        "Orofacial tissue destruction and disfigurement",
        "Liver failure",
        "Kidney failure",
      ],
      correct: "B"
    },
    {
      id: 70797,
      question: "What other complications can occur with measles besides SSPE?",
      options: [
        "Diabetes and hypertension",
        "Bronchopneumonia and otitis media",
        "Arthritis and myalgia",
        "Hepatitis and nephritis",
      ],
      correct: "B"
    },
    {
      id: 70798,
      question: "What is encephalomyelitis in the context of measles?",
      options: [
        "Skin complication",
        "Neurological complication",
        "Respiratory complication",
        "Gastrointestinal complication",
      ],
      correct: "B"
    },
    {
      id: 70799,
      question: "What are the common symptoms of avian influenza?",
      options: [
        "Skin rash and joint pain",
        "Fever, cough, bleeding nose, chest pain, headache, sore throat, and diarrhea",
        "Vomiting and abdominal pain only",
        "Eye infection and headache only",
      ],
      correct: "B"
    },
    {
      id: 70800,
      question: "Which structures are affected in Ramsay Hunt syndrome?",
      options: [
        "Lungs and heart",
        "External auditory canal and tympanic membrane",
        "Liver and spleen",
        "Kidneys and bladder",
      ],
      correct: "B"
    },
    {
      id: 70801,
      question: "What facial symptom accompanies Ramsay Hunt syndrome?",
      options: [
        "Bilateral facial palsy",
        "Unilateral facial palsy",
        "Facial numbness only",
        "Facial swelling only",
      ],
      correct: "B"
    },
    {
      id: 70802,
      question: "How is chickenpox prevented?",
      options: [
        "VZIG",
        "Vaccine",
        "Antibiotics",
        "Antifungals",
      ],
      correct: "B"
    },
    {
      id: 70803,
      question: "What is the H5N2 designation referring to?",
      options: [
        "Herpes simplex virus type",
        "Avian influenza (bird flu)",
        "Human papillomavirus type",
        "Hepatitis virus type",
      ],
      correct: "B"
    },
    {
      id: 70804,
      question: "What type of tumor is a wart?",
      options: [
        "Malignant",
        "Benign epithelial",
        "Metastatic",
        "Inflammatory",
      ],
      correct: "B"
    },
    {
      id: 70805,
      question: "What happens when anogenital warts are examined in cervical biopsies?",
      options: [
        "They cannot be detected",
        "They can be distinguished by specific HPV serotypes",
        "They appear as bacterial infections",
        "They show fungal elements",
      ],
      correct: "B"
    },
    {
      id: 70806,
      question: "Is infectious mononucleosis self-limiting?",
      options: [
        "No, it requires extensive treatment",
        "Yes, it is self-limiting",
        "It always leads to chronic infection",
        "It always requires hospitalization",
      ],
      correct: "B"
    },
    {
      id: 70807,
      question: "What cell abnormality is seen in infectious mononucleosis?",
      options: [
        "Red blood cell abnormality",
        "Lymphocyte abnormality",
        "Platelet abnormality",
        "Neutrophil abnormality",
      ],
      correct: "B"
    },
    {
      id: 70808,
      question: "What is tonsillitis a symptom of in EBV infection?",
      options: [
        "Primary infection only",
        "Infectious mononucleosis",
        "Burkitt\'s lymphoma",
        "Nasopharyngeal carcinoma",
      ],
      correct: "B"
    },
    {
      id: 70809,
      question: "What type of vaccine is the MMR vaccine?",
      options: [
        "Killed vaccine",
        "Live attenuated vaccine",
        "Toxoid vaccine",
        "Subunit vaccine",
      ],
      correct: "B"
    },
    {
      id: 70810,
      question: "What is antigenic drift in influenza viruses?",
      options: [
        "Major genetic reassortment",
        "Minor gradual mutations in H and N antigens",
        "Complete change in virus type",
        "Loss of all antigens",
      ],
      correct: "B"
    },
    {
      id: 70811,
      question: "What is antigenic shift in influenza viruses?",
      options: [
        "Minor mutations",
        "Major genetic reassortment creating new virus strains",
        "No change in antigens",
        "Gradual loss of infectivity",
      ],
      correct: "B"
    },
    {
      id: 70812,
      question: "Which virus family comprises enteroviruses and rhinoviruses?",
      options: [
        "Picornaviruses",
        "Togaviruses",
        "Coronaviruses",
        "Herpesviruses",
      ],
      correct: "A"
    },
    {
      id: 70813,
      question: "What is the causative agent of paralytic poliomyelitis?",
      options: [
        "Coxsackievirus",
        "Poliovirus",
        "Rhinovirus",
        "Echovirus",
      ],
      correct: "B"
    },
    {
      id: 70814,
      question: "How is poliovirus primarily transmitted?",
      options: [
        "Blood transfusion only",
        "Sexual contact only",
        "Contaminated water and direct contact via pharyngeal secretion",
        "Insect bites",
      ],
      correct: "C"
    },
    {
      id: 70815,
      question: "Which vaccine type is the Salk vaccine for poliomyelitis?",
      options: [
        "Live attenuated vaccine",
        "Subunit vaccine",
        "mRNA vaccine",
        "Killed vaccine",
      ],
      correct: "D"
    },
    {
      id: 70816,
      question: "Which vaccine type is the Sabin vaccine for poliomyelitis?",
      options: [
        "Live attenuated vaccine",
        "Killed vaccine",
        "Subunit vaccine",
        "Viral vector vaccine",
      ],
      correct: "A"
    },
    {
      id: 70817,
      question: "How many major groups do Coxsackieviruses consist of?",
      options: [
        "One",
        "Two",
        "Three",
        "Four",
      ],
      correct: "B"
    },
    {
      id: 70818,
      question: "Which disease is characterized by fever, sore throat, dysphagia, anorexia, headache, stiff neck and herpes-like oropharyngitis?",
      options: [
        "Hand, foot and mouth disease",
        "Common cold",
        "Herpangina",
        "Rubella",
      ],
      correct: "C"
    },
    {
      id: 70819,
      question: "What is the appearance of lesions in herpangina?",
      options: [
        "Bright-red macules with blue areolae",
        "Large bullae with clear fluid",
        "Flat brown patches",
        "Papulovesicular with grayish-white and red areolae",
      ],
      correct: "D"
    },
    {
      id: 70820,
      question: "Which areas of the body are affected by Hand, foot and mouth disease?",
      options: [
        "Mouth, plantar surface of feet, palmar surface of hands, and buttocks",
        "Only the oral cavity",
        "Only the respiratory tract",
        "Only the genital area",
      ],
      correct: "A"
    },
    {
      id: 70821,
      question: "What is the initial appearance of lesions in Hand, foot and mouth disease?",
      options: [
        "White pustules",
        "Bright-red macules that later become vesicles",
        "Black necrotic tissue",
        "Yellow crusted plaques",
      ],
      correct: "B"
    },
    {
      id: 70822,
      question: "How is Coxsackievirus transmitted?",
      options: [
        "Through contaminated blood only",
        "Through insect vectors only",
        "Via respiratory secretions and fecal-oral route",
        "Through skin contact only",
      ],
      correct: "C"
    },
    {
      id: 70823,
      question: "What disease does rhinovirus cause?",
      options: [
        "Paralytic poliomyelitis",
        "German measles",
        "Herpangina",
        "Common cold",
      ],
      correct: "D"
    },
    {
      id: 70824,
      question: "Which characteristic describes the common cold caused by rhinovirus?",
      options: [
        "Acute but afebrile disease",
        "Chronic and severe with high fever",
        "Always accompanied by pneumonia",
        "Results in permanent immunity",
      ],
      correct: "A"
    },
    {
      id: 70825,
      question: "How is rhinovirus primarily transmitted?",
      options: [
        "Fecal-oral route",
        "Respiratory droplets, especially nasal secretions",
        "Blood transfusion",
        "Contaminated food",
      ],
      correct: "B"
    },
    {
      id: 70826,
      question: "Why do colds caused by rhinovirus recur?",
      options: [
        "The virus mutates after each infection",
        "The immune system cannot recognize rhinovirus",
        "Various antigenic groups of rhinoviruses exist",
        "Rhinovirus destroys memory cells",
      ],
      correct: "C"
    },
    {
      id: 70827,
      question: "What disease do Togaviruses cause?",
      options: [
        "Common cold",
        "Poliomyelitis",
        "COVID-19",
        "Rubella (German measles)",
      ],
      correct: "D"
    },
    {
      id: 70828,
      question: "How is rubella transmitted?",
      options: [
        "Respiratory secretions",
        "Contaminated water",
        "Insect bites",
        "Sexual contact",
      ],
      correct: "A"
    },
    {
      id: 70829,
      question: "How does rubella compare to measles?",
      options: [
        "Rubella is longer and more severe",
        "Rubella is shorter and less severe",
        "They are identical in severity",
        "Rubella only affects adults",
      ],
      correct: "B"
    },
    {
      id: 70830,
      question: "What can congenital rubella syndrome cause?",
      options: [
        "Only mild symptoms",
        "Temporary skin rash only",
        "Severe abnormalities and even death",
        "Enhanced immunity in newborns",
      ],
      correct: "C"
    },
    {
      id: 70831,
      question: "What type of vaccine is MMR?",
      options: [
        "Killed vaccine",
        "Subunit vaccine",
        "mRNA vaccine",
        "Live attenuated vaccine",
      ],
      correct: "D"
    },
    {
      id: 70832,
      question: "When were coronaviruses first identified?",
      options: [
        "Mid-1960s",
        "1940s",
        "1950s",
        "1980s",
      ],
      correct: "A"
    },
    {
      id: 70833,
      question: "Why are coronaviruses named as such?",
      options: [
        "For the circular shape of their genome",
        "For the crown-like spikes on their envelope",
        "For being discovered during a solar eclipse",
        "For the color of infected cells",
      ],
      correct: "B"
    },
    {
      id: 70834,
      question: "How many main groupings of coronaviruses exist?",
      options: [
        "Two",
        "Three",
        "Four",
        "Five",
      ],
      correct: "C"
    },
    {
      id: 70835,
      question: "Which coronavirus type is 229E?",
      options: [
        "Beta coronavirus",
        "Gamma coronavirus",
        "Delta coronavirus",
        "Alpha coronavirus",
      ],
      correct: "D"
    },
    {
      id: 70836,
      question: "Which coronavirus type is OC43?",
      options: [
        "Beta coronavirus",
        "Alpha coronavirus",
        "Gamma coronavirus",
        "Delta coronavirus",
      ],
      correct: "A"
    },
    {
      id: 70837,
      question: "Which coronavirus causes MERS?",
      options: [
        "SARS-CoV",
        "MERS-CoV",
        "SARS-CoV-2",
        "NL63",
      ],
      correct: "B"
    },
    {
      id: 70838,
      question: "Which coronavirus causes COVID-19?",
      options: [
        "SARS-CoV",
        "MERS-CoV",
        "SARS-CoV-2",
        "OC43",
      ],
      correct: "C"
    },
    {
      id: 70839,
      question: "How many coronaviruses can infect humans?",
      options: [
        "Four",
        "Five",
        "Ten",
        "Seven",
      ],
      correct: "D"
    },
    {
      id: 70840,
      question: "Which animals commonly spread coronaviruses?",
      options: [
        "Camels, cows, pigs, cats and bats",
        "Only birds and fish",
        "Only domestic dogs",
        "Only reptiles",
      ],
      correct: "A"
    },
    {
      id: 70841,
      question: "What do coronaviruses cause in chickens?",
      options: [
        "Diarrhea",
        "Upper respiratory disease",
        "Skin infections",
        "Neurological disease",
      ],
      correct: "B"
    },
    {
      id: 70842,
      question: "What do coronaviruses cause in cows and pigs?",
      options: [
        "Upper respiratory disease",
        "Skin lesions",
        "Diarrhea",
        "Neurological symptoms",
      ],
      correct: "C"
    },
    {
      id: 70843,
      question: "When was MERS first reported?",
      options: [
        "2002",
        "2008",
        "2019",
        "2012",
      ],
      correct: "D"
    },
    {
      id: 70844,
      question: "Where was MERS first reported?",
      options: [
        "Saudi Arabia",
        "China",
        "United States",
        "Brazil",
      ],
      correct: "A"
    },
    {
      id: 70845,
      question: "From which animal did MERS originate?",
      options: [
        "Bats",
        "Camels",
        "Pigs",
        "Birds",
      ],
      correct: "B"
    },
    {
      id: 70846,
      question: "What is the mortality rate of MERS?",
      options: [
        "About 1 out of 10 patients",
        "About 2 out of 10 patients",
        "About 3 or 4 out of 10 patients",
        "About 8 out of 10 patients",
      ],
      correct: "C"
    },
    {
      id: 70847,
      question: "Where did SARS originate?",
      options: [
        "Northern China",
        "Saudi Arabia",
        "Southeast Asia",
        "Southern China",
      ],
      correct: "D"
    },
    {
      id: 70848,
      question: "When did SARS originate?",
      options: [
        "2002",
        "1998",
        "2000",
        "2012",
      ],
      correct: "A"
    },
    {
      id: 70849,
      question: "What is the approximate mortality rate of SARS?",
      options: [
        "1 percent",
        "10 percent",
        "5 percent",
        "30 percent",
      ],
      correct: "B"
    },
    {
      id: 70850,
      question: "Where did COVID-19 first emerge?",
      options: [
        "Beijing, China",
        "Hong Kong, China",
        "Wuhan, China",
        "Shanghai, China",
      ],
      correct: "C"
    },
    {
      id: 70851,
      question: "When did COVID-19 emerge?",
      options: [
        "November 2018",
        "January 2020",
        "March 2020",
        "December 2019",
      ],
      correct: "D"
    },
    {
      id: 70852,
      question: "When did WHO declare COVID-19 a pandemic?",
      options: [
        "March 11, 2020",
        "December 2019",
        "January 2020",
        "June 2020",
      ],
      correct: "A"
    },
    {
      id: 70853,
      question: "How long after exposure may COVID-19 symptoms develop?",
      options: [
        "1-3 days",
        "2-14 days",
        "15-21 days",
        "30-45 days",
      ],
      correct: "B"
    },
    {
      id: 70854,
      question: "Which is NOT a common symptom of COVID-19?",
      options: [
        "Dry cough and sore throat",
        "Loss of taste or smell",
        "Excessive hunger and weight gain",
        "Shortness of breath",
      ],
      correct: "C"
    },
    {
      id: 70855,
      question: "Which drug is authorized to treat hospitalized COVID-19 patients with severe symptoms?",
      options: [
        "Aspirin",
        "Ibuprofen",
        "Acetaminophen",
        "Remdesivir (Veklury)",
      ],
      correct: "D"
    },
    {
      id: 70856,
      question: "What is the minimum age for Remdesivir use in COVID-19 treatment?",
      options: [
        "12 years and older",
        "6 years and older",
        "16 years and older",
        "21 years and older",
      ],
      correct: "A"
    },
    {
      id: 70857,
      question: "For which patient group is Paxlovid prescribed?",
      options: [
        "Children under 12 years",
        "Patients older than 18 years with only 2 vaccine shots",
        "Pregnant women only",
        "Patients with no vaccination",
      ],
      correct: "B"
    },
    {
      id: 70858,
      question: "Which is a recommended supportive care measure for COVID-19?",
      options: [
        "Intense physical exercise",
        "Avoid all medications",
        "Drink plenty of liquids and rest",
        "Go to work immediately",
      ],
      correct: "C"
    },
    {
      id: 70859,
      question: "What type of COVID-19 vaccine is Pfizer-BioNTech?",
      options: [
        "Viral vector-based vaccine",
        "Killed vaccine",
        "Live attenuated vaccine",
        "mRNA vaccine",
      ],
      correct: "D"
    },
    {
      id: 70860,
      question: "What is the dosing schedule for Pfizer-BioNTech COVID-19 vaccine?",
      options: [
        "2 doses, 3 weeks apart",
        "1 dose",
        "2 doses, 4 weeks apart",
        "3 doses, 2 weeks apart",
      ],
      correct: "A"
    },
    {
      id: 70861,
      question: "What is the dosing schedule for Moderna COVID-19 vaccine?",
      options: [
        "1 dose",
        "2 doses, 4 weeks apart",
        "2 doses, 3 weeks apart",
        "3 doses, 1 week apart",
      ],
      correct: "B"
    },
    {
      id: 70862,
      question: "What type of vaccine is AstraZeneca COVID-19 vaccine?",
      options: [
        "mRNA vaccine",
        "Killed vaccine",
        "Viral vector-based vaccine",
        "Subunit vaccine",
      ],
      correct: "C"
    },
    {
      id: 70863,
      question: "How many doses does the Janssen COVID-19 vaccine require?",
      options: [
        "2 doses",
        "3 doses",
        "4 doses",
        "1 dose",
      ],
      correct: "D"
    },
    {
      id: 70864,
      question: "What is the minimum recommended handwashing time to prevent COVID-19?",
      options: [
        "20 seconds",
        "5 seconds",
        "10 seconds",
        "60 seconds",
      ],
      correct: "A"
    },
    {
      id: 70865,
      question: "What are the structural units of molds?",
      options: [
        "Spores",
        "Hyphae",
        "Conidia",
        "Blastospores",
      ],
      correct: "B"
    },
    {
      id: 70866,
      question: "What is a mass of hyphae called?",
      options: [
        "Spore",
        "Conidia",
        "Mycelium",
        "Septum",
      ],
      correct: "C"
    },
    {
      id: 70867,
      question: "How do yeasts reproduce?",
      options: [
        "Binary fission",
        "Conjugation",
        "Fragmentation",
        "Budding",
      ],
      correct: "D"
    },
    {
      id: 70868,
      question: "What are dimorphic fungi characterized by?",
      options: [
        "Existing as molds in environments/laboratory and yeasts in tissues",
        "Only existing as molds",
        "Only existing as yeasts",
        "Having no specific form",
      ],
      correct: "A"
    },
    {
      id: 70869,
      question: "How are clinically important fungi (including molds) classified due to their reproduction?",
      options: [
        "Perfect fungi",
        "Imperfect fungi",
        "Complete fungi",
        "Advanced fungi",
      ],
      correct: "B"
    },
    {
      id: 70870,
      question: "What environmental conditions do fungi typically require?",
      options: [
        "Low carbohydrate and high pH",
        "Low carbohydrate and low pH",
        "High carbohydrate and low pH",
        "High carbohydrate and high pH",
      ],
      correct: "C"
    },
    {
      id: 70871,
      question: "Why do fungi cause slowly progressive chronic infections?",
      options: [
        "They reproduce rapidly",
        "They have thick cell walls",
        "They are gram-negative",
        "They lack toxins",
      ],
      correct: "D"
    },
    {
      id: 70872,
      question: "Which Aspergillus secretion is an exception to fungi lacking toxins?",
      options: [
        "Aflatoxin",
        "Endotoxin",
        "Exotoxin",
        "Neurotoxin",
      ],
      correct: "A"
    },
    {
      id: 70873,
      question: "What makes Candida albicans virulent through tissue invasion?",
      options: [
        "Spore formation",
        "Hyphae formation ability",
        "Capsule production",
        "Flagella movement",
      ],
      correct: "B"
    },
    {
      id: 70874,
      question: "Which ability allows Candida albicans to adhere to host cells?",
      options: [
        "Capsule formation",
        "Flagella formation",
        "Biofilm formation",
        "Spore formation",
      ],
      correct: "C"
    },
    {
      id: 70875,
      question: "Which enzymes contribute to Candida albicans virulence?",
      options: [
        "Catalase and oxidase only",
        "Urease and lipase only",
        "Amylase and cellulase only",
        "Proteinase, phospholipase and hemolysin",
      ],
      correct: "D"
    },
    {
      id: 70876,
      question: "What type of mycoses affect keratinized tissues and mucosae?",
      options: [
        "Superficial mycoses",
        "Systemic mycoses",
        "Subcutaneous mycoses",
        "Deep mycoses",
      ],
      correct: "A"
    },
    {
      id: 70877,
      question: "What is another name for dermatophyte infections of keratinized structures?",
      options: [
        "Thrush",
        "Ringworm",
        "Candidiasis",
        "Cryptococcosis",
      ],
      correct: "B"
    },
    {
      id: 70878,
      question: "What causes subcutaneous mycoses?",
      options: [
        "Inhalation of spores",
        "Contaminated water",
        "Trauma",
        "Insect bites",
      ],
      correct: "C"
    },
    {
      id: 70879,
      question: "Which is an example of subcutaneous mycosis?",
      options: [
        "Thrush",
        "Ringworm",
        "Histoplasmosis",
        "Sporotrichosis",
      ],
      correct: "D"
    },
    {
      id: 70880,
      question: "What type of mycoses affect internal organs?",
      options: [
        "Systemic mycoses",
        "Superficial mycoses",
        "Subcutaneous mycoses",
        "Cutaneous mycoses",
      ],
      correct: "A"
    },
    {
      id: 70881,
      question: "Which is an example of systemic mycosis?",
      options: [
        "Ringworm",
        "Histoplasmosis",
        "Thrush",
        "Sporotrichosis",
      ],
      correct: "B"
    },
    {
      id: 70882,
      question: "In which patient populations are opportunist fungi a global problem?",
      options: [
        "Only athletes",
        "Only pregnant women",
        "Immunodeficient patients, cancer patients and transplant recipients",
        "Only elderly patients",
      ],
      correct: "C"
    },
    {
      id: 70883,
      question: "What are unicellular, gram-positive cells that replicate by budding called?",
      options: [
        "Molds",
        "Dimorphic fungi",
        "Dermatophytes",
        "Yeasts (blastospores)",
      ],
      correct: "D"
    },
    {
      id: 70884,
      question: "Which is the most medically prominent yeast?",
      options: [
        "Candida",
        "Cryptococcus",
        "Aspergillus",
        "Histoplasma",
      ],
      correct: "A"
    },
    {
      id: 70885,
      question: "What are the normal habitats of Candida albicans?",
      options: [
        "Soil and water only",
        "Oral cavity, skin, gastrointestinal tract and female genital tract",
        "Only hospital environments",
        "Only respiratory tract",
      ],
      correct: "B"
    },
    {
      id: 70886,
      question: "Which is a predisposing factor for candidiasis?",
      options: [
        "Regular exercise",
        "Balanced diet",
        "Chronic diseases",
        "Young age",
      ],
      correct: "C"
    },
    {
      id: 70887,
      question: "What is the most significant mucosal infection caused by C. albicans?",
      options: [
        "Ringworm",
        "Meningitis",
        "Pneumonia",
        "Thrush",
      ],
      correct: "D"
    },
    {
      id: 70888,
      question: "How does thrush appear clinically?",
      options: [
        "White pseudomembrane with erythema",
        "Black necrotic patches",
        "Large fluid-filled bullae",
        "Dry scaly plaques",
      ],
      correct: "A"
    },
    {
      id: 70889,
      question: "With what is candidal vulvovaginitis associated?",
      options: [
        "Pregnancy",
        "Oral contraceptive",
        "Menopause",
        "Antibiotic use only",
      ],
      correct: "B"
    },
    {
      id: 70890,
      question: "What type of lesions appear on warm and moist skin in C. albicans skin infections?",
      options: [
        "Flat macules",
        "Large bullae",
        "Vesicular pustules",
        "Dry scales",
      ],
      correct: "C"
    },
    {
      id: 70891,
      question: "What is nappy rash characterized by?",
      options: [
        "White patches on tongue",
        "Hair loss",
        "Nail discoloration only",
        "Severe burning of genitals or anus with macules and vesicles",
      ],
      correct: "D"
    },
    {
      id: 70892,
      question: "What type of infection is candidal paronychia?",
      options: [
        "Nail inflammation",
        "Oral infection",
        "Lung infection",
        "Brain infection",
      ],
      correct: "A"
    },
    {
      id: 70893,
      question: "In which occupations is candidal paronychia common?",
      options: [
        "Office workers",
        "Laundry workers or dishwashers",
        "Teachers",
        "Pilots",
      ],
      correct: "B"
    },
    {
      id: 70894,
      question: "What does deep candidiasis affect?",
      options: [
        "Only the skin",
        "Only the oral cavity",
        "Lower respiratory and urinary tract, eyes, kidneys, meninges and heart",
        "Only the nails",
      ],
      correct: "C"
    },
    {
      id: 70895,
      question: "What drug class is effective against superficial and oral candidiasis?",
      options: [
        "Aminoglycosides",
        "Beta-lactams",
        "Quinolones",
        "Polyenes",
      ],
      correct: "D"
    },
    {
      id: 70896,
      question: "What is the drug of choice for candidiasis in HIV-positive patients?",
      options: [
        "Fluconazole",
        "Amphotericin",
        "Nystatin",
        "Flucytosine",
      ],
      correct: "A"
    },
    {
      id: 70897,
      question: "What drugs are used for systemic candidiasis?",
      options: [
        "Polyenes only",
        "Amphotericin and flucytosine",
        "Azoles only",
        "Penicillin and amoxicillin",
      ],
      correct: "B"
    },
    {
      id: 70898,
      question: "What is the normal habitat of Cryptococcus neoformans?",
      options: [
        "Human oral cavity",
        "Animal intestines",
        "Soil",
        "Fresh water",
      ],
      correct: "C"
    },
    {
      id: 70899,
      question: "How is Cryptococcus neoformans transmitted?",
      options: [
        "Fecal-oral route",
        "Contaminated water",
        "Skin contact",
        "Respiratory droplets",
      ],
      correct: "D"
    },
    {
      id: 70900,
      question: "What disease does Cryptococcus neoformans cause?",
      options: [
        "Cryptococcal meningitis",
        "Thrush",
        "Ringworm",
        "Pneumonia only",
      ],
      correct: "A"
    },
    {
      id: 70901,
      question: "What are the drugs of choice for cryptococcosis?",
      options: [
        "Penicillin and amoxicillin",
        "Amphotericin and fluconazole",
        "Azithromycin and erythromycin",
        "Metronidazole and vancomycin",
      ],
      correct: "B"
    },
    {
      id: 70902,
      question: "Which dimorphic fungus causes blastomycosis?",
      options: [
        "Histoplasma capsulatum",
        "Coccidioides immitis",
        "Blastomyces dermatitidis",
        "Penicillium marneffei",
      ],
      correct: "C"
    },
    {
      id: 70903,
      question: "How are dimorphic fungi transmitted?",
      options: [
        "Fecal-oral route",
        "Sexual contact",
        "Blood transfusion",
        "Respiratory tract",
      ],
      correct: "D"
    },
    {
      id: 70904,
      question: "Where are the primary lesions of dimorphic fungal infections located?",
      options: [
        "Lungs",
        "Liver",
        "Heart",
        "Spleen",
      ],
      correct: "A"
    },
    {
      id: 70905,
      question: "What are the drugs of choice for infections caused by Blastomyces, Histoplasma, Penicillium marneffei, and Coccidioides?",
      options: [
        "Penicillin and cephalosporins",
        "Amphotericin and itraconazole",
        "Vancomycin and gentamicin",
        "Tetracycline and doxycycline",
      ],
      correct: "B"
    },
    {
      id: 70906,
      question: "Which fungus causes histoplasmosis?",
      options: [
        "Blastomyces dermatitidis",
        "Coccidioides immitis",
        "Histoplasma capsulatum",
        "Candida albicans",
      ],
      correct: "C"
    },
    {
      id: 70907,
      question: "Which is NOT one of the four main groupings of coronaviruses?",
      options: [
        "Alpha",
        "Beta",
        "Gamma",
        "Epsilon",
      ],
      correct: "D"
    },
    {
      id: 70908,
      question: "What symptoms does MERS usually include?",
      options: [
        "Fever, cough, shortness of breath, often progressing to pneumonia",
        "Only skin rash",
        "Only gastrointestinal symptoms",
        "Only neurological symptoms",
      ],
      correct: "A"
    },
    {
      id: 70909,
      question: "What symptoms does SARS include?",
      options: [
        "Only respiratory symptoms",
        "Fever, chills, body aches, may progress to pneumonia",
        "Only skin manifestations",
        "Only gastrointestinal symptoms",
      ],
      correct: "B"
    },
    {
      id: 70910,
      question: "Which type of vaccine is Moderna COVID-19 vaccine?",
      options: [
        "Viral vector-based vaccine",
        "Killed vaccine",
        "mRNA vaccine",
        "Live attenuated vaccine",
      ],
      correct: "C"
    },
    {
      id: 70911,
      question: "What is the dosing interval for AstraZeneca COVID-19 vaccine?",
      options: [
        "1-2 weeks apart",
        "3 weeks apart",
        "6 months apart",
        "4-12 weeks apart",
      ],
      correct: "D"
    },
    {
      id: 70912,
      question: "Which COVID-19 prevention measure involves keeping distance from others?",
      options: [
        "Physical distancing",
        "Hand hygiene",
        "Surface disinfection",
        "Travel restriction",
      ],
      correct: "A"
    },
    {
      id: 70913,
      question: "What are the three medically important types of fungi?",
      options: [
        "Bacteria, viruses, and parasites",
        "Molds, yeasts, and dimorphic fungi",
        "Aerobic, anaerobic, and facultative fungi",
        "Gram-positive, gram-negative, and acid-fast fungi",
      ],
      correct: "B"
    },
    {
      id: 70914,
      question: "What divides hyphae into single cells?",
      options: [
        "Cell walls",
        "Capsules",
        "Porous septa",
        "Membranes",
      ],
      correct: "C"
    },
    {
      id: 70915,
      question: "What is the shape of yeast cells?",
      options: [
        "Rod-shaped",
        "Spiral",
        "Filamentous",
        "Spherical or oval",
      ],
      correct: "D"
    },
    {
      id: 70916,
      question: "Which of the following is a predisposing factor for candidiasis?",
      options: [
        "Disturbed oral microflora",
        "Healthy immune system",
        "Balanced oral microflora",
        "Young adulthood",
      ],
      correct: "A"
    },
    {
      id: 70917,
      question: "What type of reproduction do clinically important fungi have?",
      options: [
        "Sexual reproduction only",
        "Asexual reproduction only",
        "Both sexual and asexual reproduction",
        "No reproduction capability",
      ],
      correct: "B"
    },
    {
      id: 70918,
      question: "Which two infections are significant superficial mycoses?",
      options: [
        "Histoplasmosis and blastomycosis",
        "Cryptococcosis and coccidioidomycosis",
        "Dermatophytosis and thrush",
        "Sporotrichosis and mycetoma",
      ],
      correct: "C"
    },
    {
      id: 70919,
      question: "What happens in subcutaneous mycoses?",
      options: [
        "Only skin discoloration",
        "Temporary rash",
        "Only nail changes",
        "Sinus formation, tissue destruction and chronic disease",
      ],
      correct: "D"
    },
    {
      id: 70920,
      question: "Which is an example of a deep mycosis?",
      options: [
        "Coccidioidomycosis",
        "Thrush",
        "Ringworm",
        "Sporotrichosis",
      ],
      correct: "A"
    },
    {
      id: 70921,
      question: "What structures can some yeasts produce?",
      options: [
        "True hyphae only",
        "Pseudohyphae",
        "Spores only",
        "Conidia only",
      ],
      correct: "B"
    },
    {
      id: 70922,
      question: "What type of candidiasis involves both skin and mucosal infection?",
      options: [
        "Systemic candidiasis",
        "Oral candidiasis",
        "Mucocutaneous candidiasis",
        "Cutaneous candidiasis only",
      ],
      correct: "C"
    },
    {
      id: 70923,
      question: "Which factor contributes to Candida albicans virulence?",
      options: [
        "Slow growth rate",
        "Lack of enzymes",
        "Inability to form biofilms",
        "Antigen heterogeneity",
      ],
      correct: "D"
    },
    {
      id: 70924,
      question: "What is the oxygen requirement for most fungi?",
      options: [
        "Mostly aerobic",
        "Strictly anaerobic",
        "Facultatively anaerobic",
        "Microaerophilic",
      ],
      correct: "A"
    },
    {
      id: 70925,
      question: "Where can lesions from dimorphic fungi rarely appear besides lungs?",
      options: [
        "Only in blood",
        "Skin, oral cavity and mucous membranes",
        "Only in bones",
        "Only in muscles",
      ],
      correct: "B"
    },
    {
      id: 70926,
      question: "What clinical presentation does cryptococcosis have?",
      options: [
        "Skin rash only",
        "Only respiratory symptoms",
        "Similar to influenza together with meningitis",
        "Only gastrointestinal symptoms",
      ],
      correct: "C"
    },
    {
      id: 70927,
      question: "Which two categories of candidiasis can Candida cause?",
      options: [
        "Acute and chronic candidiasis",
        "Primary and secondary candidiasis",
        "Local and general candidiasis",
        "Superficial and systemic candidiasis",
      ],
      correct: "D"
    },
    {
      id: 70928,
      question: "Which enteroviruses are part of the Picornavirus family?",
      options: [
        "Polioviruses, coxsackieviruses, and echoviruses",
        "Only polioviruses",
        "Only rhinoviruses",
        "Coronaviruses and togaviruses",
      ],
      correct: "A"
    },
    {
      id: 70929,
      question: "What distinguishes the Salk vaccine from the Sabin vaccine?",
      options: [
        "Salk is oral, Sabin is injectable",
        "Salk is killed vaccine, Sabin is live attenuated",
        "Salk protects against more strains",
        "Salk requires more doses",
      ],
      correct: "B"
    },
    {
      id: 70930,
      question: "Which Coxsackievirus group causes herpangina?",
      options: [
        "Group B",
        "Group C",
        "Group A",
        "Group D",
      ],
      correct: "C"
    },
    {
      id: 70931,
      question: "What symptoms accompany Hand, foot and mouth disease besides lesions?",
      options: [
        "Only fever",
        "Only cough",
        "Only diarrhea",
        "Sore throat, headache, malaise and facial pain with parotid duct tenderness",
      ],
      correct: "D"
    },
    {
      id: 70932,
      question: "Which NL63 coronavirus type is it?",
      options: [
        "Alpha coronavirus",
        "Beta coronavirus",
        "Gamma coronavirus",
        "Delta coronavirus",
      ],
      correct: "A"
    },
    {
      id: 70933,
      question: "Which HKU1 coronavirus type is it?",
      options: [
        "Alpha coronavirus",
        "Beta coronavirus",
        "Gamma coronavirus",
        "Delta coronavirus",
      ],
      correct: "B"
    },
    {
      id: 70934,
      question: "What can coronaviruses cause in humans ranging from mild to severe?",
      options: [
        "Only skin infections",
        "Only gastrointestinal diseases",
        "Mild respiratory infections to life-threatening pneumonia",
        "Only neurological diseases",
      ],
      correct: "C"
    },
    {
      id: 70935,
      question: "To how many countries did MERS spread?",
      options: [
        "Less than 10 countries",
        "Exactly 50 countries",
        "Only Middle Eastern countries",
        "More than 25 countries",
      ],
      correct: "D"
    },
    {
      id: 70936,
      question: "Which COVID-19 symptom involves sensory changes?",
      options: [
        "Loss of taste or smell",
        "Muscle pain",
        "Dry cough",
        "Fever",
      ],
      correct: "A"
    },
    {
      id: 70937,
      question: "What is chest pain classified as in COVID-19?",
      options: [
        "A rare symptom",
        "A possible symptom",
        "Never occurs",
        "Only in children",
      ],
      correct: "B"
    },
    {
      id: 70938,
      question: "Which is a COVID-19 supportive care measure for respiratory relief?",
      options: [
        "Cold compress",
        "Vigorous exercise",
        "Use a humidifier or take a hot shower",
        "Cold air exposure",
      ],
      correct: "C"
    },
    {
      id: 70939,
      question: "What produces daughter cells in yeast reproduction?",
      options: [
        "Binary fission",
        "Conjugation",
        "Sporulation",
        "Budding",
      ],
      correct: "D"
    },
    {
      id: 70940,
      question: "What do hyphae contain?",
      options: [
        "Organelles and cytoplasm",
        "Only cell wall",
        "Only nucleus",
        "Only ribosomes",
      ],
      correct: "A"
    },
    {
      id: 70941,
      question: "Which is NOT a predisposing factor for candidiasis?",
      options: [
        "Malnutrition",
        "Regular exercise and healthy diet",
        "Age",
        "Smoking",
      ],
      correct: "B"
    },
    {
      id: 70942,
      question: "What causes mucocutaneous candidiasis?",
      options: [
        "Only mucosal infection",
        "Only systemic infection",
        "Both skin and mucosal infection by Candida",
        "Only nail infection",
      ],
      correct: "C"
    },
    {
      id: 70943,
      question: "Which drug class is also effective against superficial candidiasis besides polyenes?",
      options: [
        "Aminoglycosides",
        "Sulfonamides",
        "Macrolides",
        "Azoles",
      ],
      correct: "D"
    },
    {
      id: 70944,
      question: "Which fungus causes coccidioidomycosis?",
      options: [
        "Coccidioides immitis",
        "Blastomyces dermatitidis",
        "Histoplasma capsulatum",
        "Candida albicans",
      ],
      correct: "A"
    },
    {
      id: 70945,
      question: "Where was the seafood and poultry market located where COVID-19 first emerged?",
      options: [
        "Beijing",
        "Wuhan",
        "Shanghai",
        "Guangzhou",
      ],
      correct: "B"
    },
    {
      id: 70946,
      question: "Which is NOT recommended for COVID-19 prevention?",
      options: [
        "Washing hands with soap for 20 seconds",
        "Wearing a mask",
        "Sharing personal items",
        "Avoiding close contact with sick people",
      ],
      correct: "C"
    },
    {
      id: 70947,
      question: "What reference textbook is cited for this material?",
      options: [
        "Gray\'s Anatomy",
        "Harrison\'s Principles of Internal Medicine",
        "Robbins Pathology",
        "Samaranayake\'s Essential Microbiology for Dentistry",
      ],
      correct: "D"
    },
  ],
  "9. Viral Hepatitis and AIDS": [
    {
      id: 70800,
      question: "Which hepatitis viruses are transmitted via the fecal-oral route?",
      options: [
        "Hepatitis A and E",
        "Hepatitis B and C",
        "Hepatitis C and D",
        "Hepatitis B and G",
      ],
      correct: "A"
    },
    {
      id: 70801,
      question: "Which hepatitis viruses are transmitted via the parenteral route?",
      options: [
        "Hepatitis A and E",
        "Hepatitis B, C, D and G",
        "Hepatitis A, B and C",
        "Hepatitis E and G only",
      ],
      correct: "B"
    },
    {
      id: 70802,
      question: "What are the most common symptoms of viral hepatitis?",
      options: [
        "Cough, fever and headache",
        "Skin rash and joint pain only",
        "Jaundice, dark urine, fatty stools and malaise",
        "Diarrhea and vomiting only",
      ],
      correct: "C"
    },
    {
      id: 70803,
      question: "To which virus family does Hepatitis A virus belong?",
      options: [
        "Hepadnaviruses",
        "Flaviviruses",
        "Caliciviruses",
        "Picornaviruses",
      ],
      correct: "D"
    },
    {
      id: 70804,
      question: "How is Hepatitis A virus primarily transmitted?",
      options: [
        "Contaminated food and water",
        "Blood transfusion",
        "Sexual contact",
        "Respiratory droplets",
      ],
      correct: "A"
    },
    {
      id: 70805,
      question: "What is the most common symptom of Hepatitis A?",
      options: [
        "Skin rash",
        "Jaundice",
        "Diarrhea",
        "Headache",
      ],
      correct: "B"
    },
    {
      id: 70806,
      question: "Which statement best describes Hepatitis A infection?",
      options: [
        "It always becomes chronic",
        "It leads to liver cirrhosis",
        "It is a self-limiting viral hepatitis",
        "It requires lifelong treatment",
      ],
      correct: "C"
    },
    {
      id: 70807,
      question: "How can Hepatitis A be prevented for travelers and professionals?",
      options: [
        "Antiviral drugs only",
        "Live attenuated vaccine only",
        "Antibiotics prophylaxis",
        "Hyperimmune globulin and inactivated vaccine",
      ],
      correct: "D"
    },
    {
      id: 70808,
      question: "How can HAV be rarely transmitted in dentistry?",
      options: [
        "Saliva and needlestick injury",
        "Aerosols only",
        "Contaminated water only",
        "Surface contact only",
      ],
      correct: "A"
    },
    {
      id: 70809,
      question: "To which virus family does Hepatitis B virus belong?",
      options: [
        "Picornaviruses",
        "Hepadnaviruses",
        "Flaviviruses",
        "Caliciviruses",
      ],
      correct: "B"
    },
    {
      id: 70810,
      question: "How many different forms does HBV have?",
      options: [
        "Two",
        "Four",
        "Three",
        "Five",
      ],
      correct: "C"
    },
    {
      id: 70811,
      question: "Which form of HBV is the infective form?",
      options: [
        "Spherical form",
        "Tubular form",
        "Both spherical and tubular forms",
        "Dane particle",
      ],
      correct: "D"
    },
    {
      id: 70812,
      question: "What do the tubular and spherical forms of HBV represent?",
      options: [
        "Viral surface antigens (HBsAg)",
        "Core antigens (HBcAg)",
        "\"e\" antigens (HBeAg)",
        "DNA polymerase",
      ],
      correct: "A"
    },
    {
      id: 70813,
      question: "What components does the Dane particle consist of?",
      options: [
        "RNA and RNA polymerase only",
        "DNA, DNA polymerase, HBsAg, HBcAg and HBeAg",
        "Protein coat only",
        "Lipid envelope only",
      ],
      correct: "B"
    },
    {
      id: 70814,
      question: "What does the presence of HBsAg in serum for a long time after acute hepatitis indicate?",
      options: [
        "Active infection",
        "Recovery",
        "Carrier state",
        "Immunity",
      ],
      correct: "C"
    },
    {
      id: 70815,
      question: "Which HBV antigen is NOT present in the serum?",
      options: [
        "HBsAg",
        "HBeAg",
        "All antigens are present in serum",
        "HBcAg",
      ],
      correct: "D"
    },
    {
      id: 70816,
      question: "What is HBeAg a marker of?",
      options: [
        "Active hepatitis",
        "Carrier state",
        "Recovery",
        "Immunity",
      ],
      correct: "A"
    },
    {
      id: 70817,
      question: "What are the target cells for HBV?",
      options: [
        "Neurons",
        "Hepatocytes",
        "Lymphocytes",
        "Erythrocytes",
      ],
      correct: "B"
    },
    {
      id: 70818,
      question: "What percentage of HBV-infected individuals suffer a chronic carrier state?",
      options: [
        "Up to 10%",
        "Up to 25%",
        "Up to 4%",
        "Up to 50%",
      ],
      correct: "C"
    },
    {
      id: 70819,
      question: "What is the characteristic of chronic carrier state in hepatitis B?",
      options: [
        "Icteric",
        "Symptomatic",
        "Acute",
        "Anicteric",
      ],
      correct: "D"
    },
    {
      id: 70820,
      question: "Which group of HB chronic carriers are healthy and have HBsAg for a long time?",
      options: [
        "Chronic persistent carriers",
        "Chronic active carriers",
        "Acute carriers",
        "Fulminant carriers",
      ],
      correct: "A"
    },
    {
      id: 70821,
      question: "What are chronic active carriers of HBV prone to develop?",
      options: [
        "Only mild symptoms",
        "Hepatocellular carcinoma or liver cirrhosis",
        "Complete recovery",
        "Natural immunity",
      ],
      correct: "B"
    },
    {
      id: 70822,
      question: "Where is the most voluminous amount of HBV found in the oral cavity?",
      options: [
        "Tongue surface",
        "Palate",
        "Gingival sulcus",
        "Buccal mucosa",
      ],
      correct: "C"
    },
    {
      id: 70823,
      question: "Which dental specialists are at higher risk for HBV infection?",
      options: [
        "Orthodontists and prosthodontists",
        "Pediatric dentists only",
        "Endodontists only",
        "Periodontists and oral surgeons",
      ],
      correct: "D"
    },
    {
      id: 70824,
      question: "What is used for treatment of chronic HBV carriers?",
      options: [
        "α-interferon",
        "Penicillin",
        "Amoxicillin",
        "Metronidazole",
      ],
      correct: "A"
    },
    {
      id: 70825,
      question: "What technology is the HBV vaccine based on?",
      options: [
        "Live attenuated virus",
        "DNA recombinant technology",
        "Killed virus",
        "Subunit protein only",
      ],
      correct: "B"
    },
    {
      id: 70826,
      question: "To which virus family does Hepatitis C virus belong?",
      options: [
        "Hepadnaviruses",
        "Picornaviruses",
        "Flaviviruses",
        "Caliciviruses",
      ],
      correct: "C"
    },
    {
      id: 70827,
      question: "How does HCV stability compare to HBV?",
      options: [
        "Less stable than HBV",
        "Equally stable as HBV",
        "Completely unstable",
        "More stable than HBV",
      ],
      correct: "D"
    },
    {
      id: 70828,
      question: "How is Hepatitis C primarily transmitted?",
      options: [
        "Blood transfusion, organ donation and drug injection",
        "Fecal-oral route",
        "Respiratory droplets",
        "Contaminated food",
      ],
      correct: "A"
    },
    {
      id: 70829,
      question: "In which patient group is HCV commonly transmitted?",
      options: [
        "Diabetic patients",
        "Hemophiliac patients",
        "Cardiac patients",
        "Renal patients only",
      ],
      correct: "B"
    },
    {
      id: 70830,
      question: "In which population is the initial HCV infection often asymptomatic?",
      options: [
        "Elderly patients",
        "Middle-aged adults",
        "Children and young adults",
        "Pregnant women",
      ],
      correct: "C"
    },
    {
      id: 70831,
      question: "How does HCV compare to HBV in causing chronic liver diseases, HCC and LC?",
      options: [
        "HCV causes fewer cases",
        "They cause equal cases",
        "HCV never causes these conditions",
        "HCV causes much more cases",
      ],
      correct: "D"
    },
    {
      id: 70832,
      question: "Which conditions can HCV also lead to besides liver disease?",
      options: [
        "Thrombocytopenia, cryoglobulinemia, thyroid disorders and diabetes",
        "Cardiac disorders only",
        "Renal failure only",
        "Neurological disorders only",
      ],
      correct: "A"
    },
    {
      id: 70833,
      question: "In which oral conditions can HCV be detected?",
      options: [
        "Dental caries only",
        "Salivary gland infections and lichen planus",
        "Periodontal disease only",
        "Oral cancer only",
      ],
      correct: "B"
    },
    {
      id: 70834,
      question: "What is the importance of HCV in dentistry?",
      options: [
        "Very important",
        "Most important hepatitis virus",
        "Not of great importance",
        "Requires special protocols",
      ],
      correct: "C"
    },
    {
      id: 70835,
      question: "Which drugs are effective against HCV?",
      options: [
        "Penicillin and amoxicillin",
        "Metronidazole and tetracycline",
        "Vancomycin and gentamicin",
        "α-interferon, ribavirin and aciclovir",
      ],
      correct: "D"
    },
    {
      id: 70836,
      question: "To which virus family does Hepatitis D virus belong?",
      options: [
        "Deltaviruses",
        "Flaviviruses",
        "Hepadnaviruses",
        "Picornaviruses",
      ],
      correct: "A"
    },
    {
      id: 70837,
      question: "What is unique about Hepatitis D virus?",
      options: [
        "It is the largest hepatitis virus",
        "It is a defective RNA virus accompanied by HBV",
        "It can replicate independently",
        "It only causes acute infections",
      ],
      correct: "B"
    },
    {
      id: 70838,
      question: "What is the outcome of HDV co-infection in HB patients?",
      options: [
        "Chronic active hepatitis",
        "Always fatal",
        "Self-limiting",
        "Liver transplant required",
      ],
      correct: "C"
    },
    {
      id: 70839,
      question: "What does HDV superinfection in HB carriers lead to?",
      options: [
        "Self-limiting infection",
        "Complete recovery",
        "Natural immunity",
        "Chronic active hepatitis",
      ],
      correct: "D"
    },
    {
      id: 70840,
      question: "What are the clinical features of HDV?",
      options: [
        "Jaundice, fulminant liver disease, chronic hepatitis and LC",
        "Only mild symptoms",
        "Only skin manifestations",
        "Only gastrointestinal symptoms",
      ],
      correct: "A"
    },
    {
      id: 70841,
      question: "How can HDV infections be prevented?",
      options: [
        "HDV-specific vaccine",
        "HBV vaccine",
        "Immune globulin only",
        "Antiviral prophylaxis",
      ],
      correct: "B"
    },
    {
      id: 70842,
      question: "Can Delta hepatitis be transmitted via dental procedures?",
      options: [
        "No, never",
        "Only through saliva",
        "Yes, it is transmissible",
        "Only through aerosols",
      ],
      correct: "C"
    },
    {
      id: 70843,
      question: "To which virus family does Hepatitis E virus belong?",
      options: [
        "Flaviviruses",
        "Hepadnaviruses",
        "Picornaviruses",
        "Caliciviruses",
      ],
      correct: "D"
    },
    {
      id: 70844,
      question: "How is Hepatitis E primarily transmitted?",
      options: [
        "Fecal-oral route, especially water",
        "Blood transfusion",
        "Sexual contact",
        "Respiratory droplets",
      ],
      correct: "A"
    },
    {
      id: 70845,
      question: "How do clinical features of HE compare to HA?",
      options: [
        "Very different",
        "Similar to HA",
        "More severe than HA",
        "Only affects liver",
      ],
      correct: "B"
    },
    {
      id: 70846,
      question: "What is HEV\'s association with fulminant hepatitis?",
      options: [
        "Very common",
        "Never occurs",
        "Rarely associated",
        "Always occurs",
      ],
      correct: "C"
    },
    {
      id: 70847,
      question: "To which virus family does Hepatitis G virus probably belong?",
      options: [
        "Caliciviruses",
        "Hepadnaviruses",
        "Deltaviruses",
        "Flaviviruses",
      ],
      correct: "D"
    },
    {
      id: 70848,
      question: "What type of hepatitis does HGV cause?",
      options: [
        "Both acute and chronic hepatitis",
        "Only acute hepatitis",
        "Only chronic hepatitis",
        "Only fulminant hepatitis",
      ],
      correct: "A"
    },
    {
      id: 70849,
      question: "Among which populations is HGV transmissible?",
      options: [
        "Children only",
        "Injecting drug abusers and hemophiliac patients",
        "Elderly only",
        "Athletes only",
      ],
      correct: "B"
    },
    {
      id: 70850,
      question: "What is the status of HGV transmission via dental procedures?",
      options: [
        "Confirmed transmission route",
        "Definitely not transmitted",
        "Uncertain",
        "Primary transmission route",
      ],
      correct: "C"
    },
    {
      id: 70851,
      question: "What type of virus is TTV (Transfusion-Transmitted Virus)?",
      options: [
        "Double-stranded RNA virus",
        "Enveloped RNA virus",
        "Double-stranded DNA virus",
        "Single-stranded, non-enveloped DNA virus",
      ],
      correct: "D"
    },
    {
      id: 70852,
      question: "What is the most significant feature of TTV?",
      options: [
        "Chronic viremia",
        "Acute hepatitis",
        "Fulminant disease",
        "Self-limiting infection",
      ],
      correct: "A"
    },
    {
      id: 70853,
      question: "How is TTV transmitted?",
      options: [
        "Fecal-oral route",
        "Parenterally",
        "Respiratory droplets",
        "Contaminated food",
      ],
      correct: "B"
    },
    {
      id: 70854,
      question: "What type of genetic material do SEN viruses have?",
      options: [
        "Double-stranded DNA",
        "Single-stranded RNA",
        "Single-stranded, circular DNA",
        "Double-stranded RNA",
      ],
      correct: "C"
    },
    {
      id: 70855,
      question: "What type of hepatitis do SEN viruses produce?",
      options: [
        "Acute hepatitis only",
        "Chronic hepatitis only",
        "Fulminant hepatitis",
        "Post-transfusion hepatitis (related to non-A-E)",
      ],
      correct: "D"
    },
    {
      id: 70856,
      question: "What opportunistic infections are HIV-positive patients susceptible to?",
      options: [
        "PCP, candidiasis and neoplasms like Kaposi\'s sarcoma",
        "Only bacterial infections",
        "Only viral infections",
        "Only fungal infections",
      ],
      correct: "A"
    },
    {
      id: 70857,
      question: "What is the most significant feature indicating immunodeficiency in HIV?",
      options: [
        "Low hemoglobin",
        "CD4+ TH count less than 200/mm3",
        "High white blood cell count",
        "Low platelet count",
      ],
      correct: "B"
    },
    {
      id: 70858,
      question: "What is the maximum incubation period for HIV?",
      options: [
        "Up to 1 year",
        "Up to 5 years",
        "Up to 10 years",
        "Up to 20 years",
      ],
      correct: "C"
    },
    {
      id: 70859,
      question: "To which virus family does HIV belong?",
      options: [
        "Flaviviridae",
        "Hepadnaviridae",
        "Picornaviridae",
        "Retroviridae",
      ],
      correct: "D"
    },
    {
      id: 70860,
      question: "How many subfamilies does the Retroviridae family consist of?",
      options: [
        "Three",
        "Two",
        "Four",
        "Five",
      ],
      correct: "A"
    },
    {
      id: 70861,
      question: "Which subfamily of Retroviridae causes progressive slow infection?",
      options: [
        "Spumaviruses",
        "Lentiviruses",
        "Oncoviruses",
        "Deltaviruses",
      ],
      correct: "B"
    },
    {
      id: 70862,
      question: "Which HIV type is more prevalent?",
      options: [
        "HIV-2",
        "Both are equally prevalent",
        "HIV-1",
        "HIV-3",
      ],
      correct: "C"
    },
    {
      id: 70863,
      question: "What do Oncoviruses cause?",
      options: [
        "Progressive slow infection",
        "Acute infections only",
        "No disease",
        "Tumours and ATLL",
      ],
      correct: "D"
    },
    {
      id: 70864,
      question: "What type of genome does HIV have?",
      options: [
        "Diploid RNA genome",
        "Single-stranded DNA",
        "Double-stranded DNA",
        "Single RNA strand",
      ],
      correct: "A"
    },
    {
      id: 70865,
      question: "How many reverse transcriptase molecules does HIV contain?",
      options: [
        "One",
        "Two",
        "Three",
        "Four",
      ],
      correct: "B"
    },
    {
      id: 70866,
      question: "What is the function of gp120 in HIV?",
      options: [
        "Viral replication",
        "Provides structural support",
        "Facilitates attachment of HIV to CD4",
        "Enzyme activity",
      ],
      correct: "C"
    },
    {
      id: 70867,
      question: "What is the function of gp41 in HIV?",
      options: [
        "Attachment to cells",
        "DNA synthesis",
        "Protein synthesis",
        "Simplifies viral fusion and injection into the cell",
      ],
      correct: "D"
    },
    {
      id: 70868,
      question: "How long is HIV viable at room temperature?",
      options: [
        "15 days",
        "1 day",
        "7 days",
        "30 days",
      ],
      correct: "A"
    },
    {
      id: 70869,
      question: "How long does HIV exposure to disinfectants at room temperature take to be effective?",
      options: [
        "1 minute",
        "10 minutes",
        "5 minutes",
        "30 minutes",
      ],
      correct: "B"
    },
    {
      id: 70870,
      question: "How long does HIV exposure to bleach take to be effective?",
      options: [
        "10 seconds",
        "1 minute",
        "30 seconds",
        "5 minutes",
      ],
      correct: "C"
    },
    {
      id: 70871,
      question: "At what temperature is HIV highly sensitive to heat?",
      options: [
        "Over 37°C",
        "Over 45°C",
        "Over 80°C",
        "Over 60°C",
      ],
      correct: "D"
    },
    {
      id: 70872,
      question: "Which disinfectants are effective against HIV?",
      options: [
        "Ethanol, isopropanol, H2O2, glutaraldehyde and sodium hypochlorite",
        "Water and mild soap only",
        "Saline solution only",
        "Alcohol-free solutions only",
      ],
      correct: "A"
    },
    {
      id: 70873,
      question: "What are the routes of HIV transmission?",
      options: [
        "Respiratory droplets and food",
        "Sexual intercourse, mother to fetus, and direct injection into blood",
        "Contaminated water only",
        "Insect bites",
      ],
      correct: "B"
    },
    {
      id: 70874,
      question: "Why is HIV not viable in saliva?",
      options: [
        "Saliva is too acidic",
        "Saliva contains antibiotics",
        "Saliva is cell-free, has IgA, and anti-HIV factors like mucin and SLPI",
        "Saliva is too alkaline",
      ],
      correct: "C"
    },
    {
      id: 70875,
      question: "What does SLPI stand for?",
      options: [
        "Salivary lymphocyte protein inhibitor",
        "Serum leukocyte protein inhibitor",
        "Salivary lipase protease inhibitor",
        "Salivary leukocyte protease inhibitor",
      ],
      correct: "D"
    },
    {
      id: 70876,
      question: "How long does saliva exposure take to kill HIV?",
      options: [
        "30 minutes",
        "10 minutes",
        "1 hour",
        "2 hours",
      ],
      correct: "A"
    },
    {
      id: 70877,
      question: "What is the risk of HIV transmission by saliva in dental procedures?",
      options: [
        "Very high risk",
        "No risk except via contaminated needles",
        "Moderate risk",
        "Same as blood transmission",
      ],
      correct: "B"
    },
    {
      id: 70878,
      question: "When does acute seroconversion illness develop after HIV infection?",
      options: [
        "1-2 weeks",
        "2-3 months",
        "3-4 weeks",
        "6 months",
      ],
      correct: "C"
    },
    {
      id: 70879,
      question: "What are symptoms of acute seroconversion in HIV?",
      options: [
        "Only fever",
        "Only skin rash",
        "Only headache",
        "Fever, malaise, rash, oral ulcers, meningitis and encephalitis",
      ],
      correct: "D"
    },
    {
      id: 70880,
      question: "When do HIV antibodies become positive after infection?",
      options: [
        "6 months (might be 6-12 weeks)",
        "1-2 weeks",
        "2-4 weeks",
        "1 year",
      ],
      correct: "A"
    },
    {
      id: 70881,
      question: "What is PGL in the context of HIV?",
      options: [
        "Progressive generalized leukemia",
        "Persistent generalized lymphadenopathy",
        "Peripheral gland lymphoma",
        "Primary genital lesion",
      ],
      correct: "B"
    },
    {
      id: 70882,
      question: "What is Stage B of HIV infection called?",
      options: [
        "Acute seroconversion",
        "Full-blown AIDS",
        "AIDS-defining complex",
        "Asymptomatic period",
      ],
      correct: "C"
    },
    {
      id: 70883,
      question: "What are the features of Stage B (AIDS-defining complex)?",
      options: [
        "Only fever",
        "Only candidiasis",
        "Only weight loss",
        "Weight loss, fever, shingles, fatigue, diarrhea, candidiasis and leukoplakia",
      ],
      correct: "D"
    },
    {
      id: 70884,
      question: "What is Stage C of HIV called?",
      options: [
        "Full-blown AIDS",
        "Acute seroconversion",
        "AIDS-defining complex",
        "Asymptomatic period",
      ],
      correct: "A"
    },
    {
      id: 70885,
      question: "What causes PCP (Pneumocystis carinii pneumonia)?",
      options: [
        "Bacteria",
        "Extracellular protozoan",
        "Virus",
        "Fungus",
      ],
      correct: "B"
    },
    {
      id: 70886,
      question: "What is the normal habitat of Pneumocystis carinii?",
      options: [
        "Blood",
        "Liver",
        "Alveoli",
        "Intestines",
      ],
      correct: "C"
    },
    {
      id: 70887,
      question: "What is the drug of choice for PCP?",
      options: [
        "Penicillin",
        "Metronidazole",
        "Fluconazole",
        "Pentamidine",
      ],
      correct: "D"
    },
    {
      id: 70888,
      question: "What causes toxoplasmosis in AIDS patients?",
      options: [
        "Protozoan (Toxoplasma gondii)",
        "Bacteria",
        "Virus",
        "Fungus",
      ],
      correct: "A"
    },
    {
      id: 70889,
      question: "What is the target tissue for Toxoplasma gondii?",
      options: [
        "Liver",
        "CNS",
        "Heart",
        "Kidneys",
      ],
      correct: "B"
    },
    {
      id: 70890,
      question: "Which organisms cause mycobacteriosis in HIV patients?",
      options: [
        "Only M. tuberculosis",
        "Only MOTT",
        "M. tuberculosis and MOTT",
        "M. leprae only",
      ],
      correct: "C"
    },
    {
      id: 70891,
      question: "When does oral candidiasis commonly occur in HIV patients?",
      options: [
        "Only at late stage",
        "Only at terminal stage",
        "Never occurs",
        "At the early stage",
      ],
      correct: "D"
    },
    {
      id: 70892,
      question: "What may oral candidiasis in HIV patients be associated with?",
      options: [
        "Esophageal candidiasis due to azoles",
        "Pulmonary candidiasis",
        "Cardiac candidiasis",
        "Renal candidiasis",
      ],
      correct: "A"
    },
    {
      id: 70893,
      question: "What is the characteristic of herpetic stomatitis in AIDS?",
      options: [
        "Brief and localized",
        "Intraoral, persistent and extensive, but not disseminated",
        "Always disseminated",
        "Only affects lips",
      ],
      correct: "B"
    },
    {
      id: 70894,
      question: "What can herpetic stomatitis lead to in AIDS patients?",
      options: [
        "Liver damage",
        "Kidney failure",
        "Oral papillomas and warts",
        "Heart disease",
      ],
      correct: "C"
    },
    {
      id: 70895,
      question: "What type of tumor is Kaposi\'s sarcoma?",
      options: [
        "Epithelial tumor",
        "Bone tumor",
        "Nerve tumor",
        "Vascular endothelial tumor",
      ],
      correct: "D"
    },
    {
      id: 70896,
      question: "What causes Kaposi\'s sarcoma?",
      options: [
        "HHV-8",
        "HIV directly",
        "HPV",
        "EBV",
      ],
      correct: "A"
    },
    {
      id: 70897,
      question: "Where are the lesions of hairy leukoplakia located?",
      options: [
        "Palate",
        "Lateral border of the tongue",
        "Floor of mouth",
        "Buccal mucosa",
      ],
      correct: "B"
    },
    {
      id: 70898,
      question: "What is the appearance of hairy leukoplakia?",
      options: [
        "Red and thin lesions",
        "Black lesions",
        "White and thick lesions",
        "Yellow lesions",
      ],
      correct: "C"
    },
    {
      id: 70899,
      question: "What does necrotizing gingivitis begin as?",
      options: [
        "Chronic gingivitis",
        "Periodontitis",
        "Stomatitis",
        "Acute ulcerative gingivitis",
      ],
      correct: "D"
    },
    {
      id: 70900,
      question: "What can necrotizing periodontitis lead to?",
      options: [
        "Loss of soft tissue, bone and even tooth exfoliation",
        "Only gum inflammation",
        "Only tooth discoloration",
        "Only bleeding gums",
      ],
      correct: "A"
    },
    {
      id: 70901,
      question: "What is the best treatment for necrotizing gingivitis and periodontitis?",
      options: [
        "Penicillin and extraction",
        "Metronidazole and debridement",
        "Tetracycline only",
        "Surgery only",
      ],
      correct: "B"
    },
    {
      id: 70902,
      question: "Which drug class includes AZT, didanosine, stavudine, lamivudine, zalcitabine and nevirapine?",
      options: [
        "Protease inhibitors",
        "Fusion inhibitors",
        "RT inhibitors",
        "Entry inhibitors",
      ],
      correct: "C"
    },
    {
      id: 70903,
      question: "Which drug class includes saquinavir, ritonavir, indinavir and nelfinavir?",
      options: [
        "RT inhibitors",
        "Fusion inhibitors",
        "Entry inhibitors",
        "Protease inhibitors",
      ],
      correct: "D"
    },
    {
      id: 70904,
      question: "What does HAART stand for?",
      options: [
        "Highly active antiretroviral therapy",
        "Highly advanced antiviral retroviral therapy",
        "Human acquired antiretroviral treatment",
        "HIV active antiviral retroviral therapy",
      ],
      correct: "A"
    },
    {
      id: 70905,
      question: "What does HAART include?",
      options: [
        "One RT inhibitor and two protease inhibitors",
        "Two RT inhibitors and one protease inhibitor",
        "Three RT inhibitors",
        "Three protease inhibitors",
      ],
      correct: "B"
    },
    {
      id: 70906,
      question: "How does cocktail therapy compare to single therapy for HIV?",
      options: [
        "Less effective",
        "Equally effective",
        "More effective",
        "Not recommended",
      ],
      correct: "C"
    },
    {
      id: 70907,
      question: "Why is developing an AIDS vaccine complicated?",
      options: [
        "HIV is too large",
        "HIV is too small",
        "HIV only affects one cell type",
        "HIV mutates instantly, few cells express viral proteins, immune system cannot eradicate virus, no ideal animal model",
      ],
      correct: "D"
    },
    {
      id: 70908,
      question: "What are the two types of immunodeficiencies?",
      options: [
        "Primary (congenital) and secondary",
        "Acute and chronic",
        "Mild and severe",
        "Local and systemic",
      ],
      correct: "A"
    },
    {
      id: 70909,
      question: "Which diseases can cause secondary immunodeficiency?",
      options: [
        "Diabetes and hypertension",
        "Lymphoma, leukemia and AIDS",
        "Arthritis and osteoporosis",
        "Asthma and allergies",
      ],
      correct: "B"
    },
    {
      id: 70910,
      question: "Which therapies can cause secondary immunodeficiency?",
      options: [
        "Physical therapy and occupational therapy",
        "Antibiotics only",
        "Immunosuppressive drugs, cytotoxic drugs, radiotherapy and splenectomy",
        "Pain management only",
      ],
      correct: "C"
    },
    {
      id: 70911,
      question: "What does splenectomy increase the risk of?",
      options: [
        "Viral infections",
        "Fungal infections",
        "Parasitic infections",
        "Encapsulated bacterial infections",
      ],
      correct: "D"
    },
    {
      id: 70912,
      question: "What can radiotherapy increase the risk of in the oral cavity?",
      options: [
        "Xerostomia and mucositis",
        "Dental caries only",
        "Tooth discoloration only",
        "Gum bleeding only",
      ],
      correct: "A"
    },
    {
      id: 70913,
      question: "What causes xerostomia?",
      options: [
        "Only aging",
        "Aging, drugs, radiotherapy and Sjögren\'s syndrome",
        "Only medications",
        "Only radiation",
      ],
      correct: "B"
    },
    {
      id: 70914,
      question: "What organisms overgrow in xerostomia due to dry mouth, low pH and high oxygen tension?",
      options: [
        "Streptococcus mutans only",
        "E. coli only",
        "S. aureus and Candida spp.",
        "Lactobacillus only",
      ],
      correct: "C"
    },
    {
      id: 70915,
      question: "What is dental caries in xerostomia commonly found on?",
      options: [
        "Occlusal surfaces only",
        "Root surfaces only",
        "Proximal surfaces only",
        "Cervical and incisal surfaces of teeth",
      ],
      correct: "D"
    },
    {
      id: 70916,
      question: "How can dental caries be prevented in xerostomia patients?",
      options: [
        "Discontinuation of high-sucrose snacks, appropriate brushing and daily fluoride mouth-rinsing",
        "Increased sugar intake",
        "Antibiotic use",
        "Increased fluid intake only",
      ],
      correct: "A"
    },
    {
      id: 70917,
      question: "What concentration of chlorhexidine mouthwash prevents periodontal disease in xerostomia?",
      options: [
        "0.5%",
        "2%",
        "1%",
        "5%",
      ],
      correct: "B"
    },
    {
      id: 70918,
      question: "What oral candidiasis manifestations are common in xerostomia?",
      options: [
        "Only thrush",
        "Only denture stomatitis",
        "Stomatitis and angular cheilitis",
        "Only oral thrush",
      ],
      correct: "C"
    },
    {
      id: 70919,
      question: "What can bacterial parotitis in xerostomia patients be treated with?",
      options: [
        "Antifungals",
        "Antivirals",
        "Antacids",
        "Penicillinase-resistant penicillins",
      ],
      correct: "D"
    },
    {
      id: 70920,
      question: "What is the recovery percentage from subclinical acute hepatitis B?",
      options: [
        "96%",
        "50%",
        "75%",
        "100%",
      ],
      correct: "A"
    },
    {
      id: 70921,
      question: "What are chronic active HBV carriers characterized by?",
      options: [
        "Only HBsAg in blood",
        "Dane particles in their blood",
        "No viral markers",
        "Only antibodies",
      ],
      correct: "B"
    },
    {
      id: 70922,
      question: "What is the size of HDV particle?",
      options: [
        "20-25 nm",
        "50-55 nm",
        "35-37 nm",
        "100-120 nm",
      ],
      correct: "C"
    },
    {
      id: 70923,
      question: "What codes for the envelope of HDV?",
      options: [
        "HDV RNA",
        "Host cell DNA",
        "Delta antigen only",
        "Hepatitis B virus with which it coexists",
      ],
      correct: "D"
    },
    {
      id: 70924,
      question: "How long does co-infection with HDV and acute HBV take to develop hepatitis?",
      options: [
        "6-12 weeks",
        "1-2 weeks",
        "6-12 months",
        "1-2 years",
      ],
      correct: "A"
    },
    {
      id: 70925,
      question: "How long does superinfection with HDV in HBV carriers take to develop hepatitis?",
      options: [
        "1-2 days",
        "2-6 weeks",
        "6-12 months",
        "1-2 years",
      ],
      correct: "B"
    },
    {
      id: 70926,
      question: "What percentage of co-infection cases progress to fulminant disease?",
      options: [
        "5%",
        "20%",
        "10%",
        "30%",
      ],
      correct: "C"
    },
    {
      id: 70927,
      question: "What percentage of superinfection cases progress to fulminant disease?",
      options: [
        "5%",
        "10%",
        "30%",
        "20%",
      ],
      correct: "D"
    },
    {
      id: 70928,
      question: "What is the death rate from fulminant disease in HDV?",
      options: [
        "10-20%",
        "5-10%",
        "30-40%",
        "50-60%",
      ],
      correct: "A"
    },
    {
      id: 70929,
      question: "What is the asymptomatic period range in HIV Stage A?",
      options: [
        "1-6 months",
        "1-15 years",
        "6-12 months",
        "15-20 years",
      ],
      correct: "B"
    },
    {
      id: 70930,
      question: "What characterizes hairy leukoplakia location on the tongue?",
      options: [
        "Always bilateral",
        "Always unilateral",
        "Unilateral or bilateral",
        "Central location",
      ],
      correct: "C"
    },
    {
      id: 70931,
      question: "Which cells does hairy leukoplakia typically infect?",
      options: [
        "Nerve cells",
        "Blood cells",
        "Muscle cells",
        "Epithelial cells",
      ],
      correct: "D"
    },
    {
      id: 70932,
      question: "What is enteral hepatitis?",
      options: [
        "Hepatitis transmitted through the gastrointestinal tract (fecal-oral)",
        "Hepatitis transmitted through blood",
        "Hepatitis transmitted through respiratory route",
        "Hepatitis transmitted through skin contact",
      ],
      correct: "A"
    },
    {
      id: 70933,
      question: "What is parenteral hepatitis?",
      options: [
        "Hepatitis transmitted through food",
        "Hepatitis transmitted through routes other than GI tract (blood, needles)",
        "Hepatitis transmitted through water",
        "Hepatitis transmitted through air",
      ],
      correct: "B"
    },
    {
      id: 70934,
      question: "What does HCC stand for in the context of hepatitis?",
      options: [
        "Hepatic cell carcinoma",
        "Hepatitis C carrier",
        "Hepatocellular carcinoma",
        "Hepatic chronic condition",
      ],
      correct: "C"
    },
    {
      id: 70935,
      question: "What does LC stand for in the context of hepatitis?",
      options: [
        "Liver cancer",
        "Lymphatic carcinoma",
        "Leucocyte count",
        "Liver cirrhosis",
      ],
      correct: "D"
    },
    {
      id: 70936,
      question: "What type of immunization does hyperimmune globulin provide for Hepatitis A?",
      options: [
        "Passive immunization",
        "Active immunization",
        "Both active and passive",
        "No immunization",
      ],
      correct: "A"
    },
    {
      id: 70937,
      question: "Which HBV antigen is a by-product of HBcAg?",
      options: [
        "HBsAg",
        "HBeAg",
        "DNA polymerase",
        "Envelope protein",
      ],
      correct: "B"
    },
    {
      id: 70938,
      question: "Does HCV rarely or commonly cause acute fulminating hepatitis?",
      options: [
        "Commonly causes",
        "Never causes",
        "Rarely causes",
        "Always causes",
      ],
      correct: "C"
    },
    {
      id: 70939,
      question: "What is another name for Hepatitis G?",
      options: [
        "Serum hepatitis",
        "Infectious hepatitis",
        "Delta hepatitis",
        "Non-A-E-hepatitis",
      ],
      correct: "D"
    },
    {
      id: 70940,
      question: "Which HTLV types are associated with oncoviruses?",
      options: [
        "HTLV-I and II",
        "HTLV-III and IV",
        "HTLV-V and VI",
        "HTLV only type I",
      ],
      correct: "A"
    },
    {
      id: 70941,
      question: "What does ATLL stand for?",
      options: [
        "Acute T-cell lymphocytic leukemia",
        "Adult T-cell leukemia/lymphoma",
        "Advanced T-lymphocyte lymphoma",
        "Acquired T-cell lymphatic leukemia",
      ],
      correct: "B"
    },
    {
      id: 70942,
      question: "How can mother transmit HIV to fetus?",
      options: [
        "Only through delivery",
        "Only through breast-feeding",
        "Via placenta, delivery or breast-feeding",
        "Only before conception",
      ],
      correct: "C"
    },
    {
      id: 70943,
      question: "What does AZT stand for?",
      options: [
        "Anti-zidovudine therapy",
        "Antiviral zoster treatment",
        "Acquired zoonotic therapy",
        "Azidothymidine",
      ],
      correct: "D"
    },
  ],
  "10. Oral Microbiology and Dental Caries": [
    {
      id: 70900,
      question: "How many species groups do oral streptococci have?",
      options: [
        "Four",
        "Two",
        "Three",
        "Five",
      ],
      correct: "A"
    },
    {
      id: 70901,
      question: "Which are the four species groups of oral streptococci?",
      options: [
        "Mutans, lactobacillus, veillonella and mitis",
        "Mutans, salivarius, anginosus and mitis",
        "Salivarius, anginosus, prevotella and mitis",
        "Mutans, salivarius, porphyromonas and anginosus",
      ],
      correct: "B"
    },
    {
      id: 70902,
      question: "Which genera belong to anaerobic streptococci?",
      options: [
        "Lactobacillus and Actinomyces",
        "Neisseria and Veillonella",
        "Peptostreptococcus, Finegoldia, Micromonas and Peptoniphilus",
        "Fusobacterium and Prevotella",
      ],
      correct: "C"
    },
    {
      id: 70903,
      question: "Which Actinomyces species is especially significant among gram-positive rods?",
      options: [
        "A. naeslundii",
        "A. viscosus",
        "A. odontolyticus",
        "A. israelii",
      ],
      correct: "D"
    },
    {
      id: 70904,
      question: "Which Lactobacillus species are found in oral microflora?",
      options: [
        "L. casei, L. fermentum and L. acidophilus",
        "L. rhamnosus, L. plantarum and L. brevis",
        "L. bulgaricus, L. helveticus and L. delbrueckii",
        "L. gasseri, L. johnsonii and L. reuteri",
      ],
      correct: "A"
    },
    {
      id: 70905,
      question: "Which Propionibacterium species is especially significant in oral microflora?",
      options: [
        "P. freudenreichii",
        "P. acnes",
        "P. avidum",
        "P. granulosum",
      ],
      correct: "B"
    },
    {
      id: 70906,
      question: "Which are examples of gram-negative cocci in oral microflora?",
      options: [
        "Streptococcus and Staphylococcus",
        "Porphyromonas and Prevotella",
        "Neisseria and Veillonella",
        "Actinomyces and Lactobacillus",
      ],
      correct: "C"
    },
    {
      id: 70907,
      question: "Which Neisseria species are found in oral microflora?",
      options: [
        "N. meningitidis, N. gonorrhoeae and N. lactamica",
        "N. flavescens, N. cinerea and N. polysaccharea",
        "N. elongata, N. bacilliformis and N. weaveri",
        "N. sicca, N. subflava and N. mucosa",
      ],
      correct: "D"
    },
    {
      id: 70908,
      question: "Which Veillonella species are found in oral microflora?",
      options: [
        "V. parvula, V. atypica and V. dispar",
        "V. magna, V. rogosae and V. tobetsuensis",
        "V. montpellierensis, V. ratti and V. caviae",
        "V. criceti, V. magna and V. rodentium",
      ],
      correct: "A"
    },
    {
      id: 70909,
      question: "Which Haemophilus species are found in oral microflora?",
      options: [
        "H. ducreyi, H. aegyptius and H. haemolyticus",
        "H. influenzae, H. aphrophilus and H. parainfluenzae",
        "H. pittmaniae, H. sputorum and H. paraphrohaemolyticus",
        "H. parasuis, H. somnus and H. paragallinarum",
      ],
      correct: "B"
    },
    {
      id: 70910,
      question: "Which Actinobacillus species is especially significant in oral microflora?",
      options: [
        "A. lignieresii",
        "A. equuli",
        "A. actinomycetemcomitans",
        "A. suis",
      ],
      correct: "C"
    },
    {
      id: 70911,
      question: "Which Eikenella species is especially significant in oral microflora?",
      options: [
        "E. exigua",
        "E. nodatum",
        "E. sulci",
        "E. corrodens",
      ],
      correct: "D"
    },
    {
      id: 70912,
      question: "Which Capnocytophaga species are found in oral microflora?",
      options: [
        "C. ochracea and C. gingivalis",
        "C. canimorsus and C. cynodegmi",
        "C. sputigena and C. haemolytica",
        "C. granulosa and C. leadbetteri",
      ],
      correct: "A"
    },
    {
      id: 70913,
      question: "Which Porphyromonas species are found in oral microflora?",
      options: [
        "P. asaccharolytica and P. somerae",
        "P. gingivalis and P. endodontalis",
        "P. bennonis and P. uenonis",
        "P. catoniae and P. pasteri",
      ],
      correct: "B"
    },
    {
      id: 70914,
      question: "Which Prevotella species are found in oral microflora?",
      options: [
        "P. bivia and P. disiens",
        "P. corporis and P. buccae",
        "P. melaninogenica and P. intermedia",
        "P. oris and P. veroralis",
      ],
      correct: "C"
    },
    {
      id: 70915,
      question: "Which Fusobacterium species are found in oral microflora?",
      options: [
        "F. varium and F. mortiferum",
        "F. necrophorum and F. gonidiaformans",
        "F. ulcerans and F. russii",
        "F. nucleatum and F. periodonticum",
      ],
      correct: "D"
    },
    {
      id: 70916,
      question: "Which Leptotrichia species is especially significant in oral microflora?",
      options: [
        "L. buccalis",
        "L. goodfellowii",
        "L. hofstadii",
        "L. shahii",
      ],
      correct: "A"
    },
    {
      id: 70917,
      question: "Which Tannerella species is especially significant in oral microflora?",
      options: [
        "T. serpentiformis",
        "T. forsythia",
        "T. goodfellowii",
        "T. denticola",
      ],
      correct: "B"
    },
    {
      id: 70918,
      question: "Which Wolinella species is especially significant in oral microflora?",
      options: [
        "W. curva",
        "W. recta",
        "W. succinogenes",
        "W. gracilis",
      ],
      correct: "C"
    },
    {
      id: 70919,
      question: "Which Treponema species are found in oral microflora?",
      options: [
        "T. pallidum and T. pertenue",
        "T. carateum and T. endemicum",
        "T. phagedenis and T. refringens",
        "T. denticola and T. macrodentium",
      ],
      correct: "D"
    },
    {
      id: 70920,
      question: "Which oral protozoa are found in the oral cavity?",
      options: [
        "Entamoeba gingivalis and Trichomonas tenax",
        "Giardia and Cryptosporidium",
        "Plasmodium and Toxoplasma",
        "Leishmania and Trypanosoma",
      ],
      correct: "A"
    },
    {
      id: 70921,
      question: "What does the oral ecosystem consist of?",
      options: [
        "Only oral flora",
        "Oral flora and oral habitats",
        "Only oral habitats",
        "Only bacteria and viruses",
      ],
      correct: "B"
    },
    {
      id: 70922,
      question: "What is responsible for defending against transient flora and pathogens?",
      options: [
        "Saliva only",
        "Antibiotics",
        "Colonization resistance of resident flora",
        "Immune cells only",
      ],
      correct: "C"
    },
    {
      id: 70923,
      question: "Why does the tongue have a variety of microflora?",
      options: [
        "Due to high pH",
        "Due to smooth surface",
        "Due to high oxygen",
        "Due to papillae",
      ],
      correct: "D"
    },
    {
      id: 70924,
      question: "What makes the tongue suitable for anaerobic flora?",
      options: [
        "Low redox potential (Eh)",
        "High oxygen tension",
        "Alkaline pH",
        "High carbohydrate content",
      ],
      correct: "A"
    },
    {
      id: 70925,
      question: "What infection can dental appliances cause?",
      options: [
        "Pneumonia",
        "Candida-associated denture stomatitis",
        "Endocarditis",
        "Meningitis",
      ],
      correct: "B"
    },
    {
      id: 70926,
      question: "What can dental plaques result in?",
      options: [
        "Only gingivitis",
        "Only halitosis",
        "Dental caries and periodontal diseases",
        "Only tooth discoloration",
      ],
      correct: "C"
    },
    {
      id: 70927,
      question: "What are the most prominent factors affecting microbial population in the oral cavity?",
      options: [
        "Only diet",
        "Only temperature",
        "Only pH",
        "Anatomical factors, saliva, crevicular fluid, microbial factors and miscellaneous factors",
      ],
      correct: "D"
    },
    {
      id: 70928,
      question: "What type of compounds is saliva a blend of?",
      options: [
        "Inorganic and organic (protein and carbohydrate) compounds",
        "Only water",
        "Only minerals",
        "Only enzymes",
      ],
      correct: "A"
    },
    {
      id: 70929,
      question: "Which are the three major salivary glands?",
      options: [
        "Parotid, sublingual and buccal",
        "Submandibular, sublingual and parotid",
        "Labial, lingual and palatal",
        "Submandibular, buccal and palatal",
      ],
      correct: "B"
    },
    {
      id: 70930,
      question: "What does saliva form on tooth surfaces that simplifies bacteria adhesion?",
      options: [
        "Calculus",
        "Biofilm",
        "Salivary pellicle",
        "Enamel layer",
      ],
      correct: "C"
    },
    {
      id: 70931,
      question: "Which antimicrobial factors are found in saliva?",
      options: [
        "Penicillin and amoxicillin",
        "Tetracycline and erythromycin",
        "Chlorhexidine and fluoride",
        "Lysozyme, histatin, lactoferrin, IgA and SLPI",
      ],
      correct: "D"
    },
    {
      id: 70932,
      question: "What does SLPI stand for?",
      options: [
        "Salivary leukocyte protease inhibitor",
        "Salivary lymphocyte protein inhibitor",
        "Serum lipid protease inhibitor",
        "Salivary lipase protein inhibitor",
      ],
      correct: "A"
    },
    {
      id: 70933,
      question: "What is gingival crevicular fluid similar to?",
      options: [
        "Saliva",
        "Serum",
        "Lymph",
        "Mucus",
      ],
      correct: "B"
    },
    {
      id: 70934,
      question: "What does crevicular fluid contain?",
      options: [
        "Only water",
        "Only enzymes",
        "Neutrophils, IgG, IgM and IgA",
        "Only minerals",
      ],
      correct: "C"
    },
    {
      id: 70935,
      question: "What are bacteriocins?",
      options: [
        "Antibiotics",
        "Enzymes",
        "Vitamins",
        "Toxins that kill the same bacterial species",
      ],
      correct: "D"
    },
    {
      id: 70936,
      question: "What is coaggregation?",
      options: [
        "Attachment with the same or different species",
        "Bacterial death",
        "Bacterial division",
        "Bacterial movement",
      ],
      correct: "A"
    },
    {
      id: 70937,
      question: "What can short-chain carboxylic acids do to pH?",
      options: [
        "Raise the pH",
        "Lower the pH",
        "Maintain neutral pH",
        "Have no effect on pH",
      ],
      correct: "B"
    },
    {
      id: 70938,
      question: "Which bacteria can use acids produced by S. mutans?",
      options: [
        "Lactobacillus spp.",
        "Actinomyces spp.",
        "Veillonella spp.",
        "Neisseria spp.",
      ],
      correct: "C"
    },
    {
      id: 70939,
      question: "What can tetracyclines stimulate the growth of?",
      options: [
        "Bacteria",
        "Viruses",
        "Protozoa",
        "Yeasts",
      ],
      correct: "D"
    },
    {
      id: 70940,
      question: "What does plaque formation do to Eh?",
      options: [
        "Reduces Eh significantly",
        "Increases Eh significantly",
        "Has no effect on Eh",
        "Maintains Eh constant",
      ],
      correct: "A"
    },
    {
      id: 70941,
      question: "What is the condition of the infant mouth at birth?",
      options: [
        "Colonized by many bacteria",
        "Sterile (except a few microorganisms from birth canal)",
        "Full of yeasts",
        "Colonized by viruses",
      ],
      correct: "B"
    },
    {
      id: 70942,
      question: "What are the pioneer species in the infant mouth?",
      options: [
        "Lactobacillus spp.",
        "Candida spp.",
        "Oral streptococci",
        "Neisseria spp.",
      ],
      correct: "C"
    },
    {
      id: 70943,
      question: "What do metabolic products of pioneer species stimulate?",
      options: [
        "Tooth development",
        "Immune response",
        "Saliva production",
        "Growth of other bacteria",
      ],
      correct: "D"
    },
    {
      id: 70944,
      question: "Which microbes prefer enamel after tooth eruption?",
      options: [
        "Oral streptococci and Actinomyces spp.",
        "Prevotella spp. and spirochetes",
        "Porphyromonas spp. and Candida spp.",
        "Fusobacterium spp. and Neisseria spp.",
      ],
      correct: "A"
    },
    {
      id: 70945,
      question: "Which microbes favor the gingival crevice after tooth eruption?",
      options: [
        "Oral streptococci and Actinomyces spp.",
        "Prevotella spp., Porphyromonas spp. and spirochetes",
        "Lactobacillus spp. and Neisseria spp.",
        "Candida spp. and Staphylococcus aureus",
      ],
      correct: "B"
    },
    {
      id: 70946,
      question: "What microflora are associated with prosthetic appliances?",
      options: [
        "Only streptococci",
        "Only gram-negative bacteria",
        "Candida spp., lactobacilli and Staphylococcus aureus",
        "Only anaerobes",
      ],
      correct: "C"
    },
    {
      id: 70947,
      question: "What is the main constituent of a dental plaque?",
      options: [
        "Inorganic matrix",
        "Water",
        "Minerals",
        "Organic matrix",
      ],
      correct: "D"
    },
    {
      id: 70948,
      question: "Where are dental plaques usually found?",
      options: [
        "Occlusal fissures, interproximally and around gingival crevice",
        "Only on smooth surfaces",
        "Only on root surfaces",
        "Only on enamel",
      ],
      correct: "A"
    },
    {
      id: 70949,
      question: "What are the two types of dental plaques?",
      options: [
        "Enamel and dentine plaques",
        "Supragingival and subgingival plaques",
        "Anterior and posterior plaques",
        "Organic and inorganic plaques",
      ],
      correct: "B"
    },
    {
      id: 70950,
      question: "Which plaques are supragingival?",
      options: [
        "Denture and orthodontic plaques",
        "Root and cervical plaques",
        "Fissure, approximal and smooth surface plaques",
        "Crevicular and pocket plaques",
      ],
      correct: "C"
    },
    {
      id: 70951,
      question: "Which plaques are subgingival?",
      options: [
        "Fissure and smooth surface plaques",
        "Approximal and occlusal plaques",
        "Interproximal and buccal plaques",
        "Denture and orthodontic plaques",
      ],
      correct: "D"
    },
    {
      id: 70952,
      question: "What is the pellicle?",
      options: [
        "Acquired thin layer of salivary glycoprotein on tooth surface",
        "Calcified plaque",
        "Bacterial biofilm",
        "Enamel layer",
      ],
      correct: "A"
    },
    {
      id: 70953,
      question: "What is the first step in plaque biofilm formation?",
      options: [
        "Transport",
        "Pellicle formation",
        "Coaggregation",
        "Biofilm formation",
      ],
      correct: "B"
    },
    {
      id: 70954,
      question: "What happens during transport in biofilm formation?",
      options: [
        "Pellicle forms",
        "Coaggregation occurs",
        "Bacteria travel to the tooth surface",
        "Biofilm matures",
      ],
      correct: "C"
    },
    {
      id: 70955,
      question: "What are long-range interactions?",
      options: [
        "Permanent bacterial attachment",
        "Bacterial multiplication",
        "Coaggregation",
        "Reversible attachment due to physicochemical reactions",
      ],
      correct: "D"
    },
    {
      id: 70956,
      question: "What are short-range interactions?",
      options: [
        "Bacterial multiplication due to biological interactions",
        "Reversible attachment",
        "Transport of bacteria",
        "Pellicle formation",
      ],
      correct: "A"
    },
    {
      id: 70957,
      question: "What is coaggregation in biofilm formation?",
      options: [
        "Bacterial death",
        "New bacteria attached to pre-existing ones",
        "Pellicle formation",
        "Transport of bacteria",
      ],
      correct: "B"
    },
    {
      id: 70958,
      question: "What is a biofilm?",
      options: [
        "Single species community",
        "Calcified plaque",
        "Functional complex community in exopolysaccharide matrix attached to surface",
        "Salivary pellicle",
      ],
      correct: "C"
    },
    {
      id: 70959,
      question: "What can flow easily through the biofilm?",
      options: [
        "Only bacteria",
        "Only nutrients",
        "Only oxygen",
        "Water and metabolites",
      ],
      correct: "D"
    },
    {
      id: 70960,
      question: "What are the pioneer microorganisms in biofilm?",
      options: [
        "Gram-positive cocci and bacilli",
        "Gram-negative cocci and bacilli",
        "Spirochetes",
        "Fusobacteria",
      ],
      correct: "A"
    },
    {
      id: 70961,
      question: "What is the climax community in biofilm?",
      options: [
        "Initial bacterial colonization",
        "Stable complex microbial community from bacterial succession",
        "Transport phase",
        "Pellicle formation phase",
      ],
      correct: "B"
    },
    {
      id: 70962,
      question: "What are quorum-sensing molecules?",
      options: [
        "Nutrients",
        "Antibiotics",
        "Substances produced by bacteria to maintain population levels",
        "Enzymes",
      ],
      correct: "C"
    },
    {
      id: 70963,
      question: "What can quorum-sensing molecules activate?",
      options: [
        "Only metabolism",
        "Only cell division",
        "Only movement",
        "Specific genes for metabolism reduction, EPS secretion and virulence factors",
      ],
      correct: "D"
    },
    {
      id: 70964,
      question: "What are sessile organisms?",
      options: [
        "Highly resistant microorganisms in biofilms",
        "Planktonic organisms",
        "Mobile organisms",
        "Free-floating organisms",
      ],
      correct: "A"
    },
    {
      id: 70965,
      question: "Why are sessile organisms resistant?",
      options: [
        "Due to their size",
        "Protection by EPM, poor availability to antimicrobials, pH/Eh differences, and gene expression",
        "Due to their shape",
        "Due to their color",
      ],
      correct: "B"
    },
    {
      id: 70966,
      question: "What is calculus?",
      options: [
        "Soft plaque",
        "Salivary pellicle",
        "Insoluble calcium and phosphate crystite accumulated in plaque",
        "Organic matrix",
      ],
      correct: "C"
    },
    {
      id: 70967,
      question: "What compounds in toothpastes can eliminate phosphate and calcium ions?",
      options: [
        "Fluoride compounds",
        "Chlorhexidine compounds",
        "Triclosan compounds",
        "Pyrophosphate compounds",
      ],
      correct: "D"
    },
    {
      id: 70968,
      question: "Which bacteria are predominant in supragingival plaque?",
      options: [
        "Gram-positive bacteria",
        "Gram-negative bacteria",
        "Spirochetes",
        "Anaerobes only",
      ],
      correct: "A"
    },
    {
      id: 70969,
      question: "Which bacteria are predominant in subgingival plaque?",
      options: [
        "Gram-positive bacteria",
        "Gram-negative bacteria",
        "Only cocci",
        "Only rods",
      ],
      correct: "B"
    },
    {
      id: 70970,
      question: "What can LPS of gram-negative bacteria do?",
      options: [
        "Decrease inflammation",
        "Kill bacteria",
        "Increase vascular permeability and stimulate IL-1 and TNF-α secretion",
        "Form pellicle",
      ],
      correct: "C"
    },
    {
      id: 70971,
      question: "What appearance do cocci attached to filamentous microbes make on outer surfaces?",
      options: [
        "Honeycomb appearance",
        "Chain appearance",
        "Cluster appearance",
        "Corncob appearance",
      ],
      correct: "D"
    },
    {
      id: 70972,
      question: "How can bacterial toxins be secreted from calculi?",
      options: [
        "Due to numerous pores in their structure",
        "Through the outer surface only",
        "Through cracks only",
        "By dissolution",
      ],
      correct: "A"
    },
    {
      id: 70973,
      question: "What are the three mechanisms by which oral infections lead to systemic infections?",
      options: [
        "Only bacteremia",
        "Metastatic infection, metastatic injury and metastatic inflammation",
        "Only toxin secretion",
        "Only immune response",
      ],
      correct: "B"
    },
    {
      id: 70974,
      question: "What is metastatic infection?",
      options: [
        "Toxin secretion",
        "Immune complex formation",
        "Microbial entry into circulatory system (e.g., bacteremia after tooth extraction)",
        "Local infection spread",
      ],
      correct: "C"
    },
    {
      id: 70975,
      question: "What is metastatic injury?",
      options: [
        "Bacterial entry into blood",
        "Immune complex formation",
        "Local tissue damage",
        "Toxins and enzymes secretion into cardiovascular system",
      ],
      correct: "D"
    },
    {
      id: 70976,
      question: "What is metastatic inflammation?",
      options: [
        "Immunological (antigen-antibody) complexes (e.g., Behçet\'s syndrome)",
        "Bacterial spread",
        "Toxin secretion",
        "Enzyme release",
      ],
      correct: "A"
    },
    {
      id: 70977,
      question: "Which cytokines are highly produced in periodontitis?",
      options: [
        "IL-4, IL-5 and IL-13",
        "IL-1, TNF-α and IFN-γ",
        "IL-2, IL-3 and IL-7",
        "IL-10, IL-12 and IL-15",
      ],
      correct: "B"
    },
    {
      id: 70978,
      question: "What is dental caries?",
      options: [
        "Exogenous acute infection",
        "Viral infection",
        "Endogenous chronic infection that demineralizes tooth tissues by acidic products",
        "Fungal infection",
      ],
      correct: "C"
    },
    {
      id: 70979,
      question: "When does dental caries occur?",
      options: [
        "When remineralization outweighs demineralization",
        "When pH is high",
        "When saliva flow is high",
        "When demineralization outweighs remineralization",
      ],
      correct: "D"
    },
    {
      id: 70980,
      question: "What are the four types of dental caries?",
      options: [
        "Fissure, smooth-surface, root-surface and recurrent caries",
        "Enamel, dentine, pulp and root caries",
        "Anterior, posterior, occlusal and proximal caries",
        "Primary, secondary, tertiary and quaternary caries",
      ],
      correct: "A"
    },
    {
      id: 70981,
      question: "Where does fissure caries occur?",
      options: [
        "On smooth surfaces",
        "In molars, premolars and maxillary incisors",
        "On root surfaces",
        "On approximal surfaces only",
      ],
      correct: "B"
    },
    {
      id: 70982,
      question: "Where does smooth-surface caries occur?",
      options: [
        "In fissures",
        "On root surfaces",
        "On approximal tooth surfaces",
        "On occlusal surfaces",
      ],
      correct: "C"
    },
    {
      id: 70983,
      question: "Where does root-surface caries occur?",
      options: [
        "On enamel",
        "In fissures",
        "On smooth surfaces",
        "On dentine",
      ],
      correct: "D"
    },
    {
      id: 70984,
      question: "Where does recurrent caries occur?",
      options: [
        "In relation to existing restoration",
        "On new tooth surfaces",
        "On root surfaces only",
        "In fissures only",
      ],
      correct: "A"
    },
    {
      id: 70985,
      question: "What is the primary caries lesion?",
      options: [
        "Cavitated lesion",
        "White-spot reversible lesion",
        "Black lesion",
        "Brown lesion",
      ],
      correct: "B"
    },
    {
      id: 70986,
      question: "What are progressive carious lesions like?",
      options: [
        "Smooth and white",
        "Flat and shiny",
        "Rough and cavitated",
        "Soft and pink",
      ],
      correct: "C"
    },
    {
      id: 70987,
      question: "What are the predisposing factors of dental caries?",
      options: [
        "Only diet",
        "Only microbes",
        "Only saliva",
        "Host factors, diet and microbes",
      ],
      correct: "D"
    },
    {
      id: 70988,
      question: "What roles does saliva have in caries formation?",
      options: [
        "Washing, buffering and remineralization",
        "Only lubrication",
        "Only digestion",
        "Only antimicrobial",
      ],
      correct: "A"
    },
    {
      id: 70989,
      question: "Which type of diet may result in caries?",
      options: [
        "Protein-rich diets",
        "Sucrose-rich diets",
        "Fat-rich diets",
        "Fiber-rich diets",
      ],
      correct: "B"
    },
    {
      id: 70990,
      question: "What can cariogenic streptococci convert sucrose into?",
      options: [
        "Glucose and fructose only",
        "Starch and cellulose",
        "Glucan and fructan",
        "Maltose and lactose",
      ],
      correct: "C"
    },
    {
      id: 70991,
      question: "How do glucose and fructose compare to sucrose in cariogenicity?",
      options: [
        "More cariogenic",
        "Equally cariogenic",
        "Not cariogenic at all",
        "Less cariogenic",
      ],
      correct: "D"
    },
    {
      id: 70992,
      question: "What are the three major bacteria initiating carious lesions?",
      options: [
        "Mutans streptococci, Lactobacillus spp. and Actinomyces spp.",
        "Neisseria, Veillonella and Haemophilus",
        "Porphyromonas, Prevotella and Fusobacterium",
        "Treponema, Tannerella and Wolinella",
      ],
      correct: "A"
    },
    {
      id: 70993,
      question: "Where are mutans streptococci present?",
      options: [
        "Only in gingival crevice",
        "In saliva, plaques and enamel caries",
        "Only on tongue",
        "Only in root caries",
      ],
      correct: "B"
    },
    {
      id: 70994,
      question: "What can mutans streptococci produce from sucrose?",
      options: [
        "Only intracellular polysaccharide",
        "Protein",
        "Extracellular polysaccharide",
        "Lipid",
      ],
      correct: "C"
    },
    {
      id: 70995,
      question: "What acid do mutans streptococci produce?",
      options: [
        "Acetic acid",
        "Citric acid",
        "Butyric acid",
        "Lactic acid",
      ],
      correct: "D"
    },
    {
      id: 70996,
      question: "What do mutans group produce as intracellular polysaccharide?",
      options: [
        "Glycogen",
        "Starch",
        "Cellulose",
        "Dextran",
      ],
      correct: "A"
    },
    {
      id: 70997,
      question: "How do Lactobacillus spp. differ from mutans streptococci in caries?",
      options: [
        "They don\'t produce acid",
        "Only a few are isolated before caries formation",
        "They don\'t produce polysaccharide",
        "They can\'t survive at low pH",
      ],
      correct: "B"
    },
    {
      id: 70998,
      question: "From which type of caries are Actinomyces spp. isolated?",
      options: [
        "Enamel caries",
        "Fissure caries",
        "Root caries",
        "Smooth surface caries",
      ],
      correct: "C"
    },
    {
      id: 70999,
      question: "What are Veillonella spp. called?",
      options: [
        "Pathogenic bacteria",
        "Cariogenic bacteria",
        "Acidogenic bacteria",
        "Benevolent bacteria",
      ],
      correct: "D"
    },
    {
      id: 71000,
      question: "What do Veillonellae require that is produced by other microbes?",
      options: [
        "Lactate",
        "Glucose",
        "Sucrose",
        "Fructose",
      ],
      correct: "A"
    },
    {
      id: 71001,
      question: "What do Veillonella spp. convert lactic acid into?",
      options: [
        "Stronger acids",
        "Weaker acids",
        "Neutral substances",
        "Alcohols",
      ],
      correct: "B"
    },
    {
      id: 71002,
      question: "What enzyme decomposes sucrose into glucan?",
      options: [
        "Fructosyltransferase",
        "Amylase",
        "Glucosyltransferase",
        "Invertase",
      ],
      correct: "C"
    },
    {
      id: 71003,
      question: "What enzyme decomposes sucrose into fructan?",
      options: [
        "Glucosyltransferase",
        "Amylase",
        "Sucrase",
        "Fructosyltransferase",
      ],
      correct: "D"
    },
    {
      id: 71004,
      question: "What is the main function of glucan?",
      options: [
        "Main bacterial food source",
        "Bacterial adhesion",
        "pH buffering",
        "Enzyme production",
      ],
      correct: "A"
    },
    {
      id: 71005,
      question: "What is the main function of fructan?",
      options: [
        "Main food source",
        "Facilitates bacterial adhesion",
        "pH buffering",
        "Energy storage",
      ],
      correct: "B"
    },
    {
      id: 71006,
      question: "Which organisms are the most acidogenic and aciduric in plaque?",
      options: [
        "Neisseria and Veillonella",
        "Actinomyces and Prevotella",
        "Mutans streptococci and lactobacilli",
        "Fusobacterium and Porphyromonas",
      ],
      correct: "C"
    },
    {
      id: 71007,
      question: "What is the curve called when pH falls and gradually returns to normal?",
      options: [
        "Bacterial growth curve",
        "Standard curve",
        "pH curve",
        "Stephan curve",
      ],
      correct: "D"
    },
    {
      id: 71008,
      question: "What does the ecological plaque hypothesis state?",
      options: [
        "Demineralization and remineralization are in equilibrium unless carbohydrates increase",
        "Bacteria always cause caries",
        "Plaque always forms calculus",
        "All bacteria are cariogenic",
      ],
      correct: "A"
    },
    {
      id: 71009,
      question: "What are the main principles for dental caries management?",
      options: [
        "Only treatment",
        "Active prevention, accurate diagnosis, early detection and appropriate techniques",
        "Only restoration",
        "Only extraction",
      ],
      correct: "B"
    },
    {
      id: 71010,
      question: "What is sugar substitution?",
      options: [
        "Using more sugar",
        "Eliminating all carbohydrates",
        "Using non-cariogenic artificial sweeteners not absorbed by bacteria",
        "Using natural sugars only",
      ],
      correct: "C"
    },
    {
      id: 71011,
      question: "What are the two types of artificial sweeteners?",
      options: [
        "Natural and synthetic",
        "Organic and inorganic",
        "Simple and complex",
        "Nutritive and non-nutritive sweeteners",
      ],
      correct: "D"
    },
    {
      id: 71012,
      question: "Which are examples of nutritive sweeteners?",
      options: [
        "Sugar alcohols, xylitol and lycasin",
        "Saccharin and aspartame",
        "Sucrose and glucose",
        "Fructose and maltose",
      ],
      correct: "A"
    },
    {
      id: 71013,
      question: "Which are examples of non-nutritive sweeteners?",
      options: [
        "Xylitol and sorbitol",
        "Saccharin and aspartame",
        "Sugar alcohols and lycasin",
        "Glucose and fructose",
      ],
      correct: "B"
    },
    {
      id: 71014,
      question: "What is the best source for fluoride?",
      options: [
        "Toothpaste",
        "Tablets",
        "Water",
        "Gels",
      ],
      correct: "C"
    },
    {
      id: 71015,
      question: "What does fluoride do to tooth structure?",
      options: [
        "Makes it more soluble",
        "Weakens the structure",
        "Has no effect",
        "Makes it less soluble to acid attack",
      ],
      correct: "D"
    },
    {
      id: 71016,
      question: "What other effects does fluoride have?",
      options: [
        "Enhances remineralization and modulates plaque metabolism",
        "Only prevents cavities",
        "Only whitens teeth",
        "Only freshens breath",
      ],
      correct: "A"
    },
    {
      id: 71017,
      question: "What do pits and fissures sealants do?",
      options: [
        "Remove plaque",
        "Protect susceptible areas of the tooth",
        "Whiten teeth",
        "Strengthen enamel",
      ],
      correct: "B"
    },
    {
      id: 71018,
      question: "How can cariogenic flora be reduced?",
      options: [
        "Only by brushing",
        "Only by diet change",
        "Professional cleansing, antimicrobial agents, immunization and replacement therapy",
        "Only by fluoride",
      ],
      correct: "C"
    },
    {
      id: 71019,
      question: "What concentration of chlorhexidine is effective against gram-negative and gram-positive bacteria?",
      options: [
        "0.1%",
        "0.5%",
        "1.0%",
        "0.2%",
      ],
      correct: "D"
    },
    {
      id: 71020,
      question: "What is replacement therapy (probiotic therapy)?",
      options: [
        "Using genetically engineered mutans streptococci with less pathogenicity",
        "Using antibiotics",
        "Using antifungals",
        "Using antivirals",
      ],
      correct: "A"
    },
    {
      id: 71021,
      question: "What do active and passive immunization use respectively?",
      options: [
        "Antibiotics and antivirals",
        "Vaccines and antibodies",
        "Fluoride and chlorhexidine",
        "Sealants and varnishes",
      ],
      correct: "B"
    },
    {
      id: 71022,
      question: "Where are Veillonella spp. present?",
      options: [
        "Only in saliva",
        "Only on tongue",
        "In subgingival and supragingival plaques",
        "Only in gingival crevice",
      ],
      correct: "C"
    },
    {
      id: 71023,
      question: "What is the oral flora of a one-year-old baby?",
      options: [
        "Only streptococci",
        "Only lactobacilli",
        "Only Candida",
        "Streptococci, staphylococci, neisseriae, Lactobacillus, Veillonella, Actinomyces, Prevotella and Fusobacterium",
      ],
      correct: "D"
    },
    {
      id: 71024,
      question: "What is an iatrogenic factor affecting oral microflora?",
      options: [
        "Scaling",
        "Diet",
        "Smoking",
        "Aging",
      ],
      correct: "A"
    },
    {
      id: 71025,
      question: "What do low pH conditions favor the growth of?",
      options: [
        "All bacteria equally",
        "Acidophilic bacteria",
        "Alkalophilic bacteria",
        "Neutrophilic bacteria",
      ],
      correct: "B"
    },
    {
      id: 71026,
      question: "How is the cheek mucosa compared to the tongue in terms of microbial diversity?",
      options: [
        "More diverse than the tongue",
        "Equally diverse",
        "Not as diverse as the tongue",
        "Has no microbes",
      ],
      correct: "C"
    },
    {
      id: 71027,
      question: "What forms the exopolysaccharide matrix in biofilm?",
      options: [
        "Host proteins only",
        "Calcium and phosphate",
        "Water and minerals",
        "Microbial polysaccharide with salivary glycoproteins",
      ],
      correct: "D"
    },
    {
      id: 71028,
      question: "Which colonize biofilm after pioneer microorganisms?",
      options: [
        "Gram-negative cocci and bacilli, fusobacteria and spirochetes",
        "More gram-positive cocci",
        "More gram-positive bacilli",
        "Yeasts only",
      ],
      correct: "A"
    },
    {
      id: 71029,
      question: "What happens to bacteria when they detach from climax community?",
      options: [
        "They die",
        "They enter saliva",
        "They form calculus",
        "They become inactive",
      ],
      correct: "B"
    },
    {
      id: 71030,
      question: "What is the characteristic of chronic infections caused by oral microflora?",
      options: [
        "Acute onset",
        "Viral etiology",
        "Demineralization of tooth tissues by acidic products",
        "Fungal etiology",
      ],
      correct: "C"
    },
    {
      id: 71031,
      question: "What are the host factors in dental caries predisposition?",
      options: [
        "Only saliva",
        "Only enamel",
        "Only dentine",
        "Tooth structure and saliva",
      ],
      correct: "D"
    },
    {
      id: 71032,
      question: "When are mutans streptococci especially present in enamel caries?",
      options: [
        "Before caries formation",
        "After caries formation",
        "During remineralization",
        "Never",
      ],
      correct: "A"
    },
    {
      id: 71033,
      question: "What ability do mutans streptococci have regarding pH?",
      options: [
        "They cannot survive at low pH",
        "They can maintain at low pH",
        "They raise the pH",
        "They have no effect on pH",
      ],
      correct: "B"
    },
    {
      id: 71034,
      question: "What does EPM stand for in biofilm resistance?",
      options: [
        "External protein membrane",
        "External polysaccharide membrane",
        "Extracellular polymeric matrix",
        "Extracellular protein matrix",
      ],
      correct: "C"
    },
    {
      id: 71035,
      question: "What makes deeper-layer bacteria in biofilm resistant to antimicrobials?",
      options: [
        "Their size",
        "Their shape",
        "Their color",
        "Poor availability to antimicrobial agents",
      ],
      correct: "D"
    },
    {
      id: 71036,
      question: "What gene expression in sessile organisms results in?",
      options: [
        "More resistance or virulence",
        "Decreased resistance",
        "Decreased virulence",
        "No change",
      ],
      correct: "A"
    },
    {
      id: 71037,
      question: "From where are calcium and phosphate crystals in calculus derived?",
      options: [
        "From food",
        "From saliva",
        "From blood",
        "From gingival fluid",
      ],
      correct: "B"
    },
    {
      id: 71038,
      question: "What is the purpose of bacteriocins in microbial factors?",
      options: [
        "To help bacteria grow",
        "To produce nutrients",
        "To kill the same bacterial species",
        "To form biofilm",
      ],
      correct: "C"
    },
  ],
  "11. Microbiology of Periodontal Diseases and Dentoalveolar Infections": [
    {
      id: 71000,
      question: "Which of the following are the two prominent types of periodontal diseases?",
      options: [
        "Caries and periodontitis",
        "Periodontitis and gingivitis",
        "Gingivitis and pulpitis",
        "Periodontitis and osteomyelitis",
      ],
      correct: "B"
    },
    {
      id: 71001,
      question: "Periodontitis is related to which anatomical structure?",
      options: [
        "Gingival crevice",
        "Dental pulp",
        "Periodontal pockets",
        "Enamel surface",
      ],
      correct: "C"
    },
    {
      id: 71002,
      question: "Which bacteria are among the most predominant in periodontal pockets?",
      options: [
        "Streptococcus mutans",
        "Lactobacillus",
        "E. coli",
        "P. gingivalis",
      ],
      correct: "D"
    },
    {
      id: 71003,
      question: "Peptostreptococci are predominantly found in which location?",
      options: [
        "Gingival crevice",
        "Periodontal pockets",
        "Dental pulp",
        "Alveolar bone",
      ],
      correct: "A"
    },
    {
      id: 71004,
      question: "What are the first colonizers of the cemental surface of the tooth?",
      options: [
        "Prevotella and Porphyromonas spp.",
        "Mutans streptococci and Actinomyces spp.",
        "Fusobacterium and spirochetes",
        "Capnocytophaga and Eikenella",
      ],
      correct: "B"
    },
    {
      id: 71005,
      question: "Which bacteria are the second colonizers of the cemental surface?",
      options: [
        "Mutans streptococci",
        "Actinomyces spp.",
        "Prevotella and Porphyromonas spp.",
        "Lactobacillus",
      ],
      correct: "C"
    },
    {
      id: 71006,
      question: "Which of the following is NOT an etiological factor of periodontal diseases?",
      options: [
        "Microflora",
        "Host tissues damage",
        "Host immunity",
        "Dental trauma",
      ],
      correct: "D"
    },
    {
      id: 71007,
      question: "Which immunoglobulins are especially involved in host immunity against periodontal diseases?",
      options: [
        "IgM, IgA and IgG",
        "IgD and IgE",
        "Only IgE",
        "Only IgM",
      ],
      correct: "A"
    },
    {
      id: 71008,
      question: "What type of microflora is most significant in a healthy gingival sulcus?",
      options: [
        "Gram-positive and facultative anaerobes",
        "Gram-negative and obligate anaerobes",
        "Only spirochetes",
        "Only motile bacilli",
      ],
      correct: "A"
    },
    {
      id: 71009,
      question: "As periodontal disease severity increases, what bacterial change occurs?",
      options: [
        "More gram-positive and aerobic bacteria",
        "More anaerobes and gram-negative bacteria",
        "Fewer bacteria overall",
        "Only fungal growth",
      ],
      correct: "B"
    },
    {
      id: 71010,
      question: "What are microbial virulence determinants that cause periodontal diseases?",
      options: [
        "Only cell wall components",
        "Adhesion molecules only",
        "Both enzymes/toxins and adhesion molecules",
        "Only enzymes",
      ],
      correct: "C"
    },
    {
      id: 71011,
      question: "How is tissue destruction characterized in periodontal diseases?",
      options: [
        "Rapid and continuous",
        "Immediate and complete",
        "Only affects enamel",
        "Slow, sporadic and episodic",
      ],
      correct: "D"
    },
    {
      id: 71012,
      question: "Regarding P. gingivalis strains, which statement is TRUE?",
      options: [
        "Not all strains are virulent",
        "All strains are equally virulent",
        "No strains are virulent",
        "Virulence cannot be transferred between strains",
      ],
      correct: "A"
    },
    {
      id: 71013,
      question: "Which viruses are most relevant to periodontal diseases?",
      options: [
        "Influenza and rhinovirus",
        "HIV and herpesviruses",
        "Hepatitis and rotavirus",
        "Papillomavirus and adenovirus",
      ],
      correct: "B"
    },
    {
      id: 71014,
      question: "The initial lesion of chronic marginal gingivitis occurs within how many days of plaque accumulation?",
      options: [
        "2 days",
        "10 days",
        "14 days",
        "4 days",
      ],
      correct: "D"
    },
    {
      id: 71015,
      question: "What characterizes the initial lesion of chronic marginal gingivitis?",
      options: [
        "Acute vasculitis with overproduction of crevicular fluid and PMNs",
        "Chronic inflammation",
        "Bone loss",
        "Tooth mobility",
      ],
      correct: "A"
    },
    {
      id: 71016,
      question: "Which bacteria are predominant in the initial lesion of chronic marginal gingivitis?",
      options: [
        "Porphyromonas",
        "Streptococci",
        "Prevotella",
        "Fusobacteria",
      ],
      correct: "B"
    },
    {
      id: 71017,
      question: "The early lesion of chronic marginal gingivitis occurs within how many days?",
      options: [
        "4 days",
        "14 days",
        "7 days",
        "21 days",
      ],
      correct: "C"
    },
    {
      id: 71018,
      question: "Which bacteria are predominant in the early lesion of chronic marginal gingivitis?",
      options: [
        "Streptococci",
        "Spirochetes",
        "Fusobacteria",
        "Actinomyces and Capnocytophaga spp.",
      ],
      correct: "D"
    },
    {
      id: 71019,
      question: "What immune cells increase during the early lesion stage?",
      options: [
        "Lymphocytes, PMNs and macrophages",
        "Only PMNs",
        "Only B lymphocytes",
        "Only red blood cells",
      ],
      correct: "A"
    },
    {
      id: 71020,
      question: "Which bacteria are predominant in the established lesion?",
      options: [
        "Streptococci",
        "Actinomyces",
        "Porphyromonas and Prevotella spp.",
        "Capnocytophaga",
      ],
      correct: "C"
    },
    {
      id: 71021,
      question: "Which immune cells increase during the established lesion stage?",
      options: [
        "Only T lymphocytes",
        "Only macrophages",
        "Only eosinophils",
        "PMNs and B lymphocytes",
      ],
      correct: "D"
    },
    {
      id: 71022,
      question: "Which of the following is NOT a clinical feature of chronic periodontitis?",
      options: [
        "Enamel hypoplasia",
        "Gingival inflammation and recession",
        "Tooth mobility",
        "Alveolar bone loss",
      ],
      correct: "A"
    },
    {
      id: 71023,
      question: "Chronic periodontitis involves separation of which structure from the tooth surface?",
      options: [
        "Enamel",
        "Dentin",
        "Junctional epithelium",
        "Cementum",
      ],
      correct: "C"
    },
    {
      id: 71024,
      question: "What happens to the junctional epithelium in chronic periodontitis?",
      options: [
        "It becomes thicker",
        "It calcifies",
        "It disappears completely",
        "It proliferates",
      ],
      correct: "D"
    },
    {
      id: 71025,
      question: "Where are gram-positive bacteria most predominant in chronic periodontitis?",
      options: [
        "Near the tooth surface",
        "Near the gingival crevice",
        "In the bone",
        "In the blood vessels",
      ],
      correct: "A"
    },
    {
      id: 71026,
      question: "Where are gram-negative bacteria most common in chronic periodontitis?",
      options: [
        "Near the tooth surface",
        "Close to the gingival crevice",
        "In the pulp",
        "In the enamel",
      ],
      correct: "B"
    },
    {
      id: 71027,
      question: "Which of the following bacteria is NOT typically isolated from periodontal pockets?",
      options: [
        "P. gingivalis",
        "F. nucleatum",
        "S. mutans",
        "A. actinomycetemcomitans",
      ],
      correct: "C"
    },
    {
      id: 71028,
      question: "In localized aggressive periodontitis, which teeth are mostly affected?",
      options: [
        "Incisors and molars",
        "Premolars and canines",
        "Only wisdom teeth",
        "Primary teeth only",
      ],
      correct: "A"
    },
    {
      id: 71029,
      question: "In generalized aggressive periodontitis, what is seriously affected?",
      options: [
        "Only gingiva",
        "Alveolar bone with most teeth involved",
        "Only incisors",
        "Tooth enamel",
      ],
      correct: "B"
    },
    {
      id: 71030,
      question: "Which bacteria are most significant in aggressive periodontitis?",
      options: [
        "S. mutans and Lactobacillus",
        "E. coli and Klebsiella",
        "Only spirochetes",
        "A. actinomycetemcomitans, P. gingivalis and Capnocytophaga",
      ],
      correct: "D"
    },
    {
      id: 71031,
      question: "What is the severe form of ANUG called?",
      options: [
        "Ludwig\'s angina",
        "Pericoronitis",
        "Noma (cancrum oris)",
        "Osteomyelitis",
      ],
      correct: "C"
    },
    {
      id: 71032,
      question: "Which of the following is NOT a predisposing factor for ANUG?",
      options: [
        "Excellent oral hygiene",
        "HIV",
        "Herpetic infections",
        "Smoking and malnutrition",
      ],
      correct: "A"
    },
    {
      id: 71033,
      question: "Which bacteria are also found in ANUG besides fusobacteria and spirochetes?",
      options: [
        "E. coli and Klebsiella",
        "Only S. aureus",
        "Only mycobacteria",
        "Prevotella, Veillonella and streptococci",
      ],
      correct: "D"
    },
    {
      id: 71034,
      question: "In dentoalveolar abscess formation, how do bacteria spread to the pulp?",
      options: [
        "Via dentinal tubules",
        "Through enamel",
        "Through cementum",
        "Through periodontal ligament",
      ],
      correct: "A"
    },
    {
      id: 71035,
      question: "What is the first step in dentoalveolar abscess formation?",
      options: [
        "Pulp necrosis",
        "A carious lesion spreads into dentine",
        "Bone destruction",
        "Gingival recession",
      ],
      correct: "B"
    },
    {
      id: 71036,
      question: "Which of the following is a clinical feature of dentoalveolar abscesses?",
      options: [
        "Tooth whitening",
        "Enamel strengthening",
        "Increased bone density",
        "Trismus",
      ],
      correct: "D"
    },
    {
      id: 71037,
      question: "Which of the following is NOT a clinical feature of dentoalveolar abscesses?",
      options: [
        "Swelling",
        "Improved tooth mobility",
        "Redness",
        "Malaise",
      ],
      correct: "B"
    },
    {
      id: 71038,
      question: "How many different species are typically found in dentoalveolar abscesses?",
      options: [
        "One species",
        "Only anaerobes",
        "Only aerobes",
        "At least three to four different species",
      ],
      correct: "D"
    },
    {
      id: 71039,
      question: "Which type of bacteria is more prevalent in dentoalveolar abscesses?",
      options: [
        "Obligate anaerobic bacteria",
        "Facultative anaerobes",
        "Strict aerobes",
        "Only gram-positive bacteria",
      ],
      correct: "A"
    },
    {
      id: 71040,
      question: "Which antibiotics are first-line for dentoalveolar infections?",
      options: [
        "Aminoglycosides",
        "Quinolones",
        "Tetracyclines",
        "Penicillin V and amoxicillin",
      ],
      correct: "D"
    },
    {
      id: 71041,
      question: "For patients allergic to penicillin, which antibiotics are recommended for dentoalveolar infections?",
      options: [
        "Metronidazole and erythromycin",
        "Aminoglycosides",
        "Quinolones",
        "Cephalosporins",
      ],
      correct: "A"
    },
    {
      id: 71042,
      question: "Ludwig\'s angina is a cellulitis of which spaces?",
      options: [
        "Maxillary sinus",
        "Sublingual and submandibular regions",
        "Parotid region",
        "Retropharyngeal space",
      ],
      correct: "B"
    },
    {
      id: 71043,
      question: "Which of the following is NOT an etiology of Ludwig\'s angina?",
      options: [
        "Dental infections",
        "Sialadenitis",
        "Tooth whitening",
        "Oral laceration",
      ],
      correct: "C"
    },
    {
      id: 71044,
      question: "Sialadenitis as an etiology of Ludwig\'s angina especially occurs in which space?",
      options: [
        "Sublingual space",
        "Parotid space",
        "Buccal space",
        "Submandibular space",
      ],
      correct: "D"
    },
    {
      id: 71045,
      question: "Which of the following is a common symptom of Ludwig\'s angina?",
      options: [
        "Swelling at the front of the neck",
        "Improved breathing",
        "Weight gain",
        "Enhanced speech",
      ],
      correct: "A"
    },
    {
      id: 71046,
      question: "Which bacteria are most predominant in Ludwig\'s angina?",
      options: [
        "Only S. aureus",
        "Only E. coli",
        "Only Lactobacillus",
        "Porphyromonas, Prevotella, Fusobacterium, spirochetes and anaerobic streptococci",
      ],
      correct: "D"
    },
    {
      id: 71047,
      question: "What antibiotics are especially effective for Ludwig\'s angina?",
      options: [
        "Aminoglycosides",
        "Penicillin and metronidazole",
        "Quinolones",
        "Tetracyclines",
      ],
      correct: "B"
    },
    {
      id: 71048,
      question: "A periodontal abscess is a localized collection of pus in which area?",
      options: [
        "Dental pulp",
        "Enamel",
        "Gingival sulcus or other periodontal areas",
        "Dentin",
      ],
      correct: "C"
    },
    {
      id: 71049,
      question: "Which of the following is NOT a symptom of periodontal abscess?",
      options: [
        "Swelling",
        "Improved gingival health",
        "Redness",
        "Accumulation of pus",
      ],
      correct: "B"
    },
    {
      id: 71050,
      question: "Which bacteria are also found in periodontal abscess besides anaerobic gram-negative bacilli?",
      options: [
        "Anaerobic streptococci, Spirochetes, Capnocytophaga and Actinomyces",
        "Only Lactobacillus",
        "Only E. coli",
        "Only S. aureus",
      ],
      correct: "A"
    },
    {
      id: 71051,
      question: "Which antibiotics are recommended for periodontal abscess treatment?",
      options: [
        "Aminoglycosides",
        "Antifungals",
        "Penicillin, erythromycin and metronidazole",
        "Quinolones",
      ],
      correct: "C"
    },
    {
      id: 71052,
      question: "Suppurative osteomyelitis of the jaws is inflammation of which structure?",
      options: [
        "Enamel",
        "Dental pulp",
        "Gingiva",
        "Medullary cavity of maxilla and/or mandible",
      ],
      correct: "D"
    },
    {
      id: 71053,
      question: "Which of the following is NOT an etiology of suppurative osteomyelitis of the jaws?",
      options: [
        "Excellent bone health",
        "Radiation",
        "Osteoporosis",
        "Paget\'s disease",
      ],
      correct: "A"
    },
    {
      id: 71054,
      question: "Which specific bacteria can cause suppurative osteomyelitis besides endogenous bacteria?",
      options: [
        "Only E. coli",
        "Only Candida",
        "T. pallidum and M. tuberculosis",
        "Only rhinovirus",
      ],
      correct: "C"
    },
    {
      id: 71055,
      question: "Which aerobic bacteria is also present in suppurative osteomyelitis of the jaws?",
      options: [
        "E. coli",
        "Klebsiella",
        "S. aureus",
        "Pseudomonas",
      ],
      correct: "C"
    },
    {
      id: 71056,
      question: "For patients allergic to penicillin with suppurative osteomyelitis, which antibiotics are recommended?",
      options: [
        "Erythromycin and clindamycin",
        "Aminoglycosides",
        "Quinolones",
        "Tetracyclines",
      ],
      correct: "A"
    },
    {
      id: 71057,
      question: "PMNs are important immune cells in which stage of chronic marginal gingivitis?",
      options: [
        "Only initial lesion",
        "Only established lesion",
        "All stages (initial, early, and established)",
        "None of the stages",
      ],
      correct: "C"
    },
    {
      id: 71058,
      question: "In the progression from health to gingivitis, what ecological shift occurs?",
      options: [
        "From gram-negative to gram-positive",
        "No change",
        "From bacteria to viruses",
        "From gram-positive facultative anaerobes to gram-negative obligate anaerobes",
      ],
      correct: "D"
    },
    {
      id: 71059,
      question: "Tannerella spp. is found in which periodontal condition?",
      options: [
        "Chronic periodontitis",
        "Only healthy gingiva",
        "Only ANUG",
        "Only gingivitis",
      ],
      correct: "A"
    },
    {
      id: 71060,
      question: "Which structure is part of the periodontium?",
      options: [
        "Enamel",
        "Cementum",
        "Dentin tubules",
        "Pulp chamber",
      ],
      correct: "B"
    },
    {
      id: 71061,
      question: "The periapical granuloma forms at which location?",
      options: [
        "Root apex",
        "Crown of tooth",
        "Enamel surface",
        "Gingival margin",
      ],
      correct: "A"
    },
    {
      id: 71062,
      question: "Which cells increase during gingival inflammation in the early lesion?",
      options: [
        "Only red blood cells",
        "Only platelets",
        "Lymphocytes",
        "Only eosinophils",
      ],
      correct: "C"
    },
    {
      id: 71063,
      question: "Noma especially affects which population?",
      options: [
        "Adults",
        "Middle-aged individuals",
        "Elderly",
        "Children",
      ],
      correct: "D"
    },
    {
      id: 71064,
      question: "What characterizes the pseudomembrane in ANUG?",
      options: [
        "Contains RBCs, WBCs, fibrins and microbes",
        "Only calcified tissue",
        "Pure fibrin only",
        "Only enamel debris",
      ],
      correct: "A"
    },
  ],
};
